export const dict = {
  // Движковые ключи (ADR-041) en не дублирует — деградация на content;
  // здесь только новые, добавленные вместе с ru для паритета.
  'session.steps_limit':
    'The step limit ({limit}) is exhausted: the agent stopped at the step limit without a textual report',
  'common.loading': 'Loading...',
  'common.language.english': 'English',
  'common.language.russian': 'Russian',
  'common.cancel': 'Cancel',
  'common.ok': 'OK',
  'common.confirm': 'Confirm',
  'common.empty': 'Empty',
  'common.showMore': '{count} more',
  'common.showFewer': 'Show fewer',
  'common.save': 'Save',
  'common.saving': 'Saving...',
  'common.saved': 'Saved',
  'common.create': 'Create',
  'common.delete': 'Delete',
  'common.close': 'Close',
  'common.edit': 'Edit',
  'common.copy': 'Copy',
  'common.optional': 'optional',
  'common.refresh': 'Refresh',
  'common.hide': 'Hide',
  'common.details': 'Details',
  'common.unlock': 'Unlock',
  'common.test': 'Test',
  'common.testing': 'Testing...',
  'common.add': 'Add',
  'common.icon': 'Icon',
  'common.search': 'Search...',
  'common.reset': 'Reset',
  'common.default': 'Default',
  'common.system': 'System',
  'common.modified': 'modified',
  'common.noCapabilities': 'no capabilities',
  'common.name': 'Name',
  'common.nameRequired': 'Name is required',
  'common.key': 'Key',
  'common.value': 'Value',
  'common.saveError': 'Save error',
  'panel.saved': 'Settings saved',
  'panel.saveError': 'Failed to save settings',
  'common.error': 'Error',
  'common.url': 'URL',
  'common.apiKey': 'API Key',
  'common.type': 'Type',
  'common.provider': 'Provider',
  'common.model': 'Model',
  'common.mode': 'Mode',
  'common.temperature': 'Temperature',
  'common.description': 'Description',
  'common.capabilities': 'Capabilities',
  'common.color': 'Color',
  'common.selectProvider': 'Select provider',
  'common.selectModel': 'Select model',
  'common.username': 'Username',
  'common.email': 'Email',
  'common.roles': 'Roles',
  'common.active': 'Active',
  'common.inactive': 'Inactive',
  'common.notes': 'Notes',
  'common.displayName': 'Display name',
  'common.contextFile': 'Context file',
  'common.fileName': 'File name',
  'common.content': 'Content',
  'common.context': 'Context',
  'common.id': 'ID',
  'common.project': 'Project',
  'common.created': 'Created',
  'common.updated': 'Updated',
  'common.pending': 'Pending',
  'common.blocked': 'Blocked',
  'common.version': 'Version',
  'common.users': 'Users',
  'common.off': 'off',
  'common.on': 'on',
  'common.enabled': 'Enabled',
  'common.disabled': 'Disabled',
  'common.notSelected': '(not selected)',
  'common.inDevelopment': 'In development',
  'common.searchIcon': 'Search icon...',

  // App
  'app.leftPanel': 'Left panel',
  'app.rightPanel': 'Right panel',
  'app.title': 'Synth',
  'app.subtitle': 'Agentic AI Platform for Dev Teams',

  // Header
  'header.showLeftPanel': 'Show left panel',
  'header.hideLeftPanel': 'Hide left panel',
  'header.showRightPanel': 'Show right panel',
  'header.hideRightPanel': 'Hide right panel',
  'header.settings': 'Settings',
  'header.logs': 'Logs & Audit',
  'header.chatView.title': 'Chat view & density',

  // Settings modal
  'settings.title': 'Settings',
  'settings.kit.defaultsBadge': 'Default',
  'settings.kit.unsavedChanges': 'You have unsaved changes',
  'settings.search.placeholder': 'Search settings',
  'settings.search.empty': 'Nothing found',
  'settings.search.categoryHint': 'Section',
  'settings.groups.adminOverview': 'Overview',
  'settings.groups.adminAi': 'AI & models',
  'settings.groups.adminIntegrations': 'Integrations',
  'settings.groups.adminOps': 'Operations',
  'settings.advanced.toggle': 'Advanced',
  'settings.advanced.show': 'Show advanced settings',
  'settings.advanced.hide': 'Hide advanced settings',
  'settings.category.profile': 'Profile',
  'settings.category.appearance': 'Appearance',
  'settings.category.chat': 'Chat',
  'settings.category.providers': 'Providers',
  'settings.category.models': 'Models',
  'settings.category.agents': 'Agents',
  'settings.category.mcp': 'MCP Servers',
  'settings.category.mcpAdmin': 'MCP Servers',
  'settings.category.builtinTools': 'Built-in tools',
  'settings.category.skills': 'Skills',
  'settings.category.skillsAdmin': 'Skills',
  'settings.category.commands': 'Commands',
  'settings.category.events': 'Events',
  'settings.category.credentials': 'Accesses',
  'settings.category.eventsConfig': 'Event settings',
  'settings.category.authority': 'Authority',
  'settings.category.decision': 'Decision models',
  'settings.category.serviceKeys': 'Service keys',
  'settings.category.webhooks': 'Webhooks',
  'settings.category.maintenance': 'Maintenance',
  'settings.category.metrics': 'Metrics',
  'settings.category.memory': 'Memory',
  'settings.category.contextWindow': 'Context window',
  'settings.category.contextManagement': 'Context management',
  'settings.category.agentsLimits': 'Subagent limits',
  'settings.agentsLimits.description': 'Subagent prompt budget (tokens). 0 means no limit. Subagents have no automatic context compaction, so with 0 a long run may hit the model window.',
  'settings.agentsLimits.field.title': 'Prompt budget',
  'settings.agentsLimits.field.description': 'Safeguard for the subagent input prompt size. Applies to subsequent runs without restart.',
  'settings.agentsLimits.field.label': 'Subagent prompt budget (tokens)',
  'settings.agentsLimits.field.hint': '0 means no limit. The estimate uses the calibrated model chars-per-token.',
  'settings.agentsLimits.field.invalid': 'Enter an integer ≥ 0',
  'settings.agentsLimits.field.defaults': 'Default: {value}',
  'settings.agentsLimits.source.env': 'from env',
  'settings.agentsLimits.source.runtime': 'runtime',
  'settings.agentsLimits.source.config': 'from config',
  'settings.agentsLimits.source.default': 'default',
  'settings.agentsLimits.envBanner': 'Set via an environment variable — cannot be changed from the UI.',
  'settings.agentsLimits.saved': 'Subagent budget saved',
  'settings.agentsLimits.saveError': 'Failed to save: {error}',
  'settings.agentsLimits.reset': 'Reset',
  'settings.agentsLimits.resetDone': 'Budget reset to default',
  'settings.agentsLimits.resetError': 'Failed to reset: {error}',
  'settings.agentsLimits.conflict': 'The value is set via env — cannot be changed from the UI.',
  'settings.agentsLimits.loadError': 'Failed to load the setting',
  'settings.agentsLimits.retry': 'Retry',
  'settings.help.agentsLimits.section.agents-limits': 'Safeguard for the subagent prompt size. 0 disables it; subagents have no auto-compaction, so tool-heavy agents should set a limit.',
  'settings.category.notifications': 'Notifications',
  'settings.category.routing': 'Routing',

  'settings.category.security': 'Security',
  'settings.category.network': 'Network',
  'settings.category.addons': 'Addons',
  'settings.category.plugins': 'Plugins',
  'settings.category.attachments': 'Multimodal input',
  // ADR-115: админ-раздел «Мультимодальный ввод» — runtime-настройки вложений.
  'settings.attachments.title': 'Multimodal input',
  'settings.attachments.description': 'Attachments to messages: accepted modalities, size and count limits, retention of orphaned files and the MIME allowlist. Changes apply immediately.',
  'settings.attachments.status.title': 'State',
  'settings.attachments.status.description': 'Effective settings source and the values the running process uses.',
  'settings.attachments.status.source': 'Source',
  'settings.attachments.status.running': 'Attachments in the running process',
  'settings.attachments.status.runningModalities': 'Running modalities',
  'settings.attachments.status.overridden': 'overridden',
  'settings.attachments.source.env': 'env',
  'settings.attachments.source.runtime': 'runtime (UI)',
  'settings.attachments.source.config': 'config.yaml',
  'settings.attachments.source.default': 'default',
  'settings.attachments.state.enabled': 'enabled',
  'settings.attachments.state.disabled': 'disabled',
  'settings.attachments.restartRequired': 'Changes take effect after an instance restart.',
  'settings.attachments.envLocked': 'The value is set via env — it cannot be changed in the UI and is not sent when saving.',
  'settings.attachments.saved': 'Attachment settings saved',
  'settings.attachments.saveError': 'Failed to save settings: {error}',
  'settings.attachments.loadError': 'Failed to load attachment settings',
  'settings.attachments.unitMiB': 'MiB',
  'settings.attachments.unitDays': 'days',
  'settings.attachments.unitPx': 'px',
  'settings.attachments.unitKbps': 'kbps',
  'settings.attachments.unitHz': 'Hz',
  'settings.attachments.general.title': 'Attachments',
  'settings.attachments.general.description': 'Master switch: when disabled, files are not accepted in messages at all.',
  'settings.attachments.enabled.label': 'Attachments enabled',
  'settings.attachments.enabled.hint': 'Accept files in chat messages and pass them to the model.',
  'settings.attachments.modalities.title': 'Supported modalities',
  'settings.attachments.modalities.description': 'Which file kinds the instance accepts; disabled kinds are rejected on upload.',
  'settings.attachments.modalities.image': 'Images',
  'settings.attachments.modalities.imageHint': 'PNG, JPEG, WebP, GIF — passed to the model as images.',
  'settings.attachments.modalities.pdf': 'PDF',
  'settings.attachments.modalities.pdfHint': 'PDF documents; pages are passed to vision-capable models.',
  'settings.attachments.modalities.audio': 'Audio',
  'settings.attachments.modalities.audioHint': 'Audio files; require a model with audio support or preprocessing.',
  'settings.attachments.modalities.video': 'Video',
  'settings.attachments.modalities.videoHint': 'Video files; passed only to models that declare video support.',
  'settings.attachments.modalityModels.title': 'Models by modality',
  'settings.attachments.modalityModels.description': 'Which model handles each attachment type when the session model does not accept it.',
  'settings.attachments.modalityModels.image': 'Images',
  'settings.attachments.modalityModels.pdf': 'PDF',
  'settings.attachments.modalityModels.audio': 'Audio',
  'settings.attachments.modalityModels.video': 'Video',
  'settings.attachments.modalityModels.none': 'Not set (drop)',
  'settings.attachments.modalityModels.hint': 'If the current model does not accept the format, the selected model processes the attachment and only text reaches the dialogue (the session model does not change).',
  'settings.attachments.modalityModels.incompatible': 'Model {model} does not accept this modality',
  'settings.attachments.compression.title': 'Compression before sending',
  'settings.attachments.compression.description': 'How attachments are prepared for the model call.',
  'settings.attachments.compression.enabled': 'Compress attachments before sending',
  'settings.attachments.compression.enabledHint': 'The original stays in storage; compression applies only when sending to the model; PNG with transparency stays PNG.',
  'settings.attachments.compression.image.title': 'Images',
  'settings.attachments.compression.image.enabled': 'Compress images',
  'settings.attachments.compression.image.maxSide': 'Maximum side',
  'settings.attachments.compression.image.quality': 'Quality',
  'settings.attachments.compression.image.minSize': 'Do not compress below',
  'settings.attachments.compression.video.title': 'Video',
  'settings.attachments.compression.video.enabled': 'Compress video',
  'settings.attachments.compression.video.maxHeight': 'Maximum height',
  'settings.attachments.compression.video.bitrate': 'Video bitrate',
  'settings.attachments.compression.video.audioBitrate': 'Audio bitrate',
  'settings.attachments.compression.video.minSize': 'Do not compress below',
  'settings.attachments.compression.audio.title': 'Audio',
  'settings.attachments.compression.audio.enabled': 'Compress audio',
  'settings.attachments.compression.audio.bitrate': 'Bitrate',
  'settings.attachments.compression.audio.channels': 'Channels',
  'settings.attachments.compression.audio.sampleRate': 'Sample rate',
  'settings.attachments.compression.audio.minSize': 'Do not compress below',
  'settings.attachments.compression.imageSideInvalid': 'Enter an integer from 64 to 8192',
  'settings.attachments.compression.imageQualityInvalid': 'Enter an integer from 1 to 100',
  'settings.attachments.compression.videoHeightInvalid': 'Enter an integer from 144 to 4320',
  'settings.attachments.compression.videoBitrateInvalid': 'Enter an integer from 100 to 50000',
  'settings.attachments.compression.videoAudioBitrateInvalid': 'Enter an integer from 16 to 512',
  'settings.attachments.compression.audioBitrateInvalid': 'Enter an integer from 8 to 512',
  'settings.attachments.compression.audioChannelsInvalid': 'Enter 1 or 2 channels',
  'settings.attachments.compression.audioSampleRateInvalid': 'Enter an integer from 8000 to 48000',
  'settings.attachments.compression.minSizeInvalid': 'Enter a non-negative number of MiB',
  'settings.attachments.thumbnail.title': 'Thumbnails',
  'settings.attachments.thumbnail.description': 'Small attachment previews for the interface.',
  'settings.attachments.thumbnail.enabled': 'Generate thumbnails',
  'settings.attachments.thumbnail.enabledHint': 'The thumbnail is stored separately from the original and does not affect its bytes.',
  'settings.attachments.thumbnail.maxWidth': 'Maximum width',
  'settings.attachments.thumbnail.widthInvalid': 'Enter an integer from 64 to 1024',
  'settings.attachments.limits.title': 'Limits',
  'settings.attachments.limits.description': 'Size and count limits; sizes are stored in bytes and edited in MiB (1 MiB = 1024 × 1024 bytes).',
  'settings.attachments.limits.maxFile': 'Maximum per file',
  'settings.attachments.limits.maxFileHint': 'Limit for a single attachment.',
  'settings.attachments.limits.maxFiles': 'Files per message',
  'settings.attachments.limits.maxFilesHint': 'How many files one message may carry.',
  'settings.attachments.limits.maxSession': 'Limit per session',
  'settings.attachments.limits.maxSessionHint': 'Total volume of attachments in one session.',
  'settings.attachments.limits.chunk': 'Upload chunk size',
  'settings.attachments.limits.chunkHint': 'Part size for streaming upload; at least 1 KiB.',
  'settings.attachments.limits.fileInvalid': 'Enter a positive number of MiB',
  'settings.attachments.limits.filesInvalid': 'Enter an integer ≥ 1',
  'settings.attachments.limits.sessionInvalid': 'Enter a positive number of MiB',
  'settings.attachments.limits.chunkInvalid': 'Enter a size of at least 1 KiB',
  'settings.attachments.storage.title': 'Retention',
  'settings.attachments.storage.description': 'Cleanup of files that no message references any more.',
  'settings.attachments.storage.gcDays': 'Orphaned attachments retention',
  'settings.attachments.storage.gcDaysHint': '0 — never delete.',
  'settings.attachments.storage.invalid': 'Enter a non-negative integer',
  'settings.attachments.behavior.title': 'Behaviour',
  'settings.attachments.behavior.description': 'What happens to files the current model cannot consume.',
  'settings.attachments.behavior.workspaceFallback': 'Keep incompatible attachments in the workspace',
  'settings.attachments.behavior.workspaceFallbackHint': 'The file is saved to the project workspace and the model receives only the path to it, so it can read the file with tools.',
  'settings.attachments.mime.title': 'MIME allowlist',
  'settings.attachments.mime.description': 'Types accepted for upload; other types are rejected.',
  'settings.attachments.mime.label': 'Allowed MIME prefixes',
  'settings.attachments.mime.hint': 'Comma-separated, for example image/, application/pdf, audio/. An empty list means no restriction.',
  'settings.attachments.mime.placeholder': 'image/, application/pdf, audio/',
  'settings.attachments.mime.empty': 'Remove empty items between commas',
  'settings.help.attachments.section.attachments-status': 'Where the effective settings come from (env → runtime → config.yaml → default) and what the running process actually uses.',
  'settings.help.attachments.section.attachments-general': 'Master switch: when disabled, file upload in messages is rejected regardless of modality settings.',
  'settings.help.attachments.section.attachments-modalities': 'Per-modality switches; a disabled modality is rejected on upload with a clear error.',
  'settings.help.attachments.section.attachments-modality-models': 'Auxiliary models for attachments: the session model is not changed, the chosen model only processes the file (description or extracted text).',
  'settings.help.attachments.modalityModels.image': 'Model that processes images when the session model cannot. Only models declaring the image modality are offered.',
  'settings.help.attachments.modalityModels.pdf': 'Model that extracts text from PDF when the session model cannot. Only models declaring the pdf modality are offered.',
  'settings.help.attachments.modalityModels.audio': 'Model that transcribes audio when the session model cannot. Only models declaring the audio modality are offered.',
  'settings.help.attachments.modalityModels.video': 'Model that processes video when the session model cannot. Only models declaring the video modality are offered.',
  'settings.help.attachments.section.attachments-compression': 'Compression applies only at the provider boundary: the blob and the API always serve the original.',
  'settings.help.attachments.compression.enabled': 'Master switch: disables compression for all families without changing their settings.',
  'settings.help.attachments.compression.image.maxSide': 'Limit for the long side in pixels; smaller images are not upscaled.',
  'settings.help.attachments.compression.image.quality': 'JPEG/WebP quality: higher means better and heavier.',
  'settings.help.attachments.compression.image.minSize': 'Files below the threshold are sent as is.',
  'settings.help.attachments.compression.video.maxHeight': 'Frame height limit; width is scaled proportionally.',
  'settings.help.attachments.compression.video.bitrate': 'Target video bitrate in kbps.',
  'settings.help.attachments.compression.video.audioBitrate': 'Video audio track bitrate in kbps.',
  'settings.help.attachments.compression.video.minSize': 'Files below the threshold are not re-encoded.',
  'settings.help.attachments.compression.audio.bitrate': 'Target audio bitrate in kbps.',
  'settings.help.attachments.compression.audio.channels': 'Channel count: 1 — mono, 2 — stereo.',
  'settings.help.attachments.compression.audio.sampleRate': 'Sample rate in hertz.',
  'settings.help.attachments.compression.audio.minSize': 'Files below the threshold are sent as is.',
  'settings.help.attachments.section.attachments-thumbnail': 'A thumbnail is a derived small frame for the interface; the original bytes are unchanged.',
  'settings.help.attachments.thumbnail.maxWidth': 'Thumbnail width limit in pixels; height is proportional.',
  'settings.help.attachments.maxChunk': 'Streaming upload part size in MiB; the server rejects anything below 1 KiB.',
  'settings.help.attachments.section.attachments-limits': 'Limits are edited in MiB and sent to the API in bytes; the value is rounded when converted.',
  'settings.help.attachments.section.attachments-storage': 'The background cleanup removes attachments no message references after the chosen number of days.',
  'settings.help.attachments.section.attachments-behavior': 'Fallback keeps the file on disk: the model cannot see the content but can open it with tools.',
  'settings.help.attachments.section.attachments-mime': 'Prefixes match the beginning of the MIME type, e.g. image/ covers image/png and image/jpeg.',
  'settings.help.attachments.enabled': 'Files are accepted in messages and passed to the model according to modality settings.',
  'settings.help.attachments.maxFile': 'Limit for one file in MiB; larger files are rejected on upload.',
  'settings.help.attachments.maxFiles': 'Number of files in one message; the rest is rejected.',
  'settings.help.attachments.maxSession': 'Total volume of attachments in a session; the limit blocks new uploads.',
  'settings.help.attachments.gcDays': 'Retention of orphaned attachments in days; 0 disables the cleanup.',
  'settings.help.attachments.workspaceFallback': 'Incompatible files are saved to the project workspace and the model gets the path.',
  'settings.help.attachments.mime': 'Comma-separated MIME prefixes; empty items are invalid.',
  'gateway.title': 'Security gateway',
  'gateway.description': 'Independent protection layer for LLM traffic: secrets (API keys, tokens, emails) are obfuscated to ⟦SYNTH_SECRET_N⟧ placeholders before sending to the model and revealed only at consumption points. Value reveal in the UI is audit-logged.',
  'toolsPolicy.title': 'Built-in tools policy',
  'toolsPolicy.description': 'Which built-in tool definitions are sent to the model in requests. MCP tools are governed by the separate "MCP policy".',
  'toolsPolicy.label': 'Global built-in tools policy',
  'toolsPolicy.consistency': 'consistency — all built-in tools, unavailability hints',
  'toolsPolicy.available': 'available — only available built-in tools (save context)',
  'toolsPolicy.auto': 'auto — by provider (local → available, cloud → consistency)',
  'toolsPolicy.help': 'Applies to built-in tools only. consistency keeps the tool layer stable for prompt caching; available narrows the request to built-in tools allowed for the current mode/role (useful for local models with a small context window); auto picks per request provider. MCP tools are governed by the MCP policy. A session can override this.',
  'toolsPolicy.inherit': 'Global ({policy})',
  'toolsPolicy.inheritUnknown': 'Global',
  'toolsPolicy.sessionHelp': 'Policy for this session. The global policy is set by the administrator.',
  'mcpPolicy.title': 'MCP policy',
  'mcpPolicy.description': 'Which MCP tool definitions are sent to the model in requests. Built-in tools are governed by a separate policy.',
  'mcpPolicy.label': 'Global MCP policy',
  'mcpPolicy.consistency': 'consistency — all MCP tools, unavailability hints',
  'mcpPolicy.available': 'available — only available MCP tools (save context)',
  'mcpPolicy.auto': 'auto — by provider (local → available, cloud → consistency)',
  'mcpPolicy.help': 'Applies to MCP tools only. consistency keeps the MCP tool layer stable for prompt caching; available narrows the request to MCP tools allowed for the current mode/role; auto picks per request provider. Built-in tools are governed by a separate policy. A session can override this.',
  'mcpPolicy.inherit': 'Global ({policy})',
  'mcpPolicy.inheritUnknown': 'Global',
  'mcpPolicy.sessionHelp': 'Policy for this session. The global policy is set by the administrator.',
    'mcpPolicy.saved': 'MCP policy saved',
  'mcpPolicy.saveError': 'Failed to save MCP policy: {error}',

  // Skills & slash-commands (ADR-046)
  'skillsPolicy.title': 'Skills policy',
  'skillsPolicy.description': 'Which skill definitions are sent to the model in requests. The catalog and command resolution mechanism is always on.',
  'skillsPolicy.label': 'Global skills policy',
  'skillsPolicy.consistency': 'consistency — all skills, unavailability hints',
  'skillsPolicy.available': 'available — only available skills (save context)',
  'skillsPolicy.auto': 'auto — by provider (local → available, cloud → consistency)',
  'skillsPolicy.help': 'Applies to skills only. consistency keeps the skills layer stable for prompt caching; available narrows the request to skills allowed for the current mode/role; auto picks per request provider. A session can override this.',
  'policy.short.consistency': 'Consistency',
  'policy.short.available': 'Available only',
  'policy.short.auto': 'By provider',
  'skillsPolicy.saved': 'Skills policy saved',
  'skillsPolicy.saveError': 'Failed to save skills policy: {error}',
  'skills.title': 'Skills',
  'skills.description': 'Browse available skills and inspect their SKILL.md body and supporting files. Creating and editing skills is an administrator action.',
  'skills.count': '{count, plural, one {# skill} other {# skills}}',
  'skills.reload': 'Reload',
  'skills.empty': 'No skills available',
  'skills.untrusted': 'Untrusted',
  'skills.unavailable': 'Unavailable',
  'skills.untrustedHint': 'This project skill is untrusted: only metadata is shown, the body and supporting files are hidden until the project directory is trusted.',
  'skills.error.load': 'Failed to load the skills registry',
  'skills.error.loadDetail': 'Failed to load the skill',
  'skills.error.save': 'Failed to save the skill',
  'skills.error.delete': 'Failed to delete the skill',
  'skills.error.reload': 'Failed to reload the skills registry',
  'skills.error.loadSettings': 'Failed to load skills settings',
  'skills.error.saveSettings': 'Failed to save skills settings',
  'skills.scope.instance': 'instance',
  'skills.scope.project': 'project',
  'skills.level.system': 'system',
  'skills.level.project': 'project',
  'skills.level.session': 'session',
  'skills.detail.title': 'Skill details',
  'skills.detail.body': 'SKILL.md body',
  'skills.detail.noBody': 'No body',
  'skills.detail.files': '{count, plural, one {# supporting file} other {# supporting files}}',
  'skills.detail.noFiles': 'No supporting files',
  'skills.detail.close': 'Close',
  'skillsAdmin.title': 'Skills',
  'skillsAdmin.description': 'Instance skills registry: create and edit SKILL.md, supporting files, system-level enable/disable and policy.',
  'skillsAdmin.newSkill': 'New skill',
  'skillsAdmin.editSkill': 'Edit skill',
  'skillsAdmin.instanceOnly': 'Only instance skills can be edited',
  'skillsAdmin.saved': 'Skill saved',
  'skillsAdmin.saveError': 'Failed to save the skill: {error}',
  'skillsAdmin.deleted': 'Skill deleted',
  'skillsAdmin.deleteError': 'Failed to delete the skill: {error}',
  'skillsAdmin.deleteConfirm': 'Delete skill',
  'skillsAdmin.deleteConfirmMessage': 'Delete skill "{name}"? This action cannot be undone.',
  'skillsAdmin.form.name': 'Name',
  'skillsAdmin.form.nameHint': 'lowercase letters, digits and hyphens; must match the directory name',
  'skillsAdmin.form.description': 'Description',
  'skillsAdmin.form.body': 'Body (Markdown)',
  'skillsAdmin.form.bodyHint': 'Content of SKILL.md without frontmatter',
  'skillsAdmin.form.files': 'Supporting files',
  'skillsAdmin.form.noFiles': 'No supporting files',
  'skillsAdmin.form.filePath': 'Path',
  'skillsAdmin.form.fileContent': 'Content',
  'skillsAdmin.form.addFile': 'Add file',
  'skillsAdmin.form.removeFile': 'Remove file',
  'skillsAdmin.form.loadError': 'Failed to load the skill',
  'skillsAdmin.form.error.nameRequired': 'Name is required',
  'skillsAdmin.form.error.nameInvalid': 'Invalid name: lowercase letters, digits, hyphen separator (1-64)',
  'skillsAdmin.form.error.descriptionRequired': 'Description is required',
  'skillsAdmin.form.error.descriptionMax': 'Description is too long (max {max})',
  'skillsAdmin.disabled.title': 'System skill gates',
  'skillsAdmin.disabled.description': 'Two axes: master disable (the skill is unavailable everywhere) and the new-projects seed (what not to enable by default). The catalog and command resolution mechanism cannot be disabled.',
  'skillsAdmin.gates.master': 'Disable everywhere (master)',
  'skillsAdmin.gates.masterHint': 'A disabled skill is unavailable anywhere — in new and already created projects and sessions.',
  'skillsAdmin.gates.newProjects': 'Default for new projects',
  'skillsAdmin.gates.newProjectsHint': 'What not to include in the seed of new projects. Does not affect existing projects and sessions.',
  'skillsAdmin.disabled.categories': 'Categories',
  'skillsAdmin.disabled.groups': 'Groups',
  'skillsAdmin.disabled.skills': 'Individual skills',
  'skillsAdmin.disabled.noCategories': 'No categories found',
  'skillsAdmin.disabled.noGroups': 'No groups found',
  'skillsAdmin.disabled.noSkills': 'No skills found',
  'skillsAdmin.disabled.saved': 'Skills settings saved',
  'skillsAdmin.disabled.saveError': 'Failed to save skills settings: {error}',
  'skillsAdmin.diagnostics.title': 'Diagnostics',
  'skillsAdmin.diagnostics.description': 'Discovery and validation issues (shadowed, invalid frontmatter, untrusted).',
  'commands.title': 'Commands',
  'commands.description': 'Slash-commands: built-in, template, skills and bundles, plus discovery diagnostics.',
  'commands.count': '{count, plural, one {# command} other {# commands}}',
  'commands.empty': 'No commands',
  'commands.error.load': 'Failed to load commands',
  'commands.kind.builtin': 'built-in',
  'commands.kind.template': 'template',
  'commands.kind.skill': 'skill',
  'commands.kind.bundle': 'bundle',
  'commands.unavailable': 'unavailable',
  'commands.unavailable.denied': 'denied',
  'commands.diagnostics.title': 'Diagnostics',
  'commands.diagnostics.description': 'Name collisions and shadowed commands.',
  'commands.bundles.title': 'Bundles',
  'commands.bundles.description': 'YAML groups of skills loaded by a single /bundle-name command.',
  'commands.bundles.empty': 'No bundles',
  'commands.bundles.new': 'New bundle',
  'commands.bundles.edit': 'Edit bundle',
  'commands.bundles.deleteConfirm': 'Delete bundle',
  'commands.bundles.deleteConfirmMessage': 'Delete bundle "{name}"? This action cannot be undone.',
  'skillBundles.name': 'Name',
  'skillBundles.description': 'Description',
  'skillBundles.skills': 'Skills',
  'skillBundles.skillsHint': 'Skill names included in the bundle (at least one)',
  'skillBundles.noSkills': 'No skills added',
  'skillBundles.instruction': 'Additional instruction',
  'skillBundles.saved': 'Bundle saved',
  'skillBundles.saveError': 'Failed to save the bundle: {error}',
  'skillBundles.deleted': 'Bundle deleted',
  'skillBundles.deleteError': 'Failed to delete the bundle: {error}',
  'skillBundles.error.load': 'Failed to load bundles',
  'skillBundles.error.nameRequired': 'Name is required',
  'skillBundles.error.nameInvalid': 'Invalid name: lowercase letters, digits, hyphen separator (1-64)',
  'skillBundles.error.descriptionRequired': 'Description is required',
  'skillBundles.error.descriptionMax': 'Description is too long (max {max})',
  'skillBundles.error.skillsRequired': 'Add at least one skill',


  'gateway.logPayloads': 'Log LLM requests and responses',
  'gateway.logPayloadsHelp': 'Written to a separate JSONL after obfuscation, available in the "Logs & audit → LLM" window.',
  'gateway.inputMode': 'Input Guard mode',
  'gateway.inputMode.obfuscate': 'obfuscate — replace secret with placeholder',
  'gateway.inputMode.block': 'block — block the request',
  'gateway.rateLimit': 'Rate limit',
  'gateway.rateLimit.user': 'Requests per user / min',
  'gateway.rateLimit.provider': 'Requests per provider / min',
  'gateway.patterns.title': 'Obfuscation patterns',
  'gateway.patterns.description': 'Regex patterns for secret detection: matched values are replaced with the ⟦SYNTH_SECRET_N⟧ placeholder before sending to the model.',
  'gateway.patterns.defaultBadge': 'default',
  'gateway.patterns.add': 'Add pattern',
  'gateway.patterns.save': 'Save patterns',
  'gateway.patterns.reset': 'Reset to default',
  'gateway.patterns.remove': 'Remove',
  'gateway.patterns.invalidRegex': 'Invalid regex',
  'gateway.patterns.saved': 'Patterns saved',
  'gateway.patterns.empty': 'No patterns',
  'gateway.secret.hidden': 'Value hidden',
  'security.protectedPaths.title': 'Protected paths',
  'security.protectedPaths.description': 'Cross-cutting check of file and shell tools: attempts to access protected paths (secrets, configs, system files) are blocked before permission rules are applied.',
  'security.protectedPaths.defaultBadge': 'default',
  'security.protectedPaths.add': 'Add',
  'security.protectedPaths.remove': 'Remove',
  'security.protectedPaths.deniedPaths': 'Denied paths (exact match)',
  'security.protectedPaths.placeholder': 'path/value',
  'security.protectedPaths.deniedPrefixes': 'Denied directory prefixes',
  'security.protectedPaths.approvalPaths': 'Paths requiring confirmation (ask)',
  'security.protectedPaths.deniedCommandPrefixes': 'Denied command prefixes (shell only)',
  'security.protectedPaths.save': 'Save paths',
  'security.protectedPaths.reset': 'Reset to default',
  'security.protectedPaths.saved': 'Paths saved',
  'security.protectedPaths.baseHint': 'The list matches the system default policy. You can change the protected paths list here; changes apply to agent tools.',
  'settings.category.dashboard': 'Dashboard',
  'settings.category.sessions': 'Sessions',
  'settings.category.projects': 'Projects',
  'settings.category.context': 'Context files',
  'settings.category.users': 'Users',
  'settings.category.defaults': 'System appearance',
  'settings.category.debug': 'Debug',

  // Logs & Audit modal
  'logs.title': 'Logs & Audit',
  'logs.category.core': 'Core',
  'logs.category.ui': 'UI',
  'logs.category.backend': 'Backend',
  'logs.category.llm': 'LLM',
  'logs.category.audit': 'Audit',
  'logs.category.events': 'Events',
  'logs.core.title': 'Core logs',
  'logs.core.description': 'Tail of the synth core log file (core.log).',
  'logs.ui.title': 'UI logs',
  'logs.ui.description': 'Tail of the web interface log file (ui.log).',
  'logs.backend.title': 'Backend logs',
  'logs.backend.description': 'Tail of the API hub log file (backend.log).',
  'logs.audit.title': 'Audit journal',
  'logs.audit.description': 'LLM Gateway events: secret obfuscation, blocks, rate limits and placeholder reveals.',
  'logs.tail': 'Tail',
  'logs.search': 'Search',
  'logs.refresh': 'Refresh',
  'logs.autoRefresh': 'Auto-refresh',
  'logs.empty': 'No lines',
  'logs.loading': 'Loading…',
  'logs.error': 'Load error',
  'logs.audit.type': 'Type',
  'logs.audit.user': 'User',
  'logs.audit.session': 'Session',
  'logs.audit.since': 'From',
  'logs.audit.until': 'To',
  'logs.audit.limit': 'Limit',
  'logs.audit.apply': 'Apply',
  'logs.audit.all': 'all',
  'logs.audit.time': 'Time',
  'logs.audit.placeholder': 'Placeholder',
  'logs.audit.provider': 'Provider',
  'logs.audit.cost': 'Cost',
  'logs.audit.reason': 'Reason',
  'logs.audit.noEntries': 'No entries',
  'logs.category.security': 'Security (policies)',
  'logs.category.egress': 'Outgoing requests',
  'logs.security.title': 'Security policy audit',
  'logs.security.description': 'History of egress/security policy changes: who, when, scope and before → after.',
  'logs.security.time': 'Time',
  'logs.security.actor': 'Actor',
  'logs.security.scope': 'Scope',
  'logs.security.action': 'Action',
  'logs.security.change': 'Before → after',
  'logs.security.noEntries': 'No entries',
  'logs.security.error': 'Failed to load the audit',
  'logs.security.limit': 'Limit',
  'logs.security.allScopes': 'all scopes',
  'logs.egress.title': 'Outgoing requests log',
  'logs.egress.description': 'External requests of tools, webhooks, providers and MCP: verdict, status, duration and reason.',
  'logs.egress.time': 'Time',
  'logs.egress.scope': 'Scope',
  'logs.egress.target': 'Host / URL',
  'logs.egress.status': 'Status',
  'logs.egress.code': 'Code',
  'logs.egress.duration': 'Duration',
  'logs.egress.reason': 'Reason / rule',
  'logs.egress.noEntries': 'No entries',
  'logs.egress.error': 'Failed to load the egress log',
  'logs.egress.limit': 'Limit',
  'logs.egress.allScopes': 'all scopes',
  'logs.egress.allStatuses': 'all statuses',
  'logs.egress.status.allowed': 'allowed',
  'logs.egress.status.blocked': 'blocked',
  'logs.egress.status.error': 'error',
  'logs.llm.title': 'LLM requests/responses',
  'logs.llm.description': 'Full log of LLM exchanges (after obfuscation, no secrets).',
  'logs.llm.request': 'Request',
  'logs.llm.response': 'Response',
  'logs.llm.noEntries': 'No entries',

  // Appearance settings
  'settings.appearance.title': 'Appearance',
  'settings.appearance.description': 'Customize the interface theme and language.',
  'settings.appearance.themeMode.label': 'Theme mode',
  'settings.appearance.themeMode.system': 'System',
  'settings.appearance.themeMode.light': 'Light',
  'settings.appearance.themeMode.dark': 'Dark',
  'settings.appearance.theme.label': 'Theme',
  'settings.appearance.language.label': 'Interface language',
  'settings.appearance.uiScale.label': 'Interface scale',
  'settings.appearance.uiScale.mobile': 'Mobile',
  'settings.appearance.uiScale.desktop': 'Desktop',
  'settings.appearance.uiScale.reset': 'Reset',
  'settings.microFirst.enabled': 'Quick answers',
  'settings.microFirst.confidence': 'Confidence threshold',
  'settings.microFirst.embedding': 'Embedding',
  'settings.microFirst.provider': 'Provider',
  'settings.microFirst.model': 'Model',

  // Auth
  'auth.loginTitle': 'Sign In',
  'auth.loginSubtitle': 'Enter your API key to access Synth',
  'auth.loginSubtitleOidc': 'Enter your login and password to access Synth',
  'auth.apiKey': 'API key',
  'auth.apiKeyPlaceholder': 'Enter API key',
  'auth.username': 'Login',
  'auth.usernamePlaceholder': 'Enter login',
  'auth.password': 'Password',
  'auth.passwordPlaceholder': 'Enter password',
  'auth.serverUrl': 'Server URL',
  'auth.serverUrlPlaceholder': 'https://synth.example.com',
  'auth.serverKnown': 'Choose a server or enter the address',
  'auth.selectUser': 'Select user',
  'auth.loginButton': 'Sign In',
  'auth.profile': 'Profile',
  'auth.profileDescription': 'Manage your profile settings',
  'auth.usernameRequired': 'Username is required',
  'auth.saveError': 'Failed to save profile',
  'auth.interfaceLanguage': 'Interface language',
  'auth.teamRole': 'Team role',
  'auth.notes': 'Notes',
  'auth.interviewCompleted': 'Onboarding completed',
  'auth.interviewCompletedDescription': 'The interview about you is finished; it will not be offered again.',
  'auth.phone': 'Phone',
  'auth.roleDeveloper': 'Developer',
  'auth.roleAdmin': 'Administrator',
  'auth.roleAnalyst': 'Analyst',
  'auth.roleManager': 'Manager',
  'auth.logout': 'Logout',
  'auth.openSettings': 'Profile settings',
  'auth.uploadAvatar': 'Upload avatar',
  'auth.changeAvatar': 'Change avatar',
  'auth.removeAvatar': 'Remove',
  'auth.avatarTooLarge': 'File too large (max 500 KB)',
  'auth.login': 'Login',
  'auth.displayName': 'Name',
  'auth.identities': 'Identities',
  'auth.identitiesDescription': 'External accounts (e.g. Telegram) linked to your profile. Sessions from these senders belong to you.',
  'auth.identitiesEmpty': 'No linked identities',
  'auth.identityUnlink': 'Unlink',
  'auth.identityUnlinkTitle': 'Unlink identity',
  'auth.identityUnlinkConfirm': 'Unlink {identity} from your profile?',
  'auth.identityLinkedAt': 'Linked',
  'auth.identitiesLoadError': 'Failed to load identities',
  'auth.identityUnlinkError': 'Failed to unlink identity',
  'auth.identityClaim': 'Link',
  'auth.identityClaimLabel': 'Confirmation code',
  'auth.identityClaimDescription': 'Enter the code you received in chat (e.g. from the Telegram bot) to link an external account to your profile.',
  'auth.identityClaimPlaceholder': 'XXX-XXX',
  'auth.identityClaimInvalid': 'Code is invalid, expired, or already used',
  'auth.identityClaimConflict': 'This identity is already linked to another profile',
  'auth.identityClaimRequired': 'Enter the confirmation code',
  'auth.identityClaimError': 'Failed to link identity',
  'auth.resetVisualSettings': 'Reset to defaults',
  'auth.resetConfirm': 'Are you sure you want to reset visual settings?',
  'auth.resetSuccess': 'Settings reset',
  'auth.admin': 'Administration',
  'auth.reloadPage': 'Reload page',
  'auth.fullscreen': 'Fullscreen',
  'auth.exitFullscreen': 'Exit fullscreen',

  // Left panel
  'leftPanel.tab.projects': 'Projects',
  'leftPanel.tab.files': 'Files',
  'leftPanel.tab.git': 'Git',
  'leftPanel.tab.pipelines': 'Pipelines',
  'leftPanel.newProject': 'New project',
  'leftPanel.newSession': 'New session',
  'leftPanel.confirm': 'Confirm',
  'leftPanel.cancel': 'Cancel',
  'leftPanel.expandAll': 'Expand all',
  'leftPanel.collapseAll': 'Collapse all',
  'leftPanel.projectName': 'Project name',
  'leftPanel.sessionName': 'Session name',
  'leftPanel.noProject': 'No project',
  'leftPanel.noSessions': 'No sessions',
  'leftPanel.empty': 'No projects or sessions',
  'leftPanel.noWorkspace': 'No projects with workspace',
  'leftPanel.emptyDirectory': 'Empty directory',
  'leftPanel.editProject': 'Edit project',
  'leftPanel.editProject.title': 'Project settings',
  'leftPanel.editProject.general': 'General',
  'leftPanel.editProject.appearance': 'Appearance',
  'leftPanel.editProject.repos': 'Repositories',
  'leftPanel.editSession': 'Edit session',
  'leftPanel.editSession.title': 'Session settings',
  'project.name': 'Name',
  'project.description': 'Description',
  'project.save': 'Save',
  // Engine key (ADR-041/ADR-075)
  'project.workspace_create_error': 'Error creating project workspace: {error}',
  'project.write_forbidden': 'Error: you do not have permission to modify this project (owner or editor role required)',
  'project.updated': 'Project updated.',
  'project.updated_ok': 'Project "{name}" updated.',
  'project.invalid_icon': 'Invalid icon "{value}". Allowed values: {allowed}.',
  'project.invalid_color': 'Invalid color "{value}". Allowed values: {allowed}.',
  'project.no_project': 'No project: this action is available only within a project',
  'project.workspace_set': 'Project working directory set: {dir}',
  'project.workspace_invalid': 'Error: invalid project working directory',
  'project.workspace_denied': 'Error: working directory outside the allowed root is denied by policy',
  'project.workspace_confirm_required': 'Error: working directory outside the allowed root requires confirmation',
  'project.workspace_missing': 'Error: project working directory is not set',
  'project.repo_cloned': 'Repository cloned: {path}',
  'project.repo_initialized': 'Repository initialized: {path}',
  'project.repo_registered': 'Repository registered: {path}',
  'project.repo_fetched': 'Repository updated (fetch): {path}',
  'project.repo_removed': 'Repository removed from the project registry: {path}',
  'project.repo_not_found': 'Error: repository not found in the project registry: {path}',
  'leftPanel.name': 'Name',
  'leftPanel.icon': 'Icon',
  'leftPanel.color': 'Color',
  'leftPanel.iconColor': 'Icon & color',
  'entityIcon.noIcon': 'No icon',
  'entityIcon.noColor': 'No color',
  'entityColor.a1': 'Red',
  'entityColor.a2': 'Salmon',
  'entityColor.a3': 'Amber',
  'entityColor.a4': 'Pale lime',
  'entityColor.a5': 'Lime',
  'entityColor.a6': 'Light green',
  'entityColor.a7': 'Green',
  'entityColor.a8': 'Mint',
  'entityColor.a9': 'Cyan',
  'entityColor.a10': 'Sky',
  'entityColor.a11': 'Blue',
  'entityColor.a12': 'Cornflower',
  'entityColor.a13': 'Violet',
  'entityColor.a14': 'Orchid',
  'entityColor.a15': 'Magenta',
  'entityColor.a16': 'Pink',
  'leftPanel.workspace': 'Workspace',
  'leftPanel.confirmDelete': 'Delete project?',
  'leftPanel.confirmDeleteSession': 'Delete session?',
  'leftPanel.confirmBulkDelete': 'Delete {count} selected sessions?',
  'leftPanel.rename': 'Rename',
  'leftPanel.regenerateTitle': 'Regenerate title',
  'leftPanel.forkSession': 'Fork',
  'leftPanel.copyToSession': 'Copy to session...',
  'leftPanel.addReference': 'Add reference...',
  'leftPanel.configure': 'Configure',
  'leftPanel.delete': 'Delete',
  'leftPanel.clearSession': 'Clear',
  'leftPanel.confirmClearSession': 'Clear all messages in session?',
  'leftPanel.streaming': 'Streaming',
  'leftPanel.attentionNeeded': 'Attention needed',
  'leftPanel.answerReady': 'Answer ready',
  'leftPanel.blocked': 'Blocked',
  'leftPanel.notifications': '{count} notif.',
  'leftPanel.showMore': 'Show {count} more',
  'leftPanel.showFewer': 'Show fewer',
  'leftPanel.loadMoreSessions': 'Show more sessions',
  'leftPanel.loadingMoreSessions': 'Loading…',
  'leftPanel.loadMoreProjects': 'Show more projects',
  'leftPanel.loadingMoreProjects': 'Loading…',
  'leftPanel.selectSessions': 'Select mode',
  'leftPanel.exitSelection': 'Exit selection',
  'leftPanel.sortByName': 'By name',
  'leftPanel.sortByDate': 'By date',
  'leftPanel.bulkSelectedCount': 'Selected: {count}',
  'leftPanel.git.placeholder': 'Git — in development',
  'leftPanel.noRepos': 'No repositories',
  'leftPanel.noCommits': 'No commits',
  'leftPanel.showMoreCommits': 'Show {count} more',
  'leftPanel.showFewerCommits': 'Show fewer',
  'leftPanel.currentProject': 'Current project',
  'leftPanel.otherProjects': 'Other projects ({count})',
  'leftPanel.projectScope.onlyCurrent': 'Only current project',
  'leftPanel.projectScope.all': 'All projects',
  'leftPanel.projectScope.noContextHint': 'No active project context',
  'leftPanel.currentProject.none': 'Active session has no project',
  'leftPanel.currentProject.noWorkspace': 'Active project has no workspace',
  'leftPanel.otherProjects.expand': 'Expand other projects',
  'leftPanel.otherProjects.collapse': 'Collapse other projects',

  'git.repo': 'Repository',
  'git.workspaceRoot': 'Workspace root',
  'git.scan': 'Scan',
  'git.scanAll': 'Scan all',
  'git.addRepo': 'Add repository',
  'git.initRepo': 'Initialize',
  'git.cloneRepo': 'Clone',
  'git.refresh': 'Refresh',
  'git.remove': 'Remove',
  'git.path': 'Path',
  'git.url': 'URL',
  'git.branch': 'Branch',
  'git.defaultBranch': 'Default branch',
  'git.branchPlaceholder': 'main',
  'git.initSuccess': 'Repository initialized',
  'git.cloneSuccess': 'Repository cloned',
  'git.noGitRepos': 'No git repositories found',
  'git.selectToAdd': 'Select repositories to add',
  'git.destination': 'Destination',
  'git.type': 'Type',
  'git.name': 'Name',
  'git.namePlaceholder': 'Defaults to the repository name',
  'git.pathHint': 'Relative to the project workspace',
  'git.sshKey': 'SSH key',
  'git.sshKeyNone': 'No key',
  'git.sshKeyRequiredHint': 'An SSH key is required for SSH URLs',
  'git.noSshKeys': 'No SSH keys configured',
  'git.deleteLocal': 'Also delete local files',
  'git.register': 'Add to project',
  'git.lastFetch': 'Last fetch',
  'git.fetchRepo': 'Fetch',
  'git.fetchSuccess': 'Repository fetched',
  'git.removeTitle': 'Remove repository?',
  'git.removeConfirm': 'Remove "{path}" from the project registry?',
  // Progress indicators and cancellation for long network operations.
  'git.cloning': 'Cloning…',
  'git.initializing': 'Initializing…',
  'git.fetching': 'Fetching…',
  'git.removing': 'Removing…',
  'git.cloneCancel': 'Cancel',
  'git.cloneCancelled': 'Clone cancelled',
  'git.cloneNetworkHint': 'A network operation may take several minutes',
  // 409 "path is taken" (details.occupied): three states — three actions.
  'git.occupied.register': 'Register existing',
  'git.occupied.deleteAndRetry': 'Delete and retry',
  'git.occupied.choosePath': 'Choose another path',
  'git.occupied.stubMoved': 'Incomplete clone kept at "{path}"',
  'git.registerOccupiedSuccess': 'Existing repository registered',

  'commit.hash': 'Commit',
  'commit.author': 'Author',
  'commit.date': 'Date',
  'commit.message': 'Message',
  'commit.files': 'Files',
  'commit.diff': 'Diff',
  'commit.diffTruncated': 'Diff truncated: the file is too large, only the first lines are shown.',
  'commit.filesCount': '{count} files changed',
  'commit.copy': 'Copy',
  'commit.copied': 'Copied',
  'commit.tooltip': '{subject}\n\n{author} • {date}\nBranch: {branch}\nHash: {hash}',
  'errors.notFound.route': 'Route not found',
  'errors.conflict.eventKeyLabel': 'This label is already used by another key — pick a different one.',
  'errors.conflict.serviceKeyLabel': 'This label is already used by another service key — pick a different one.',
  'errors.conflict.webhookLabel': 'This label is already used by another webhook — pick a different one.',

  // Right panel
  'rightPanel.tab.stats': 'Stats',
  'rightPanel.tab.session': 'Session',
  'rightPanel.tab.context': 'Context',
  'rightPanel.tab.scheduler': 'Scheduler',
  'rightPanel.tab.references': 'References',
  'rightPanel.tab.secrets': 'Security',
  'rightPanel.tab.memory': 'Memory',
  'rightPanel.tab.processes': 'Processes',
  'rightPanel.stats.projectStats': 'Project stats',
  'rightPanel.stats.sessions': 'Sessions',
  'rightPanel.stats.inputTokens': 'Input',
  'rightPanel.stats.outputTokens': 'Output',
  'rightPanel.stats.cacheReadTokens': 'Cache read',
  'rightPanel.stats.cacheWriteTokens': 'Cache write',
  'rightPanel.stats.cacheHitRate': 'Cache hit rate',
  // ADR-070 §2.6: short column headers in agent/user tables
  'rightPanel.stats.colCache': 'Cache',
  'rightPanel.stats.colCacheHit': '%',
  'rightPanel.stats.reasoningTokens': 'Reasoning',
  'rightPanel.stats.noData': 'No data',
  'rightPanel.stats.lastAnswer': 'Last answer',
  'rightPanel.stats.session': 'Session',
  'rightPanel.stats.project': 'Project',
  'rightPanel.stats.noProject': 'No project',
  'rightPanel.stats.contextWindow': 'Context window',
  'rightPanel.stats.contextNearLimit': 'Context limit is near',
  // ADR-070 §2.6: agent and author stats
  'rightPanel.stats.agentsStats': 'Agent stats',
  'rightPanel.stats.usersStats': 'User stats',
  'rightPanel.stats.agent': 'Agent',
  'rightPanel.stats.user': 'User',
  'rightPanel.stats.messages': 'Messages',
  'rightPanel.stats.subagents': 'Subagents',
  'rightPanel.stats.subagentTokens': 'Subagent tokens',
  // ADR-070 §2.6: separate subagent block in "Last answer"
  'rightPanel.stats.subagentsTitle': 'Subagents',
  'rightPanel.stats.subagentsSessions': 'Sessions',
  'rightPanel.stats.subagentsNote': 'Separate from the answer — not counted in the context window',
  'rightPanel.stats.subagentsIncluded': 'incl. subagents',
  // ADR-070 §2.6: live-строка статистики активного стрима
  'rightPanel.stats.live': 'live',
  'rightPanel.stats.speed': 'Speed',
  'rightPanel.stats.duration': 'Duration',
  'rightPanel.stats.cost': 'Cost',
  'rightPanel.stats.expand': 'More',
  'rightPanel.stats.collapse': 'Hide',
  // ADR-070 §2.5: prompt composition (manifest)
  'rightPanel.stats.promptComposition': 'Prompt composition',
  'rightPanel.stats.promptTotal': 'Total chars\n~tokens',
  'rightPanel.stats.promptStaticPrefix': 'Static\nprefix, chars.',
  'rightPanel.stats.promptCache': 'Cache',
  'rightPanel.stats.promptHit': 'hit',
  'rightPanel.stats.promptMiss': 'miss',
  'rightPanel.stats.promptColTier': 'Tier',
  'rightPanel.stats.promptColKey': 'Block',
  'rightPanel.stats.promptColChars': 'Chars',
  'rightPanel.stats.promptColTokens': '~Tokens',
  'rightPanel.stats.promptColStatus': 'Status',
  'rightPanel.stats.promptTier.stable': 'stable',
  'rightPanel.stats.promptTier.context': 'context',
  'rightPanel.stats.promptTier.volatile': 'volatile',
  'rightPanel.stats.promptStatus.loaded': 'loaded',
  'rightPanel.stats.promptStatus.truncated': 'truncated',
  'rightPanel.stats.promptStatus.empty': 'empty',
  'rightPanel.stats.promptStatus.blocked': 'blocked',
  'rightPanel.stats.promptStatus.suppressed': 'suppressed',
  'rightPanel.stats.promptBlock.role': 'Role prompt',
  'rightPanel.stats.promptBlock.override': 'System prompt override',
  'rightPanel.stats.promptBlock.additional': 'Additional context',
  'rightPanel.stats.promptBlock.gateway': 'Gateway instructions',
  'rightPanel.stats.promptBlock.plan.guide': 'Plan guide',
  'rightPanel.stats.promptBlock.memory.guide': 'Memory guide',
  'rightPanel.stats.promptBlock.mode.policy': 'Mode policy',
  'rightPanel.stats.promptBlock.classification': 'Classification instruction',
  'rightPanel.stats.promptBlock.profile': 'User profile',
  'rightPanel.stats.promptBlock.project.info': 'Project info',
  'rightPanel.stats.promptBlock.session.info': 'Session info',
  'rightPanel.stats.promptBlock.sticky': 'Sticky notes',
  'rightPanel.stats.promptBlock.participants': 'Participants notice',
  'rightPanel.stats.promptBlock.summary': 'Compressed dialog',
  'rightPanel.stats.promptBlock.interview': 'Interview prompt',
  'rightPanel.stats.promptBlock.tools': 'Tool descriptions',
  'rightPanel.stats.promptBlock.plugin.tools': 'Plugin tools',
  'rightPanel.stats.promptBlock.mcp.tools': 'MCP tools',
  'rightPanel.stats.promptBlock.mcp.servers': 'MCP servers',
  'rightPanel.stats.promptBlock.mcp.status': 'MCP status',
  // ADR-071 §2.6: built-in tools + MCP tables
  'rightPanel.stats.builtinTools': 'Built-in tools',
  'rightPanel.stats.mcpServers': 'MCP',
  'rightPanel.stats.colTool': 'Tool',
  'rightPanel.stats.colCapability': 'Capability',
  'rightPanel.stats.colAvailable': 'Availability',
  'rightPanel.stats.colSource': 'Source',
  'rightPanel.stats.colServer': 'Server',
  'rightPanel.stats.colLevel': 'Level',
  'rightPanel.stats.colStatus': 'Status',
  'rightPanel.stats.colTools': 'Tools',
  'rightPanel.stats.colAuthor': 'Author',
  'rightPanel.stats.toolAvailable': 'available',
  'rightPanel.stats.toolHidden': 'hidden',
  'rightPanel.stats.toolUnavailable': 'unavailable',
  'rightPanel.stats.toolUnavailableMode': 'unavailable (mode)',
  'rightPanel.stats.toolUnavailableRole': 'unavailable (role)',
  'rightPanel.stats.toolUnavailableDependency': 'unavailable (missing dependency)',
  'rightPanel.stats.mcpDisabled': 'disabled',
  'rightPanel.stats.mcpLevel.system': 'system',
  'rightPanel.stats.mcpLevel.project': 'project',
  'rightPanel.stats.mcpLevel.session': 'session',
  'rightPanel.stats.mcpStatus.connected': 'connected',
  'rightPanel.stats.mcpStatus.error': 'error',
  'rightPanel.stats.mcpStatus.disabled': 'disabled',
  'rightPanel.stats.mcpStatus.circuit-open': 'circuit-open',
  'rightPanel.stats.mcpReason.session_optout': 'session opt-out',
  'rightPanel.stats.mcpReason.project_disabled': 'project disabled',
  'rightPanel.stats.mcpReason.system_disabled': 'disabled by administrator',
  'rightPanel.stats.mcpReason.not_default': 'not default',
  'rightPanel.stats.tokenEstimate': 'Estimated tokens: ~{tokens} (chars {chars}, ratio {ratio})',
  // ADR-070 §2.5: history layer (messages) — composition of sent messages
  'rightPanel.stats.history': 'History',
  'rightPanel.stats.historyMessages': 'Messages',
  'rightPanel.stats.historyColType': 'Type',
  'rightPanel.stats.historyColCount': 'Count',
  'rightPanel.stats.historyExcluded': 'Excluded',
  'rightPanel.stats.historyAttachments': 'Attachments',
  'rightPanel.stats.historySecrets': 'Secrets',
  'rightPanel.stats.historyDisabled': 'disabled',
  'rightPanel.stats.historyHidden': 'hidden',
  'rightPanel.stats.historyInfo': 'info',
  'rightPanel.params.session': 'Session',
  'rightPanel.params.name': 'Name',
  'rightPanel.params.id': 'ID',
  'rightPanel.params.project': 'Project',
  'rightPanel.params.none': '—',
  'rightPanel.params.creator': 'Creator',
  'rightPanel.params.created': 'Created',
  'rightPanel.params.tokens': 'Tokens',
  'rightPanel.params.agents': 'Available agents',
  'rightPanel.params.noAgents': 'No agents',
  'rightPanel.params.noSessions': 'No sessions',
  'rightPanel.tab.project': 'Project',
  'projectTab.noProject.title': 'Session is not attached to a project',
  'projectTab.noProject.hint': 'Create a project or attach the session to an existing one',
  'projectTab.noProject.create': 'Create project',
  'projectTab.noProject.attach': 'Attach to project',
  'projectTab.noProject.attachPlaceholder': 'Select a project…',
  'projectTab.noProject.prompt': 'New project name',
  'projectTab.noProject.creating': 'Creating…',
  'projectTab.noProject.created': 'Project created and attached to the session',
  'projectTab.noProject.attached': 'Session attached to the project',
  'projectTab.noProject.createError': 'Failed to create project',
  'projectTab.noProject.moveError': 'Failed to attach the session to the project',
  'projectTab.loadError': 'Failed to load project',
  'projectTab.loading': 'Loading project…',
  'projectTab.info.name': 'Name',
  'projectTab.info.id': 'ID',
  'projectTab.info.creator': 'Creator',
  'projectTab.info.created': 'Created',
  'projectTab.workspace.title': 'Working directory',
  'projectTab.workspace.placeholder': 'Path to working directory',
  'projectTab.workspace.save': 'Save',
  'projectTab.workspace.saving': 'Saving…',
  'projectTab.workspace.pathRequired': 'Path cannot be empty',
  'projectTab.workspace.hint': 'The project directory is the workspace where tools operate. If not set, the default directory is used.',
  'projectTab.invariants.title': 'Invariants',
  'projectTab.invariants.hint': 'Project rules and constraints the model must follow',
  'projectTab.invariants.placeholder': 'Describe project invariants…',
  'projectTab.invariants.save': 'Save',
  'projectTab.invariants.saving': 'Saving…',
  'projectTab.log.title': 'Log',
  'projectTab.log.hint': 'Project work log (maintained by the model via project_log_write)',
  // ADR-071 §2.4: project MCP scope (owner/lead/admin)
  'projectTab.mcp.title': 'MCP servers',
  'projectTab.mcp.empty': 'No MCP servers in the registry yet.',
  'projectTab.mcp.loadError': 'Failed to load the project MCP servers.',
  'projectTab.mcp.available': 'Available',
  'projectTab.mcp.defaultOn': 'Default on',
  'projectTab.mcp.systemHint': 'System server: managed globally by the administrator, but the project can also disable access for itself.',
  'projectTab.mcp.hint': '"Available" — the server is allowed for the project (otherwise it is unavailable even in existing sessions). "Default on" — enabled in new sessions.',
  'sessionTab.plan.title': 'Project plan',
  'sessionTab.plan.empty': 'No plan',
  'sessionTab.plan.hint': 'The project plan will appear here after plan_write',
  'sessionTab.plan.file': 'File',
  'sessionTab.plan.collapse': 'Collapse',
  'sessionTab.plan.expand': 'Expand',
  'sessionTab.todos.title': 'ToDo',
  'sessionTab.todos.empty': 'No tasks',
  'sessionTab.todos.hint': 'The todo list will appear after using the todo tools (todo_add / todo_write)',
  'sessionTab.todo.status.pending': 'Pending',
  'sessionTab.todo.status.in_progress': 'In progress',
  'sessionTab.todo.status.completed': 'Completed',
  'sessionTab.todo.status.cancelled': 'Cancelled',
  'sessionTab.todo.priority.high': 'High',
  'sessionTab.todo.priority.medium': 'Medium',
  'sessionTab.todo.priority.low': 'Low',
  // ADR-069 §9.3: project instructions (AGENTS.md chain/sources)
  'sessionTab.instructions.title': 'Project instructions',
  'sessionTab.instructions.summary': '{count, plural, one {# file} other {# files}} · {chars} chars',
  'sessionTab.instructions.truncatedCount': '{count, plural, one {# file truncated} other {# files truncated}}',
  'sessionTab.instructions.blockedCount': '{count, plural, one {# file blocked} other {# files blocked}}',
  'sessionTab.instructions.disabled': 'Project instructions are disabled in the configuration',
  'sessionTab.instructions.noProject': 'The session is not linked to a project — project instructions are unavailable',
  'sessionTab.instructions.empty': 'No project instruction files found',
  'sessionTab.instructions.loadError': 'Failed to load project instructions',
  'sessionTab.instructions.retry': 'Retry',
  'sessionTab.instructions.chars': 'characters',
  'sessionTab.instructions.truncated': 'truncated',
  'sessionTab.instructions.suspicious': 'suspicious',
  'sessionTab.instructions.status.loaded': 'Loaded',
  'sessionTab.instructions.status.truncated': 'Truncated',
  'sessionTab.instructions.status.blocked': 'Blocked',
  'sessionTab.instructions.status.dedup': 'Duplicate',
  'sessionTab.instructions.status.skipped': 'Skipped',
  'sessionTab.instructions.status.untrusted': 'Untrusted',
  'sessionTab.instructions.status.skipped-install-tree': 'Install tree',
  'sessionTab.instructions.status.excluded': 'Excluded',
  'sessionTab.instructions.status.fetch-error': 'Fetch error',
  'rightPanel.context.sectionOptimization': 'Context optimization',
  'rightPanel.context.optimization': 'Mode',
  'rightPanel.context.optimization.none': 'None',
  'rightPanel.context.optimization.sliding_window': 'Sliding window',
  'rightPanel.context.optimization.summarization': 'Summarization',
  'rightPanel.context.optimization.compaction': 'Compaction',
  'rightPanel.context.stickyNotes': 'Sticky notes',
  'rightPanel.context.sectionSlidingWindow': 'Sliding window',
  'rightPanel.context.sectionWindowSize': 'WINDOW SIZE',
  'rightPanel.context.windowType': 'Window type',
  'rightPanel.context.windowType.messages': 'By messages',
  'rightPanel.context.windowType.tokens': 'By tokens',
  'rightPanel.context.windowMessages': 'N messages',
  'rightPanel.context.windowTokens': '% window fill',
  'rightPanel.context.sectionSummarization': 'Summarization',
  'rightPanel.context.summarizationEnabled': 'Auto-summarize',
  'rightPanel.context.afterN': 'After N messages',
  'rightPanel.context.tokenThreshold': '% context window',
  'rightPanel.context.triggersGroup': 'TRIGGERS',
  'rightPanel.context.compressionGroup': 'COMPRESSION',
  'rightPanel.context.summarizationKeepTokens': 'Verbatim tail, tokens',
  'rightPanel.context.compactionThreshold': '% window (threshold)',
  'rightPanel.context.compactionKeepTokens': 'Verbatim tail, tokens',
  'rightPanel.context.sectionCommon': 'Common',
  'rightPanel.context.windowThreshold': '% fill (trigger)',
  'rightPanel.context.sectionActions': 'Actions',
  'rightPanel.context.summarizeNow': 'Summarize now',
  'rightPanel.context.summarizeEnqueued': 'Summarization enqueued',
  'rightPanel.context.summarizationPendingBanner': 'Compacting context…',
  'rightPanel.context.summarizationCancelled': 'Summarization cancelled',
  'rightPanel.context.notEnoughMessages': 'Not enough messages to summarize',
  'rightPanel.context.checkTriggers': 'Check triggers',
  'rightPanel.context.hint.slidingWindow': 'Messages outside the window will be disabled automatically. Pinned messages are never disabled.',
  'rightPanel.context.hint.summarization': 'When the trigger fires, the older part of the history is compressed into a summary, while the token tail stays verbatim.',
  'rightPanel.context.hint.compaction': 'Compaction keeps the working state of the code rather than a retelling of the conversation: paths, commands, errors and decisions. The token tail stays verbatim.',
  'rightPanel.context.summarizing': 'Summarizing...',
  'rightPanel.context.summarized': 'Summarization complete',
  'rightPanel.context.summarizeError': 'Summarization error',
  'rightPanel.context.triggerCheckResult': 'Triggers: SW={sw}, SUM={sum}',
  'rightPanel.context.notLoaded': 'Session not loaded',
  'rightPanel.context.noStickyNotes': 'No notes',
  'rightPanel.context.hint.stickyNotes': 'Notes are added to the system prompt and visible to the model in every request.',
  // Scheduler (ADR-051/ADR-089)
  'rightPanel.scheduler.add': 'Add schedule',
  'rightPanel.scheduler.count': '{count, plural, one {# schedule} other {# schedules}}',
  'rightPanel.scheduler.empty': 'No schedules configured',
  'rightPanel.scheduler.loadError': 'Failed to load schedules',
  'rightPanel.scheduler.saved': 'Schedule saved',
  'rightPanel.scheduler.saveError': 'Failed to save the schedule: {error}',
  'rightPanel.scheduler.deleted': 'Schedule deleted',
  'rightPanel.scheduler.deleteError': 'Failed to delete the schedule: {error}',
  'rightPanel.scheduler.deleteTitle': 'Delete schedule',
  'rightPanel.scheduler.deleteConfirm': 'Delete schedule "{name}"? This action cannot be undone.',
  'rightPanel.scheduler.run': 'Run now',
  'rightPanel.scheduler.runSuccess': 'Schedule triggered',
  'rightPanel.scheduler.runError': 'Failed to run the schedule: {error}',
  'rightPanel.scheduler.toggleError': 'Failed to update the schedule: {error}',
  'rightPanel.scheduler.trigger.cron': 'Cron',
  'rightPanel.scheduler.trigger.every': 'Interval',
  'rightPanel.scheduler.target.bound': 'Session',
  'rightPanel.scheduler.target.ephemeral': 'Ephemeral session',
  'rightPanel.scheduler.target.queue': 'Queue',
  'rightPanel.scheduler.target.pipeline': 'Pipeline',
  'rightPanel.scheduler.target.pipelineRun': 'Pipeline run',
  'rightPanel.scheduler.field.name': 'Name',
  'rightPanel.scheduler.field.enabled': 'Enabled',
  'rightPanel.scheduler.field.trigger': 'Trigger',
  'rightPanel.scheduler.field.cron': 'Cron (5 fields, UTC)',
  'rightPanel.scheduler.field.every': 'Interval',
  'rightPanel.scheduler.field.target': 'Target',
  'rightPanel.scheduler.field.session': 'Session',
  'rightPanel.scheduler.field.agent': 'Agent',
  'rightPanel.scheduler.field.project': 'Project',
  'rightPanel.scheduler.field.ttl': 'TTL',
  'rightPanel.scheduler.field.prompt': 'Prompt',
  'rightPanel.scheduler.field.pipeline': 'Pipeline',
  'rightPanel.scheduler.field.payload': 'Payload (JSON)',
  'rightPanel.scheduler.field.nameTooltip': 'Schedule name shown in the list and job history.',
  'rightPanel.scheduler.field.enabledTooltip': 'Disabled schedules are kept but never fire.',
  'rightPanel.scheduler.field.triggerTooltip': 'Cron expression or a fixed interval between runs.',
  'rightPanel.scheduler.field.cronTooltip': 'Five fields (minute hour day month weekday) in UTC.',
  'rightPanel.scheduler.field.everyTooltip': 'Delay between runs (30s, 15m, 1h, 24h).',
  'rightPanel.scheduler.field.targetTooltip': 'Where the fired event goes: an existing session, a temporary session, the queue or a pipeline run.',
  'rightPanel.scheduler.field.sessionTooltip': 'Target session for bound/queue delivery.',
  'rightPanel.scheduler.field.agentTooltip': 'Agent template used to create a temporary session.',
  'rightPanel.scheduler.field.projectTooltip': 'Project container for the temporary session.',
  'rightPanel.scheduler.field.ttlTooltip': 'Lifetime of the temporary session (default — instance setting).',
  'rightPanel.scheduler.field.promptTooltip': 'Text delivered to the target session on each run.',
  'rightPanel.scheduler.field.pipelineTooltip': 'Project pipeline whose run is started by the schedule.',
  'rightPanel.scheduler.field.pipelineProjectTooltip': 'Project owning the pipeline — the run lives in the project.',
  'rightPanel.scheduler.field.payloadTooltip': 'Run input data — passed to the run as trigger.payload.',
  'rightPanel.scheduler.field.payloadHint': 'Run input → trigger.payload; for the memory template use {"sessionId":"ses_1"}.',
  'rightPanel.scheduler.form.new': 'New schedule',
  'rightPanel.scheduler.form.edit': 'Edit schedule',
  'rightPanel.scheduler.form.nameRequired': 'Name is required',
  'rightPanel.scheduler.form.sessionRequired': 'Select a session',
  'rightPanel.scheduler.form.projectRequired': 'Select a project',
  'rightPanel.scheduler.form.pipelineRequired': 'Select a pipeline',
  'rightPanel.scheduler.form.payloadInvalid': 'Payload must be a JSON object',
  'rightPanel.scheduler.form.cronRequired': 'Cron expression is required',
  'rightPanel.scheduler.form.everyRequired': 'Interval is required',
  'rightPanel.scheduler.selectSession': 'Select a session',
  'rightPanel.scheduler.selectAgent': 'Default agent',
  'rightPanel.scheduler.selectProject': 'No project',
  'rightPanel.scheduler.selectPipeline': 'Select a pipeline',
  'rightPanel.scheduler.pipelineLoading': 'Loading pipelines…',
  'rightPanel.scheduler.pipelineNone': 'This project has no pipelines',
  'rightPanel.scheduler.pipelineNotPublished': 'Pipeline is not published: it needs a publication, otherwise the job will fail.',
  'rightPanel.scheduler.ttlDefault': 'Default',
  'rightPanel.scheduler.row.trigger': 'Trigger',
  'rightPanel.scheduler.row.target': 'Target',
  'rightPanel.scheduler.row.nextRun': 'Next run',
  'rightPanel.scheduler.row.lastRun': 'Last run',
  'rightPanel.scheduler.row.lastStatus': 'Status',
  'rightPanel.scheduler.row.lastError': 'Error',
  'rightPanel.scheduler.status.enabled': 'enabled',
  'rightPanel.scheduler.status.disabled': 'disabled',
  'rightPanel.scheduler.status.ok': 'ok',
  'rightPanel.scheduler.status.error': 'error',
  'rightPanel.scheduler.status.skipped': 'skipped',
  'rightPanel.scheduler.history.title': 'Run history',
  'rightPanel.scheduler.history.empty': 'No runs yet',
  'rightPanel.scheduler.history.loadError': 'Failed to load run history: {error}',
  'rightPanel.scheduler.history.trigger.cron': 'Cron',
  'rightPanel.scheduler.history.trigger.manual': 'Manual',
  'rightPanel.scheduler.history.trigger.catchup': 'Catch-up',
  'rightPanel.scheduler.contextHint.text': 'For sessions triggered by the scheduler, enabling context optimization is recommended — it reduces token usage.',
  'rightPanel.scheduler.contextHint.action': 'Open "Context"',

  // Background processes and background sub-agents (PROP-096/097)
  'processes.title': 'Background processes',
  'processes.count': '{count, plural, one {# run} other {# runs}}',
  'processes.runningCount': '{count, plural, one {# running} other {# running}}',
  'processes.empty': 'No background processes',
  'processes.emptyHint': 'Background shell commands and background sub-agents appear here.',
  'processes.loadError': 'Failed to load background runs: {error}',
  'processes.filter.title': 'Filter by kind',
  'processes.filter.all': 'All',
  'processes.filter.process': 'Processes',
  'processes.filter.subagent': 'Sub-agents',
  'processes.filter.onlyCurrent': 'Current session only',
  'processes.status.running': 'running',
  'processes.status.completed': 'completed',
  'processes.status.failed': 'failed',
  'processes.status.cancelled': 'cancelled',
  'processes.status.orphaned': 'orphaned',
  'processes.action.stop': 'Stop',
  'processes.action.remove': 'Remove',
  'processes.action.openSession': 'Open session',
  'processes.action.showLog': 'Show log',
  'processes.action.hideLog': 'Hide log',
  'processes.action.refreshLog': 'Refresh log',
  'processes.log.truncated': 'The log was truncated (write limit reached)',
  'processes.log.empty': 'The log is empty',
  'processes.log.error': 'Failed to read the log: {error}',
  'processes.stopped': 'Background run stopped',
  'processes.removed': 'Background run removed',
  'processes.failed': 'Action failed: {error}',
  'processes.confirm.stopTitle': 'Stop background run',
  'processes.confirm.stopMessage': 'Stop "{name}"?',
  'processes.confirm.removeTitle': 'Remove background run',
  'processes.confirm.removeMessage': 'Remove "{name}" from the registry?',
  'processes.row.cwd': 'Directory',
  'processes.row.session': 'Session',
  'processes.row.agent': 'Agent',
  'processes.row.elapsed': 'Running for',
  'processes.row.finished': 'Finished',
  'processes.row.exitCode': 'Exit code',
  'processes.row.signal': 'Signal',

  // Center panel (tabs)
  'center.tab.chat': 'Chat',
  'center.tab.fileViewer': 'Viewer',
  'center.tab.fileEditor': 'Editor',
  'center.noTabs': 'No open tabs',
  'center.closeTab': 'Close tab',
  'center.tab.viewing': 'Viewing: {title}',
  'center.tab.editing': 'Editing: {title}',
  'center.tabTooltip.chat': 'Chat "{title}" — {project}',
  'center.tabTooltip.fileViewer': 'Viewing "{title}" — {project}',
  'center.tabTooltip.fileEditor': 'Editing "{title}" — {project}',
  'center.tabTooltip.commitDetail': 'Commit "{title}" — {project}',
  'center.tabTooltip.noProject.chat': 'Chat "{title}"',
  'center.tabTooltip.noProject.fileViewer': 'Viewing "{title}"',
  'center.tabTooltip.noProject.fileEditor': 'Editing "{title}"',
  'center.tabTooltip.noProject.commitDetail': 'Commit "{title}"',
  'center.tabTooltip.pipeline': 'Pipeline "{title}" — {project}',
  'center.tabTooltip.pipelineRun': 'Pipeline run "{title}" — {project}',
  'center.tabTooltip.noProject.pipeline': 'Pipeline "{title}"',
  'center.tabTooltip.noProject.pipelineRun': 'Pipeline run "{title}"',

  // Files
  'file.binaryFile': 'Binary file ({size} bytes)',
  'file.upload': 'Upload file',
  'file.download': 'Download',
  'file.move': 'Move',
  'file.moveError': 'Failed to move',
  'file.newFolder': 'New folder',
  'file.fileName': 'File name',
  'file.folderName': 'Folder name',
  'file.confirmDelete': 'Delete file «{name}»?',
  'file.loadError': 'File load error',
  'file.saveError': 'Save error',
  'file.unsavedChanges': 'Unsaved changes. Close anyway?',
  'file.saving': 'Saving...',
  'file.saved': 'Saved',
  'file.edit': 'Edit',
  'file.close': 'Close',
  'file.changedOnDisk': 'File changed on disk',
  'file.deletedOnDisk': 'File was deleted on disk',
  'file.reload': 'Reload',
  'file.workspaceRoot': 'Workspace root',
  'file.tooLarge': 'File is too large to view: {size}. Read limit is {limit}.',
  'file.binaryNotReadable': 'Binary files cannot be read in the editor.',
  'file.previewTooLarge': 'File is too large to preview: {size}. Preview limit is {limit}.',
  'file.previewFailed': 'Could not display the file.',
  'file.zoomIn': 'Zoom in',
  'file.zoomOut': 'Zoom out',
  'file.zoomReset': 'Reset zoom',
  'file.zoomLevel': '{percent}%',
  'file.markdownPreview': 'Preview',
  'file.markdownSource': 'Source',
  'file.openInNewTab': 'Open in new tab',
  'file.listTruncated': 'Not all entries are shown: the listing was truncated by the limit.',

  // Workspace picker
  'workspace.selectDirectory': 'Select workspace directory',
  'workspace.select': 'Select',
  'workspace.selected': 'Selected: {path}',
  'workspace.noneSelected': 'Nothing selected',
  'workspace.showHidden': 'Show hidden',
  'workspace.clear': 'Clear',
  'workspace.dialogTitle': 'Select directory',
  'workspace.selectCurrent': 'Select this folder',
  'workspace.goUp': 'Up',
  'workspace.newFolderPlaceholder': 'New folder name',
  'workspace.empty': 'No subdirectories',
  'workspace.loadError': 'Failed to load directory',
  'workspace.outsideRootConfirmTitle': 'Create outside workspace root?',
  'workspace.outsideRootConfirmMessage': 'Path “{path}” is outside the workspace root. Create it anyway?',
  'workspace.outsideRootSelectTitle': 'Select a directory outside the workspace root?',
  'workspace.outsideRootSelectMessage': 'Path “{path}” is outside the workspace root. Use it anyway?',
  'workspace.outsideRootHint': 'Outside workspace root',
  'workspace.error.denied': 'Path is outside the workspace root and denied by policy',
  'workspace.error.confirmRequired': 'Confirmation is required to create a directory outside the workspace root',
  'workspace.error.createFailed': 'Failed to create directory: {error}',
  'workspace.error.alreadyExists': 'A directory with this name already exists',
  'workspace.managedReadOnly': 'Managed deployment: paths outside the workspace root are not available',
  'workspace.autoManaged': 'The workspace is created automatically by the server',
  'workspace.policy.title': 'Paths outside workspace root',
  'workspace.policy.description': 'Policy for absolute project workspace paths outside the workspace root',
  'workspace.policy.confirm': 'Ask for confirmation',
  'workspace.policy.deny': 'Deny',
  'workspace.policy.overridden': 'Overridden at runtime',
  'workspace.policy.default': 'Default',

  // Files tab
  'files.toolbar.newFolder': 'New folder',
  'files.toolbar.showHidden': 'Show hidden',
  'files.toolbar.selectionMode': 'Select mode',
  'files.toolbar.exitSelection': 'Exit selection',
  'files.bulkSelectedCount': 'Selected: {count}',
  'files.bulkDelete': 'Delete selected',
  'files.confirmBulkDelete': 'Delete {count} selected items?',
  'files.showMore': 'Show {count} more',
  'files.showFewer': 'Show fewer',
  'files.newFile': 'New file',
  'files.rename': 'Rename',
  'files.renamePrompt': 'New name:',

  // Status bar
  'statusBar.noMessages': 'No notifications',
  'statusBar.clearAll': 'Clear all',
  'statusBar.showHistory': 'Show history',
  'statusBar.hideHistory': 'Hide history',

  // Chat
  'chat.input.placeholder': 'Type a message... Use @ to mention an agent',
  'chat.input.readOnly': 'Read-only — this is a subagent session',
  'chat.input.send': 'Send',
  'chat.input.createNote': 'Create note',
  'chat.input.createNoteLimit': 'Note limit reached ({maxCount})',
  // Notes (sticky notes): лимиты инстанса при создании
  'chat.notes.tooLong': 'The note is too long: maximum {maxChars} characters',
  'chat.notes.limitReached': 'Note limit reached: at most {maxCount} notes per session',
  'chat.notes.invalid': 'The note was rejected: maximum {maxChars} characters',
  'chat.notes.panelTitle': 'Notes: {active}/{maxCount}',
  'chat.notes.panelTitlePlain': 'Notes: {active}',
  'chat.notes.limitBadge': 'limit',
  'chat.notes.limitHint': 'Note limit reached: {maxCount}',
  'chat.input.stop': 'Stop',
  'chat.input.mentionHint': 'Mention an agent with @',
  'chat.input.enqueue': 'Enqueue',

  // --- Steering: interrupting the running turn (ADR-104) ---
  // No "intervened in turn" marker anymore: a joined reply is rendered as a
  // plain bubble (ADR-118 §4).
  'chat.steer.interruptMarker': 'Turn interrupted',

  // Markdown в ответах: заголовок блока кода, кнопки копирования и скачивания.
  'markdown.code.copy': 'Copy',
  'markdown.code.copied': 'Copied',
  'markdown.code.download': 'Download',
  'markdown.code.downloaded': 'Downloaded',

  'chat.actions.copy': 'Copy',
  'chat.actions.copyHint': 'Copy · Shift for plain text',
  'chat.actions.toggleOff': 'Disable',
  'chat.actions.toggleOn': 'Enable',
  'chat.actions.pin': 'Pin',
  'chat.actions.unpin': 'Unpin',
  'chat.actions.delete': 'Delete',
  'chat.actions.deleteConfirm': 'Delete message?',
  'chat.actions.retry': 'Retry',
  'chat.actions.retryConfirm': 'Retry? This and subsequent messages will be disabled.',
  'chat.actions.return': 'Return to input',
  'chat.actions.fork': 'Create branch',
  'chat.actions.debug': 'Debug',

  // ADR-046 §7.1: нейтральный system-блок системной (builtin) команды
  'chat.command.title': 'Command',
  'chat.command.copy': 'Copy',

  // ADR-046 §7.1: единый Notice служебных сообщений
  'chat.notice.summary': 'Summary',
  'chat.notice.debug': 'Debug',
  'chat.notice.error': 'Error',
  'chat.notice.info': 'Info',
  // ADR-118/restart recovery: a turn continued automatically after restart.
  'chat.notice.restartResumed': 'Work resumed after restart',
  'chat.notice.restartResumedText': 'The turn was interrupted by an instance restart and continued automatically',
  'chat.notice.scheduler': 'Scheduler',
  'chat.notice.schedulerNamed': 'Scheduler · {name}',
  // ADR-115: an attachment delivered by a tool — service block.
  'chat.notice.toolAttachment': 'Agent · {name} · attachment',
  'chat.notice.toolAttachmentAnonymous': 'Agent · attachment',
  // ADR-089: external event without a sender name — neutral author label.
  'chat.author.external': 'External sender',
  // ADR-111/ADR-113: уведомление о завершении фонового прогона.
  'chat.notice.backgroundProcess': 'Background process · {name}',
  'chat.notice.backgroundSubagent': 'Background subagent · {name}',
  'chat.notice.backgroundState.completed': 'completed',
  'chat.notice.backgroundState.failed': 'failed',
  'chat.notice.backgroundState.cancelled': 'stopped',
  // ADR-111/ADR-113: ретрансляция результата из дочерней сессии.
  'chat.backgroundNotice.relayedFrom': 'started in “{title}”',
  // ADR-111/ADR-113: UI-уведомления о старте/финише фоновой работы.
  'notify.background.started': 'Background process started: {name}',
  'notify.background.subagentStarted': 'Background subagent started: {name}',
  'notify.background.completed': 'Background process completed: {name}',
  'notify.background.failed': 'Background process failed: {name}',
  'notify.background.cancelled': 'Background process stopped: {name}',
  'notify.background.subagentCompleted': 'Background subagent completed: {name}',
  'notify.background.subagentFailed': 'Background subagent failed: {name}',
  'notify.background.subagentCancelled': 'Background subagent stopped: {name}',
  // ADR-111 §detach: moving a running run to the background.
  'chat.background.move': 'Move to background',
  'chat.background.hint': 'ctrl+b',
  'notify.background.moved': 'Moved to background: {count}',
  'notify.background.moveFailed': 'Failed to move to background',
  // ADR-112: notification about a user question (the session is not open).
  'notify.question.asked': 'Agent is waiting for an answer: {name}',
  'notify.steer.dropped.limit': 'Per-turn intervention limit: messages not applied — {count}',
  'notify.steer.dropped.aborted': 'Turn stopped — interventions not applied: {count}',
  'notify.steer.dropped.turn_ended': 'Turn already finished — interventions not applied: {count}',
  'chat.notice.copy': 'Copy',

  'chat.message.copied': 'Copied',
  'chat.message.disabled': 'Message disabled',
  'chat.message.enabled': 'Message enabled',
  'chat.message.pinned': 'Pinned',
  'chat.message.unpinned': 'Unpinned',
  'chat.message.deleted': 'Message deleted',
  'chat.message.retrying': 'Returned to input',
  'chat.message.forked': 'Branch created',
  'chat.message.empty': 'Empty message',
  // Agent answer expanded to the full chat column width
  'chat.message.expand': 'Expand',
  'chat.message.collapse': 'Collapse',

  // ADR-070 §2.6: per-message answer stats
  'chat.messageStats.stopped': 'Stopped',
  'chat.messageStats.error': 'Error',
  'chat.messageStats.limit': 'Iteration limit',
  'chat.messageStats.interrupted': 'Interrupted',
  'chat.messageStats.cache': '{pct} cache',
  'chat.messageStats.in': 'in',
  'chat.messageStats.out': 'out',
  'chat.messageStats.speed': '{speed}',
  'chat.messageStats.cost': '{cost}',
  'chat.messageStats.toggle': 'Response stats',

  'chat.session.cleared': 'Session cleared',

  'chat.reasoning.show': 'Reasoning',
  'chat.reasoning.hide': 'Hide',

  'chat.stream.error': 'Error',

  'chat.toolCall.title': 'Tool call',

  'chat.toolCall.expand': 'Expand',

  'chat.toolCall.collapse': 'Collapse',

  'chat.toolCall.running': 'Running:',

  'chat.toolCall.done': 'Done:',

  'chat.toolCall.error': 'Error:',

  'chat.toolCall.result': 'Result',

  'chat.toolCall.arguments': 'Arguments',

  'chat.toolCall.debug': 'raw',

  'chat.toolCall.iteration': 'Iteration {n}',

  'chat.subagent.title': 'Subagent',
  'chat.subagent.steps': 'steps',
  'chat.subagent.open': 'Open',
  'chat.subagent.errorStopped': 'Subagent stopped: provider error',
  'chat.subagent.errorAttempts': 'attempts: {attempts}/{max}',
  'chat.subagent.resume': 'Resume',
  'chat.subagent.resuming': 'Resuming…',
  'chat.subagent.stop': 'Stop',
  'chat.subagent.resumeFailed': 'Failed to resume subagent',
  'chat.subagent.stepsLoading': 'Loading steps…',
  'chat.subagent.stepsFailed': 'Failed to load steps',
  'chat.subagent.stepsRetry': 'Retry',

  'chat.streamError.generic': 'Processing stopped: provider error',
  'chat.streamError.contextLength': 'Model context window exceeded. Start a new session or shorten the history',
  'chat.streamError.authFailed': 'Provider authentication error. Check the API key in provider settings',
  'chat.streamError.retry': 'Retry',
  'chat.streamError.retrySent': 'Request sent again',
  'chat.streamError.providerDisabled': 'Provider is disabled — choose another model',
  'chat.streamError.modelDisabled': 'Model is disabled — choose another model',
  'chat.sendBlocked.providerDisabled': 'Provider "{provider}" is disabled — choose another model',
  'chat.sendBlocked.modelDisabled': 'Model {provider}/{model} is disabled — choose another model',

  'chat.context.warning80': 'Context is {percent}% full — the model may lose quality',
  'chat.context.blockTitle': 'Context is {percent}% full — {used} of {max} tokens',
  'chat.context.blockHint': 'The model may lose quality and the turn may be cut off',
  'chat.context.details': 'What to do',
  'chat.context.actionSummarize': 'Summarize the context: use the summarize button in the chat header or start a new session',
  'chat.context.actionAuto': 'Enable auto-summarization or a sliding history window',
  'chat.context.actionDisable': 'Disable some messages or answers to shorten the history',
  'chat.context.estimated': 'The model has no context window set — an estimate of {max} tokens is used',
  'chat.error.retryLast': 'Failed to retry the request:',

  'chat.queue.stalled': 'Processing stopped: {count} messages',
  'chat.queue.pending': 'In queue: {count}',
  'chat.queue.resume': 'Resume',
  'chat.queue.clear': 'Clear',
  'chat.queue.return': 'Return to input',
  'chat.queue.cleared': 'Queue cleared',
  'chat.queue.resumed': 'Queue processing resumed',
  'chat.queue.returned': 'Queue returned',
  'chat.queue.empty': 'Queue is empty',
  'chat.queue.steer': 'Send now',
  'chat.queue.remove': 'Remove',
  'chat.queue.steered': 'Sent into the running turn',
  'chat.queue.itemQueued': 'Queued',
  'chat.queue.itemStarting': 'Starting',
  'chat.queue.changed': 'The queue changed — refreshed',

  'permission.bar.request': 'Tool "{tool}" requests permission',
  'permission.bar.waiting': '{count} more',
  'permission.bar.details': 'Details',
  'permission.bar.hide': 'Hide',
  'permission.bar.reason': 'Reason',
  'permission.bar.params': 'Arguments',
  'permission.bar.allowOnce': 'Allow once',
  'permission.bar.allowSession': 'Allow in session',
  'permission.bar.deny': 'Deny',
  'permission.bar.allowOnceHint': 'Allow this call once',
  'permission.bar.allowSessionHint': 'Allow calls within this session',
  'permission.bar.stopTimer': 'Stop timer',
  'permission.bar.stopTimerHint': 'Disable auto-deny by timeout and wait for your answer',
  'permission.bar.noTimeout': 'waiting without timeout',
  'permission.bar.timeoutTitle': 'Time until request auto-denied',
  'permission.bar.grantedForSession': 'Tool {tool} allowed for the session',
  'permission.bar.replyFailed': 'Could not send the answer — the request is still open',

  // User questions (stage 1 roadmap 0.13 — block 1.3): dock above the composer.
  'question.dock.title': 'The agent asked a question',
  'question.dock.custom': 'Your own answer',
  'question.dock.submit': 'Answer',
  'question.dock.cancel': 'Cancel',
  'question.dock.next': 'Next',
  'question.dock.prev': 'Back',
  'question.dock.progress': '{current} of {total}',
  'question.dock.required': 'Answer every question',
  'question.dock.failed': 'Failed to send the answer',
  'question.dock.cancelled': 'Question cancelled',
  'question.dock.multipleHint': 'You can select multiple options',
  // Dock collapsing and question navigation (dots instead of "1 of N").
  'question.dock.collapse': 'Collapse',
  'question.dock.expand': 'Expand',
  'question.dock.collapsedTitle': 'Question {current} of {total}',
  'question.dock.collapsedSummary': 'answered {answered}/{total}',
  'question.dock.dots.aria': 'Question {n}',
  // Final review of the answers before sending.
  'question.dock.review.open': 'Review',
  'question.dock.review.title': 'Review answers',
  'question.dock.review.collapsed': 'Review answers · {answered}/{total}',
  'question.dock.review.edit': 'Edit',
  'question.dock.review.submit': 'Send',
  'question.dock.review.back': 'Back',
  'question.dock.review.unanswered': 'No answer',
  // Countdown to the question expiry (dock header).
  'question.dock.timeLeft': 'Time left {time}',
  'question.dock.timeLeftAria': 'Question expires in {time}',

  'chat.error.rateLimit': 'Rate limit exceeded. Pause {sec}s...',
  'chat.error.retryCount': 'Attempt {current}/{max}',
  'chat.retry.inProgress': 'Retry {current}/{max} in {sec}s…',
  'chat.retry.now': 'Retry now',
  'chat.retry.cancel': 'Cancel',
  'chat.error.retryNow': 'Failed to retry now',
  'chat.error.cancelRetry': 'Failed to cancel retry',
  'chat.error.loadSession': 'Failed to load session',
  'chat.loadOlder': 'Load older messages',
  'chat.loadingOlder': 'Loading…',
  'chat.error.loadOlder': 'Failed to load older messages',
  'chat.error.resumeQueue': 'Failed to resume queue',
  'chat.error.clearQueue': 'Failed to clear queue',
  'chat.error.sendFailed': 'Send failed:',
  'chat.error.returnQueue': 'Failed to return queue',
  'chat.error.steerQueue': 'Could not send into the running turn',
  'chat.error.reorderQueue': 'Failed to reorder the queue',
  'chat.error.toggleMessage': 'Failed to toggle message',
  'chat.error.pinMessage': 'Failed to pin message',
  'chat.error.deleteMessage': 'Failed to delete message',
  'chat.error.retryMessage': 'Failed to retry message',
  'chat.error.clearSession': 'Failed to clear session',
  'chat.error.contextLength': 'Model context window exceeded. Start a new session or shorten the history',
  'chat.error.messageModelMismatch': 'The instance speaks an incompatible message protocol (client {client}, server {server}). Update the instance or the interface; the live event stream is not connected',

  'chat.error.forkFailed': 'Failed to create branch:',

  'chat.message.sent': 'Message sent',
  'chat.message.unconfirmed':
    'Message sent; confirmation is delayed — checking the queue',

  'chat.debug.noData': 'No debug data',
  'chat.queue.returnInDev': 'Return queue — in development',

  // Chat input footer
  'chat.footer.attach': 'Attach',
  'chat.footer.expand': 'Expand',
  'chat.footer.collapse': 'Collapse',
  'chat.footer.mode': 'Mode',

  // Attachments (ADR-115)
  'chat.attachments.attach': 'Attach file',
  'chat.attachments.disabled': 'Attachments are disabled by the administrator',
  'chat.attachments.remove': 'Remove',
  'chat.attachments.removeNamed': 'Remove “{name}”',
  'chat.attachments.retry': 'Retry upload',
  'chat.attachments.uploading': 'Uploading…',
  'chat.attachments.uploadingPercent': 'Uploading: {percent}%',
  'chat.attachments.error.upload': 'Failed to upload the file',
  'chat.attachments.error.tooLarge': 'File is larger than {max}',
  'chat.attachments.error.tooMany': 'No more than {max} files per message',
  'chat.attachments.gallery.close': 'Close',
  'chat.attachments.gallery.prev': 'Previous image',
  'chat.attachments.gallery.next': 'Next image',
  'chat.attachments.gallery.counter': '{index} / {total}',
  'chat.attachments.dropHint': 'Drop files to attach',
  'chat.attachments.waitUpload': 'Wait for the attachments to finish uploading',
  'chat.attachments.fixErrors': 'Remove failed attachments or retry the upload',
  'chat.attachments.added': '{count, plural, one {Attached # file} other {Attached # files}}',
  'chat.attachments.error.prepare': 'Failed to prepare the file',
  'chat.attachments.modelUnsupported':
    'The model {model} does not accept {kind} — the attachment will not reach it. Switch models.',
  'chat.attachments.kind.image': 'images',
  'chat.attachments.kind.audio': 'audio',
  'chat.attachments.kind.video': 'video',
  'chat.attachments.kind.pdf': 'PDF',

  // Attachments in a sent message (ADR-115, D2c)
  'chat.message.attachments.open': 'Open',
  'chat.message.attachments.audio': 'Audio',
  'chat.message.attachments.video': 'Video',
  'chat.message.attachments.file': 'File',
  'chat.message.attachments.imageAlt': 'Image “{name}”',

  // Session Plan/Act mode (ADR-025)
  'chat.mode.title': 'Session mode: Plan (read-only) / Act (full access) / YOLO (auto-approve)',
  'chat.mode.plan': 'Plan',
  'chat.mode.act': 'Act',
  'chat.mode.yolo': 'YOLO',
  'chat.mode.yoloHint': 'Auto-approve all requests',
  'chat.mode.planEnabled': 'Plan mode enabled',
  'chat.mode.actEnabled': 'Act mode enabled',
  'chat.mode.yoloEnabled': 'YOLO mode enabled',
  'chat.mode.unavailable': 'This agent has no mutation tools — mode unavailable',
  'chat.mode.error': 'Failed to change mode:',

  // Connection indicator
  'connection.idle': 'No session',
  'connection.ws': 'WebSocket connected',
  'connection.sse': 'SSE mode (WebSocket unavailable)',
  'connection.disconnected': 'Backend unavailable',
  'connection.sessionExpired': 'Your session has expired or the server was restarted. Please sign in again.',
  'connection.lost': 'Connection lost. Reconnecting…',
  'connection.offline': 'No network connection.',
  'connection.reloadTitle': 'Connection not restored',
  'connection.reloadMessage': 'Could not restore the connection. Reload the page?',
  'connection.reloadConfirm': 'Reload',
  'connection.reloadCancel': 'Wait',

  // Transport modes
  'transport.auto': 'Auto',
  'transport.ws': 'WebSocket',
  'transport.sse': 'SSE',
  'transport.autoDesc': 'Auto: WS, fallback to SSE',
  'transport.wsDesc': 'WebSocket only',
  'transport.sseDesc': 'SSE only',

  // Hybrid mode (local core + remote backend)
  'hybrid.local': 'local',
  'hybrid.remote': 'remote',
  'hybrid.enabled': 'Server',
  'hybrid.connected': 'Server: connected',
  'hybrid.disconnected': 'Server: unavailable',
  'hybrid.statusTitle': 'Hybrid mode',
  'hybrid.confirmDeleteRemoteProject': 'Delete remote project? The action will be performed on the server.',
  'hybrid.confirmDeleteRemoteSession': 'Delete remote session? The action will be performed on the server.',
  'hybrid.createWhere': 'Create where',
  'hybrid.createLocal': 'Local',
  'hybrid.createRemote': 'On server',
  'hybrid.createSessionLocal': 'Create session locally',
  'hybrid.createSessionRemote': 'Create session on server',
  'hybrid.createRemoteNoProject': 'A session on the server is created without a project (the server does not know local projects)',
  'hybrid.offline': 'Server unavailable — remote projects and sessions are inactive',
  'hybrid.offlineBanner': 'Server unavailable — remote projects/sessions are inactive. Local ones still work.',
  'hybrid.offlineShort': 'Server unavailable',
  'hybrid.unavailableNode': 'unavailable',
  'hybrid.publishProject': 'Publish to server',
  'hybrid.cloneProject': 'Clone locally',
  'hybrid.publishDialog.title': 'Publish project',
  'hybrid.publishDialog.subtitle': 'Project sessions and files will be transferred to the server.',
  'hybrid.publishDialog.new': 'Create a new project on the server',
  'hybrid.publishDialog.existing': 'Update an existing project',
  'hybrid.publishDialog.noRemoteProjects': 'No remote projects — a new one will be created',
  'hybrid.publishDialog.selectPlaceholder': 'Select a project on the server',
  'hybrid.publishDialog.overwriteHint': 'Sessions and files of the selected project will be overwritten',
  'hybrid.publishDialog.publish': 'Publish',
  'hybrid.publishDialog.publishing': 'Publishing...',
  'hybrid.publishDialog.success': 'Project «{name}» published to the server',
  'hybrid.forkDialog.title': 'Clone project',
  'hybrid.forkDialog.subtitle': 'Project sessions and files will be copied locally.',
  'hybrid.forkDialog.localName': 'Local copy name',
  'hybrid.forkDialog.nameCollision': 'A project with this name already exists locally — choose another name',
  'hybrid.forkDialog.clone': 'Clone',
  'hybrid.forkDialog.cloning': 'Cloning...',
  'hybrid.forkDialog.success': 'Project «{name}» cloned locally',

  // Session settings
  'sessionSettings.providerModel': 'Provider & Model',
  'sessionSettings.model': 'Model',
  'sessionSettings.debug': 'Debug',
  'sessionSettings.debugOn': 'On',
  'sessionSettings.debugOff': 'Off',
  'sessionSettings.tokens': 'Tokens',
  'sessionSettings.askTimeout': 'Approval timeout',
  'sessionSettings.askTimeoutSeconds': 'Approval timeout (sec)',
  'sessionSettings.askTimeoutEnabled': 'Enabled',
  'sessionSettings.askTimeoutDisabled': 'Disabled',
  // Response limit (`max_tokens`, 0 = auto)
  'sessionSettings.maxTokens': 'Response limit',
  'sessionSettings.maxTokensHint': '0 — auto: the model limit from the catalog or the instance (8192 by default). Models with mandatory reasoning have a minimum of 8192, because thinking consumes the same budget.',
  // ADR-029: session approvals
  'sessionSettings.allow.title': 'Session approvals',
  'sessionSettings.allow.empty': 'No approved tools',
  'sessionSettings.allow.hint': 'Allow-rules appear after "Allow in session" in the approval panel',
  'sessionSettings.allow.remove': 'Remove',
  // Micro-layer (quick answers) per session
  'sessionSettings.micro.title': 'Quick answers',
  'sessionSettings.micro.tooltip': 'Simple requests — greetings, yes/no, task classification — are handled instantly by rules or embeddings, without calling the large model. This speeds up responses and saves tokens. If a request is complex or confidence is low, the LLM is called automatically. The confidence threshold is configured below.',
  'sessionSettings.micro.confidence': 'Confidence threshold',
  'sessionSettings.micro.embedding': 'Embedding',
  'sessionSettings.micro.embeddingHint': 'Embedding model for semantic classification in the micro-layer',
  'sessionSettings.micro.embeddingModel': 'Embedding model',
  'sessionSettings.micro.decision': 'Decision level',
  'sessionSettings.micro.decisionHint': 'Decision-model (Clef/System One) classification in the micro-cascade follows the global decision setting. Turning it off forcibly disables the level for this session.',
  'sessionSettings.routing.tooltip': 'Requests not handled by Quick answers are distributed across models automatically: the strategy picks a model by task type (coding/chat/research), by cost, or a combination. Additionally, quality control applies: if the answer is uncertain or too short, the request is forwarded to a fallback model. If routing is off, the model selected in the session is used.',
  // ADR-071 §2.4: MCP scope in session
  'sessionSettings.mcp.title': 'MCP servers',
  'sessionSettings.mcp.hint': 'Session-level toggle. Overrides project settings.',
  'sessionSettings.mcp.toggleLabel': 'Enabled',

  // ADR-046 §4.5/§8.2/§9.3: skills & commands (panels, stats, autocomplete)
  'sessionSettings.skills.title': 'Skills',
  'sessionSettings.skills.hint': 'Session-level toggle. Overrides project settings.',
  'sessionSettings.skills.toggleLabel': 'Enabled',
  'sessionSettings.skills.enabled': 'enabled in this session',
  'sessionSettings.skills.notEnabled': 'not enabled',
  'sessionSettings.skills.disabled': 'disabled',
  'sessionSettings.skills.enable': 'Enable skill',
  'sessionSettings.skills.disable': 'Disable skill',
  'sessionSettings.skills.disabledReason.session': 'session opt-out',
  'sessionSettings.skills.disabledReason.system': 'disabled by administrator',
  'sessionSettings.skills.disabledReason.project': 'not allowed by project',
  'projectTab.skills.title': 'Skills',
  'projectTab.skills.empty': 'No skills available to the project yet.',
  'projectTab.skills.available': 'Available',
  'projectTab.skills.defaultOn': 'Default on',
  'projectTab.skills.hint': '"Available" — the skill is allowed for the project (otherwise it is unavailable even in existing sessions). "Default on" — enabled in new sessions.',
  'projectTab.skills.forbidden': 'Insufficient permissions to manage project skills',
  'projectTab.skills.loadError': 'Failed to load the project skills.',
  'rightPanel.stats.skills': 'Skills',
  'rightPanel.stats.commands': 'Commands',
  'rightPanel.stats.colSkill': 'Skill',
  'rightPanel.stats.colEnabled': 'Enabled',
  'rightPanel.stats.colUnavailable': 'Unavailable reason',
  'rightPanel.stats.colTrusted': 'Trust',
  'rightPanel.stats.trusted': 'trusted',
  'rightPanel.stats.skillEnabled': 'enabled',
  'rightPanel.stats.skillDisabledReason.session': 'session opt-out',
  'rightPanel.stats.skillDisabledReason.system': 'disabled by administrator',
  'rightPanel.stats.skillDisabledReason.project': 'not allowed by project',
  'rightPanel.stats.skillSource.stable': 'stable',
  'rightPanel.stats.skillSource.session': 'session',
  'rightPanel.stats.skillSource.project': 'project',
  'rightPanel.stats.skillTokenEstimate': 'Estimated skill catalog contribution: ~{tokens} (chars {chars}, ratio {ratio})',
  'rightPanel.stats.skillsCatalogTokens': 'Skills catalog in prompt: ~{tokens} tokens',
  'rightPanel.stats.commandsCounters': 'Commands invoked',
  'rightPanel.stats.skillsCounters': 'Skills invoked',
  'rightPanel.stats.lastCommand': 'Last command',
  'rightPanel.stats.lastSkill': 'Last skill',
  'rightPanel.stats.noInvocations': 'No commands or skills invoked yet',

  // Right panel — "Memory" tab (ADR-107 / PROP-047)
  'rightPanel.memory.status': 'Status',
  'rightPanel.memory.readiness.ready': 'Ready',
  'rightPanel.memory.readiness.degraded': 'Degraded',
  'rightPanel.memory.readiness.unavailable': 'Unavailable',
  'rightPanel.memory.provider.active': 'Active',
  'rightPanel.memory.provider.inactive': 'Inactive',
  'rightPanel.memory.project': 'Project',
  'rightPanel.memory.noProject': 'No project',
  'rightPanel.memory.lastContext': 'In the last turn context',
  'rightPanel.memory.noTurns': 'Memory has not taken part in turns yet',
  'rightPanel.memory.block.facts': 'Facts',
  'rightPanel.memory.block.recall': 'Recall',
  'rightPanel.memory.block.notPassed': 'not passed',
  'rightPanel.memory.block.noFacts': 'Facts were not passed',
  'rightPanel.memory.block.noRecall': 'Recall is not passed when the turn has no question',
  'rightPanel.memory.block.loaded': 'Block passed in full',
  'rightPanel.memory.block.truncated': 'Block was truncated by the context budget',
  'rightPanel.memory.block.empty': 'No facts / nothing found',
  'rightPanel.memory.block.blocked': 'Blocked by policy',
  'rightPanel.memory.block.suppressed': 'Suppressed by settings',
  'rightPanel.memory.blockStatus.loaded': 'loaded',
  'rightPanel.memory.blockStatus.truncated': 'truncated',
  'rightPanel.memory.blockStatus.empty': 'empty',
  'rightPanel.memory.blockStatus.blocked': 'blocked',
  'rightPanel.memory.blockStatus.suppressed': 'suppressed',
  'rightPanel.memory.scope': 'Scope',
  'rightPanel.memory.scope.factsActive': 'Active facts',
  'rightPanel.memory.scope.indexesTotal': 'Indexes total',
  'rightPanel.memory.scope.indexesProject': 'Project indexes',
  'rightPanel.memory.scope.indexesInstance': 'Instance indexes',
  'rightPanel.memory.scope.indexesReady': 'Ready',
  'rightPanel.memory.scope.indexesBuilding': 'Building',
  'rightPanel.memory.scope.indexesFailed': 'Failed',
  'rightPanel.memory.hints': 'Hints',
  'rightPanel.memory.hint.failedIndexes': 'Some indexes failed — rebuild them',
  'rightPanel.memory.hint.providerInactive': 'Memory plugin is not active',
  'rightPanel.memory.control': 'Manage',
  'rightPanel.memory.control.projectMemory': 'Memory for project',
  'rightPanel.memory.control.projectMemoryHint':
    'Project facts and recall are used in the sessions of this project.',
  'rightPanel.memory.control.noProject':
    'Session has no project — project memory is not configurable',
  'rightPanel.memory.control.noProjectHint':
    'No project selected — only a shared facts index is available',
  'rightPanel.memory.control.forbidden': 'Not enough rights to change memory',
  'rightPanel.memory.control.notToggleable': 'This index cannot be disabled',
  'rightPanel.memory.control.mutationError': 'Memory operation failed: {error}',
  'rightPanel.memory.control.createIndex': 'Create index',
  'rightPanel.memory.control.name': 'Name',
  'rightPanel.memory.control.namePlaceholder': 'Index name',
  'rightPanel.memory.control.source': 'Source',
  'rightPanel.memory.control.scope': 'Scope',
  'rightPanel.memory.control.source.files': 'files',
  'rightPanel.memory.control.source.facts': 'facts',
  'rightPanel.memory.control.scope.project': 'Project',
  'rightPanel.memory.control.scope.instance': 'Instance',
  'rightPanel.memory.control.instanceFilesWarning':
    'The project workspace will be indexed and the index will be visible to all users of the instance.',
  'rightPanel.memory.control.projectRequired':
    'Select a project or a shared facts index',
  'rightPanel.memory.control.createSubmit': 'Create',
  'rightPanel.memory.control.createCancel': 'Cancel',
  'rightPanel.memory.indexes': 'Indexes',
  'rightPanel.memory.indexes.empty': 'No indexes yet',
  'rightPanel.memory.indexes.scope.project': 'Project',
  'rightPanel.memory.indexes.scope.instance': 'Shared',
  'rightPanel.memory.indexes.instanceLocked': 'Shared · cannot be disabled',
  'rightPanel.memory.indexes.enabled': 'used in recall',
  'rightPanel.memory.indexes.disabledHint': 'not used in recall',
  'rightPanel.memory.indexes.toggle': 'Use index "{name}" in recall',
  'rightPanel.memory.indexes.rebuild': 'Rebuild',
  'rightPanel.memory.indexes.state.building': 'building',
  'rightPanel.memory.indexes.state.ready': 'ready',
  'rightPanel.memory.indexes.state.stale': 'stale',
  'rightPanel.memory.indexes.state.failed': 'failed',
  'rightPanel.memory.loading': 'Loading memory data...',
  'rightPanel.memory.error': 'Failed to load memory data: {error}',
  'rightPanel.memory.unavailable': 'Memory service is not configured',
  'rightPanel.memory.retry': 'Retry',
  'rightPanel.memory.noSession': 'No active session',
  'rightPanel.memory.automation.title': 'Automation',
  'rightPanel.memory.automation.description':
    'Memory maintenance pipelines: prepare and publish them, then run once or on a schedule.',
  'rightPanel.memory.automation.extract.title': 'Extract facts from session',
  'rightPanel.memory.automation.extract.hint':
    'Reads the current session and writes stable statements to memory as facts.',
  'rightPanel.memory.automation.dedupe.title': 'Merge duplicate facts',
  'rightPanel.memory.automation.dedupe.hint':
    'Finds near-duplicate facts and consolidates them into one.',
  'rightPanel.memory.automation.dedupe.scheduleName': 'Memory: merge duplicate facts',
  'rightPanel.memory.automation.reindex.title': 'Reindex project',
  'rightPanel.memory.automation.reindex.hint':
    'Rebuilds the project memory index from the current workspace and facts.',
  'rightPanel.memory.automation.reindex.scheduleName': 'Memory: reindex project',
  'rightPanel.memory.automation.template.available': 'system template available',
  'rightPanel.memory.automation.template.missing': 'template not found (old server)',
  'rightPanel.memory.automation.pipeline.none': 'not prepared',
  'rightPanel.memory.automation.pipeline.published': 'published v{version}',
  'rightPanel.memory.automation.lastRun': 'Last run',
  'rightPanel.memory.automation.lastRun.none': 'not run yet',
  'rightPanel.memory.automation.prepare': 'Prepare pipeline',
  'rightPanel.memory.automation.run': 'Run now',
  'rightPanel.memory.automation.schedule': 'Schedule',
  'rightPanel.memory.automation.runBlocked': 'Prepare and publish the pipeline first',
  'rightPanel.memory.automation.loadError': 'Failed to load automation: {error}',
  'rightPanel.memory.automation.retry': 'Retry',
  'rightPanel.memory.automation.prepareError': 'Failed to prepare pipeline: {error}',
  'rightPanel.memory.automation.runError': 'Failed to start run: {error}',
  'rightPanel.memory.automation.status.pending': 'pending',
  'rightPanel.memory.automation.status.running': 'running',
  'rightPanel.memory.automation.status.awaiting_human': 'waiting',
  'rightPanel.memory.automation.status.done': 'completed',
  'rightPanel.memory.automation.status.failed': 'failed',
  'rightPanel.memory.automation.status.cancelled': 'cancelled',
  'chat.commandAutocomplete.title': 'Commands',
  'chat.commandAutocomplete.empty': 'No commands found',
  'chat.commandAutocomplete.keyboardHint': '↑↓ navigate • Enter select • Esc close',
  'chat.commandAutocomplete.unavailable': 'unavailable',

  // Chat settings
  'chatSettings.description': 'How messages and service steps are shown in the chat feed.',
  'chatSettings.viewMode': 'Message view',
  'chatSettings.viewModeDetailed': 'Detailed',
  'chatSettings.viewModeFeed': 'Feed',
  'chatSettings.viewModeDescription':
    'Feed shows agent answers as flat text without bubbles; user messages stay highlighted.',
  'chatSettings.intermediateTextDisplay': 'Intermediate responses',
  'chatSettings.intermediateTextInline': 'Between blocks',
  'chatSettings.intermediateTextBottom': 'At bottom',
  'chatSettings.intermediateTextDescription': 'How to display model answers between tool calls.',
  'chatSettings.density': 'Feed density',
  'chatSettings.densityDescription':
    'Compact density hides reasoning and tool calls for completed turns; the current turn always stays expanded.',
  'chatSettings.densityNormal': 'Normal',
  'chatSettings.densityCompact': 'Compact',
  'chatSettings.chatScale.label': 'Chat area scale',
  'chatSettings.chatScale.mobile': 'Mobile (chat)',
  'chatSettings.chatScale.desktop': 'Desktop (chat)',
  'chatSettings.chatScale.reset': 'Reset chat scale',
  'chatSettings.display.label': 'Feed display',
  'chat.compact.tools': '{count, plural, one {# tool} other {# tools}}',
  'chat.compact.reasoning': '{count, plural, one {# reasoning step} other {# reasoning steps}}',
  'chat.compact.hide': 'Hide',
  'chat.compact.expand': 'Show hidden turn activity',
  'chat.compact.collapse': 'Hide turn activity',

  // Model controls
  'chat.modelControls.searchModels': 'Search models...',
  'chat.modelControls.favorites': 'Favorites',
  'chat.modelControls.recent': 'Recent',
  'chat.modelControls.noModelsFound': 'No models found',
  'chat.modelControls.loadingMore': 'Loading…',
  'chat.modelControls.addNewProvider': 'Add provider',
  'chat.modelControls.keyboardHintNavigate': '↑↓ navigate',
  'chat.modelControls.keyboardHintTypeToSearch': 'Type to search',
  'chat.modelControls.refresh': 'Refresh',
  'chat.modelControls.collapseAll': 'Collapse all',
  'chat.modelControls.expandAll': 'Expand all',
  'chat.modelControls.searchAgents': 'Search agents...',
  'chat.modelControls.resetToDefault': 'Reset to default',
  'chat.modelControls.addToFavorites': 'Add to favorites',
  'chat.modelControls.removeFromFavorites': 'Remove from favorites',
  'chat.modelControls.noAgentsFound': 'No agents found',
  'chat.modelControls.agentProjectOnly': 'Available in project only',

  // Reasoning level
  'chat.reasoning.title': 'Reasoning level',
  'chat.reasoning.default': 'Default',
  'chat.reasoning.none': 'None',
  'chat.reasoning.low': 'Low',
  'chat.reasoning.medium': 'Medium',
  'chat.reasoning.high': 'High',

  // Notification settings
  'notifications.title': 'Notifications',
  'notifications.description': 'Enable or disable popup notification categories. History is always preserved in the status bar.',
  'notifications.category.connection': 'Connection (WS/SSE)',
  'notifications.category.connection.desc': 'Backend connection status changes',
  'notifications.category.streaming': 'Streaming',
  'notifications.category.streaming.desc': 'Generation start, completion, and cancellation',
  'notifications.category.queue': 'Queue',
  'notifications.category.queue.desc': 'Queue stalls, clearing, and resumption',
  'notifications.category.message': 'Messages',
  'notifications.category.message.desc': 'Sending, copying, and other message actions',
  'notifications.category.error': 'Errors',
  'notifications.category.error.desc': 'Send errors, loading failures, and other issues',
  'notifications.category.system': 'System',
  'notifications.category.system.desc': 'Informational system status messages',
  'notifications.dismiss': 'Dismiss',
  'notifications.popup.title': 'Notifications',
  'notifications.popup.noNotifications': 'No notifications',
  'notifications.popup.markAllRead': 'Mark all as read',
  'notifications.popup.openSettings': 'Notification settings',
  'notifications.popup.clear': 'Clear',

  // ========== Admin ==========

  // Admin nav
  'admin.title': 'Admin Panel',
  'admin.section.dashboard': 'Dashboard',
  'admin.section.sessions': 'Sessions',
  'admin.section.projects': 'Projects',
  'admin.section.providers': 'Providers',
  'admin.section.models': 'Models',
  'admin.section.agents': 'Agents',
  'admin.section.context': 'Context',
  'admin.section.users': 'Users',
  'admin.section.defaults': 'Settings',
  'admin.section.debug': 'Debug',

  // Dashboard
  'admin.dashboard.title': 'Dashboard',
  'admin.dashboard.subtitle': 'Synth system overview',
  'admin.dashboard.totalSessions': 'Total sessions',
  'admin.dashboard.projects': 'Projects',
  'admin.dashboard.users': 'Users',
  'admin.dashboard.version': 'Version',

  // Sessions
  'admin.sessions.title': 'Sessions',
  'admin.sessions.count': '{count, plural, one {# session} other {# sessions}}',
  'admin.sessions.refresh': 'Refresh',
  'admin.sessions.empty': 'No sessions',
  'admin.sessions.blocked': 'blocked',
  'admin.sessions.showMore': 'Show more',
  'admin.sessions.loadingMore': 'Loading…',
  'admin.sessions.hide': 'Hide',
  'admin.sessions.details': 'Details',
  'admin.sessions.unlock': 'Unlock',
  'admin.sessions.unlockError': 'Failed to unblock session',
  'admin.sessions.id': 'ID:',
  'admin.sessions.project': 'Project:',
  'admin.sessions.created': 'Created:',
  'admin.sessions.updated': 'Updated:',
  'admin.sessions.pending': 'Pending:',
  'admin.sessions.blockedStatus': 'Blocked:',

  // Projects
  'admin.projects.title': 'Projects',
  'admin.projects.count': '{count, plural, one {# project} other {# projects}}',
  'admin.projects.create': 'Create',
  'admin.projects.new': 'New project',
  'admin.projects.namePlaceholder': 'Project name',
  'admin.projects.name': 'Name',
  'admin.projects.nameRequired': 'Name is required',
  'admin.projects.createError': 'Create error',
  'admin.projects.cancel': 'Cancel',
  'admin.projects.empty': 'No projects',
  'admin.projects.memberCount': '{count, plural, one {# member} other {# members}}',
  'admin.projects.statusCount': '{count, plural, one {# status} other {# statuses}}',
  'admin.projects.confirmDelete': 'Delete project «{name}»?',

  // Default workspace
  'admin.projects.workspace.title': 'Default workspace',
  'admin.projects.workspace.placeholder': 'Path to workspace',
  'admin.projects.workspace.path': 'Path',
  'admin.projects.workspace.save': 'Save',
  'admin.projects.workspace.saving': 'Saving...',
  'admin.projects.workspace.saved': 'Workspace saved',
  'admin.projects.workspace.error': 'Failed to save workspace',
  'admin.projects.workspace.pathRequired': 'Path cannot be empty',
  'admin.projects.workspace.current': 'Current: {path}',
  'admin.projects.workspace.hint': 'Default: <dataDir>/workspaces/default. Can be overridden via env SYNTH_DEFAULT_WORKSPACE.',
  'admin.projects.workspace.adminOnly': 'Only an administrator can change the default workspace',

  // Providers
  'admin.providers.title': 'Providers',
  'admin.providers.count': '{count, plural, one {# provider} other {# providers}}',
  'admin.providers.add': 'Add',
  'admin.providers.edit': 'Edit provider',
  'admin.providers.new': 'New provider',
  'admin.providers.save': 'Save',
  'admin.providers.cancel': 'Cancel',
  'admin.providers.name': 'Name',
  'admin.providers.type': 'API type',
  'admin.providers.url': 'URL',
  'admin.providers.apiKey': 'API Key',
  'admin.providers.defaultModel': "Provider's default model",
  'admin.providers.defaultModelHint': 'Used as a fallback when a session or request has no model set. The global default pair is set in «Models».',
  'admin.providers.currency': 'Default currency',
  'admin.providers.currencyDefault': 'default',
  'admin.providers.currency.RUB': 'Ruble',
  'admin.providers.currency.USD': 'US Dollar',
  'admin.providers.currency.CNY': 'Yuan',
  'admin.providers.enabled': 'Provider enabled',
  'admin.providers.icon': 'Icon',
  'admin.providers.iconImage': 'Image (base64)',
  'admin.providers.iconUncompressed': 'Could not compress the icon — it will be saved as is',
  'admin.providers.reset': 'Reset',
  'admin.providers.autoDetectFavicon': 'Auto-detect (favicon)',
  'admin.providers.detect': 'Detect',
  'admin.providers.found': 'Found',
  'admin.providers.use': 'Use',
  'admin.providers.brand': 'Brand',
  'admin.providers.searchIcon': 'Search...',
  'admin.providers.noProviders': 'No providers',
  'admin.providers.test': 'Test',
  'admin.providers.testing': 'Testing...',
  'admin.providers.connectedSuccess': 'Connection successful',
  'admin.providers.providerDisabled': 'Provider disabled',
  'admin.providers.defaultDisabledWarning':
    'Default provider "{provider}" is disabled — new sessions cannot use its model',
  'admin.providers.modelsList': 'Models: {list}',
  'admin.providers.moreModels': ' + {count} more',
  'admin.providers.notChange': '(do not change)',
  'admin.providers.off': 'off',
  'admin.providers.confirmDelete': 'Delete provider «{name}»?',

  // Provider/model compatibility (shared «Advanced options» block)
  'admin.compatibility.title': 'Advanced options',
  'admin.compatibility.hint': 'Override provider heuristics. An unset field means “auto”: the server picks the behaviour itself.',
  'admin.compatibility.changed': 'changed',
  'admin.compatibility.badgeShort': 'adv',
  'admin.compatibility.auto': 'Auto',
  'admin.compatibility.autoWith': 'Auto ({value})',
  'admin.compatibility.yes': 'Yes',
  'admin.compatibility.no': 'No',
  'admin.compatibility.on': 'on',
  'admin.compatibility.custom': 'Custom value',
  'admin.compatibility.reasoningField': 'Reasoning field',
  'admin.compatibility.reasoningFieldHint': 'Name of the reasoning field in the provider response. “Auto” — heuristic by provider type.',
  'admin.compatibility.reasoningFieldCustom': 'Field name',
  'admin.compatibility.reasoningFieldCustomHint': 'Enter the field name, e.g. reasoning_content',
  'admin.compatibility.requireReasoning': 'Require reasoning',
  'admin.compatibility.requireReasoningHint': '“No” explicitly disables reasoning (thinking) even when the model supports it. “Auto” — the server decides.',
  'admin.compatibility.maxTokensField': 'Token limit field',
  'admin.compatibility.maxTokensFieldHint': 'Which response-limit field to send to the provider. “Auto” — max_tokens.',
  'admin.compatibility.cacheFormat': 'Prompt cache format',
  'admin.compatibility.cacheFormatAuto': 'Auto (prompt_cache_key)',
  'admin.compatibility.cacheFormatHint': 'anthropic — inline cache_control markers (last tool + system + last-message boundary). alibaba — no marker on tools (system + last-message boundary). “Auto” — prompt_cache_key only, no inline markers.',
  'admin.compatibility.requireFinishReason': 'Require finish_reason',
  'admin.compatibility.requireFinishReasonHint': 'Treat a stream without finish_reason as an incomplete answer. “Auto” — yes (as in opencode). “No” — the previous tolerant behaviour: the stream is considered complete.',
  'admin.compatibility.requireAssistantAfterTool': 'Assistant reply after tool',
  'admin.compatibility.requireAssistantAfterToolHint': 'Require an assistant message after a tool result — some providers need it.',
  'admin.compatibility.streamUsage': 'Usage in stream',
  'admin.compatibility.streamUsageHint': 'Request token usage in a streamed response. “Auto” — enabled.',
  'admin.compatibility.supportsToolChoice': 'tool_choice support',
  'admin.compatibility.supportsToolChoiceHint': 'Whether the provider supports tool_choice. Native Ollama does not — “No” stops sending the parameter.',
  'admin.compatibility.supportsEffortUpdates': 'Effort mode (output_config)',
  'admin.compatibility.supportsEffortUpdatesHint': 'Anthropic 5.x: send the effort tier in output_config.effort and do not send thinking. “Auto” — no (explicit opt-in only): otherwise gateways without support for the field receive a 400. The low/medium/high tiers come from the reasoning level; effort cannot disable reasoning — in that case the parameter is not sent.',
  'admin.compatibility.supportsNativeVideo': 'Native video',
  'admin.compatibility.supportsNativeVideoHint': 'Whether the provider accepts a video file natively (video_url block). “Auto” — heuristic by provider; “No” — the video is not sent as a file but as frames.',
  'admin.compatibility.nativeAudioFormats': 'Native audio',
  'admin.compatibility.nativeAudioFormatsHint': 'Which audio containers the provider accepts natively. “Auto” — heuristic by provider; “Set list” — explicit list; “Not accepted natively” — explicit empty list.',
  'admin.compatibility.nativeAudioAuto': 'Auto',
  'admin.compatibility.nativeAudioCustom': 'Set list',
  'admin.compatibility.nativeAudioNone': 'Not accepted natively',
  'admin.compatibility.nativeAudioFormatList': 'Audio formats',
  'admin.compatibility.nativeAudioFormatListHint': 'wav — WAV/PCM; mp3 — MPEG-1 Audio Layer III; ogg — Ogg/Opus (only for providers that understand input_audio with format:\'ogg\').',
  'admin.compatibility.nativeAudioFormatListEmpty': 'No formats selected',

  // Models
  'admin.models.title': 'Models',
  'admin.models.count': '{visible} / {total, plural, one {# model} other {# models}} in {providers, plural, one {# provider} other {# providers}}',
  'admin.models.syncAll': 'Sync all',
  'admin.models.allProviders': 'All providers',
  'admin.models.onlyEnabled': 'Only enabled',
  'admin.models.loadingMore': 'Loading…',
  'admin.models.modality': 'Modality',
  'admin.models.modalityAny': 'Any',
  'admin.models.modality.text': 'Text',
  'admin.models.modality.image': 'Images',
  'admin.models.modality.pdf': 'PDF',
  'admin.models.modality.audio': 'Audio',
  'admin.models.modality.video': 'Video',
  'admin.models.add': 'Add model',
  'admin.models.addManual': 'Add model manually',
  'admin.models.editManual': 'Edit model',
  'admin.models.editModel': 'Edit model',
  'admin.models.save': 'Save',
  'admin.models.selectProviderAndName': 'Select a provider and enter the model name',
  'admin.models.provider': 'Provider',
  'admin.models.name': 'Name',
  'admin.models.contextK': 'Context (K)',
  'admin.models.priceIn': 'in/1M',
  'admin.models.priceOut': 'out/1M',
  'admin.models.priceInShort': 'in',
  'admin.models.priceOutShort': 'out',
  'admin.models.priceCrShort': 'cr',
  'admin.models.priceCwShort': 'cw',
  'admin.models.addButton': 'Add',
  'admin.models.cancel': 'Cancel',
  'admin.models.createError': 'Create error',
  'admin.models.empty': 'No models. Click «Sync all» to load.',
  'admin.models.modelsCount': '({count} models)',
  'admin.models.modelsCountOf': '{shown} of {total}',
  'admin.models.searchPlaceholder': 'Search models by name…',
  'admin.models.search': 'Search',
  'admin.models.searchEmpty': 'No models match “{query}”',
  'admin.models.defaultModel': 'provider fallback: {model}',
  'admin.models.refresh': 'Refresh',
  'admin.models.model': 'Model',
  'admin.models.context': 'Context',
  'admin.models.prices': 'Prices /1M',
  'admin.models.enabledCol': 'On',
  'admin.models.defaultCol': '',
  'admin.models.filterEmpty': 'No models matching filter',
  'admin.models.enableModel': 'Enable model',
  'admin.models.disableModel': 'Disable model',
  'admin.models.defaultModelTitle': 'Default model for new sessions',
  'admin.models.makeDefault': 'Make default model',
  'admin.models.enableToDefault': 'Enable the model before making it the default',
  'admin.models.defaultModelSection': 'Default model',
  'admin.models.defaultModelSectionHint': 'Instance-wide provider + model pair used by new sessions when no model is specified.',
  'admin.models.defaultProvider': 'Provider',
  'admin.models.defaultModelLabel': 'Model',
  'admin.models.resetDefault': 'Reset',
  'admin.models.saveDefaultError': 'Failed to save the default model',
  'admin.models.deleteModel': 'Delete model',
  'admin.models.confirmDelete': 'Delete model «{id}»?',
  'admin.models.syncResult': 'Synced {fetched} models',
  'admin.models.newModels': '{count} new',
  'admin.models.enriched': '{count} enriched',
  'admin.models.priced': '{count, plural, one {# price} other {# prices}} updated',
  'admin.models.limited': '{count, plural, one {# limit} other {# limits}} updated',
  'admin.models.syncError': 'Sync error',
  'admin.models.contextTitle': '{k}K tokens{source}',
  'admin.models.contextRef': ' (reference)',
  'admin.models.contextApi': ' (API)',
  'admin.models.contextManual': ' (manual)',
  'admin.models.priceInTitle': 'Input price per 1M tokens',
  'admin.models.priceOutTitle': 'Output price per 1M tokens',
  'admin.models.priceCrTitle': 'Cache read price per 1M tokens',
  'admin.models.priceCwTitle': 'Cache write price per 1M tokens',
  'admin.models.currency': 'Price currency',
  'admin.models.currency.RUB': 'Ruble',
  'admin.models.currency.USD': 'US Dollar',
  'admin.models.currency.CNY': 'Yuan',

  // Users
  'admin.users.title': 'Users',
  'admin.users.count': '{count, plural, one {# user} other {# users}}',
  'admin.users.add': 'Add',
  'admin.users.newUser': 'New user',
  'admin.users.editUser': 'Edit: {username}',
  'admin.users.username': 'Username',
  'admin.users.displayName': 'Display name',
  'admin.users.email': 'Email',
  'admin.users.roles': 'Roles',
  'admin.users.notes': 'Notes',
  'admin.users.save': 'Save',
  'admin.users.saving': 'Saving...',
  'admin.users.cancel': 'Cancel',
  'admin.users.active': 'Active',
  'admin.users.nameRequired': 'Username is required',
  'admin.users.saveError': 'Save error',
  'admin.users.loadError': 'Error loading users',
  'admin.users.empty': 'No users',
  'admin.users.noRoles': 'no roles',
  'admin.users.edit': 'Edit',
  'admin.users.delete': 'Delete',
  'admin.users.confirmDelete': 'Delete user «{username}»?',
  'admin.users.wasLastLogin': 'was: {date}',

  // Agents
  'admin.agents.title': 'Agents',
  'admin.agents.defaultAgent.title': 'Default agent',
  'admin.agents.defaultAgent.description': 'Used when a session is created without an explicitly selected agent.',
  'admin.agents.count': '{count, plural, one {# agent} other {# agents}}',
  'admin.agents.add': 'Add',
  'admin.agents.new': 'New agent',
  'admin.agents.edit': 'Edit: {id}',
  'admin.agents.id': 'ID',
  'admin.agents.displayName': 'Display name',
  'admin.agents.description': 'Description',
  'admin.agents.provider': 'Provider',
  'admin.agents.model': 'Model',
  'admin.agents.contextFile': 'Context file',
  'admin.agents.temperature': 'Temperature: {value}',
  'admin.agents.temperatureAuto': 'Auto (model default)',
  'admin.agents.temperatureAutoShort': 'Auto',
  'admin.agents.topP': 'Top P',
  'admin.agents.topK': 'Top K',
  'admin.agents.reasoning': 'Reasoning',
  'admin.agents.reasoning.unset': 'Not set',
  'admin.agents.reasoning.none': 'Off',
  'admin.agents.effort': 'Reasoning effort',
  'admin.agents.effort.auto': 'Auto (from reasoning level)',
  'admin.agents.effortHint':
    'The tier is sent to the provider in output_config.effort only when the model/provider has “Effort mode (output_config)” enabled (supportsEffortUpdates); otherwise the parameter is ignored. xhigh and max are set here only.',
  'admin.agents.capabilities': 'Capabilities',
  'admin.agents.icon': 'Icon',
  'admin.agents.color': 'Color',
  'admin.agents.save': 'Save',
  'admin.agents.saving': 'Saving...',
  'admin.agents.cancel': 'Cancel',
  'admin.agents.default_2': 'Default',
  'admin.agents.autoById': 'Auto (by ID)',
  'admin.agents.notSelected': '(not selected)',
  'admin.agents.reset': 'Reset',
  'admin.agents.system': 'system',
  'admin.agents.builtin': 'built-in',
  'admin.agents.modified': 'modified',
  'admin.agents.noCapabilities': 'no capabilities',
  'admin.agents.confirmReset': 'Reset agent «{name}» to default settings?',
  'admin.agents.confirmDelete': 'Delete agent «{name}»?',
  'admin.agents.cap.file_read': 'read',
  'admin.agents.cap.file_write': 'write',
  'admin.agents.cap.search': 'search',
  'admin.agents.cap.git_read': 'git:read',
  'admin.agents.cap.git_write': 'git:write',
  'admin.agents.cap.shell': 'shell',
  'admin.agents.cap.web': 'web',
  'admin.agents.cap.task': 'subagents',
  'admin.agents.cap.mcp': 'MCP',
  'admin.agents.cap.runtime': 'runtime',
  'admin.agents.cap.user': 'user',
  'admin.agents.cap.memory': 'memory',
  'admin.agents.cap.pipeline': 'pipelines',
  'admin.agents.cap.schedule': 'schedules',
  'admin.agents.cap.question': 'user question',
  'admin.agents.cap.process': 'background processes',
  'admin.agents.cap.models': 'models',

  // Subagent fields
  'admin.agents.agentMode': 'Agent type',
  'admin.agents.agentMode.primary': 'Primary',
  'admin.agents.agentMode.subagent': 'Subagent',
  'admin.agents.agentMode.system': 'System',
  'admin.agents.maxSteps': 'Max steps',
  'admin.agents.stepsCount': 'Steps',
  'admin.agents.unlimited': 'unlimited',

  // Filter
  'admin.agents.filter.all': 'All',
  'admin.agents.filter.agents': 'Agents',
  'admin.agents.filter.subagents': 'Subagents',
  'admin.agents.filter.system': 'System',
  'admin.agents.filter.subagents_count': '{count, plural, one {# subagent} other {# subagents}}',

  // Context
  'admin.context.title': 'Context',
  'admin.context.count': '{count, plural, one {# file} other {# files}}{status}',
  'admin.context.add': 'Add',
  'admin.context.userFiles': 'User',
  'admin.context.rolesFiles': 'Roles',
  'admin.context.systemFiles': 'System',
  'admin.context.newFile': 'New file',
  'admin.context.fileName': 'File name',
  'admin.context.content': 'Content',
  'admin.context.create': 'Create',
  'admin.context.cancel': 'Cancel',
  'admin.context.editing': 'Editing: {name}',
  'admin.context.save': 'Save',
  'admin.context.saved': 'Saved',
  'admin.context.fileCreated': 'File created',
  'admin.context.restoredSystem': 'System version restored',
  'admin.context.empty': 'No files in category «{category}». Add a new file.',
  'admin.context.modified': 'modified',
  'admin.context.system': 'system',
  'admin.context.edit': 'Edit',
  'admin.context.reset': 'Reset',
  'admin.context.confirmDelete': 'Delete file «{name}»?',
  'admin.context.confirmReset': 'Reset «{name}» to system version?',

  // Debug
  'admin.debug.title': 'Debug',
  'admin.debug.description': 'Logging levels by group. Changes apply immediately.',
  'admin.debug.service': 'SERVICE',
  'admin.debug.ai': 'AI',
  'admin.debug.saving': 'Saving...',
  'admin.debug.save': 'Save',
  'admin.debug.saved': 'Saved',
  'admin.debug.saveError': 'Save error',

  // Defaults
  'admin.defaults.title': 'System appearance',
  'admin.defaults.description': 'Default appearance settings for new users',
  'admin.defaults.language': 'Language',
  'admin.defaults.russian': 'Russian',
  'admin.defaults.english': 'English',
  'admin.defaults.themeMode': 'Theme mode',
  'admin.defaults.system': 'System',
  'admin.defaults.light': 'Light',
  'admin.defaults.dark': 'Dark',
  'admin.defaults.theme': 'Theme',
  'admin.defaults.saved': 'Saved',
  'admin.defaults.save': 'Save',
  'admin.defaults.confirmReset': 'Reset system appearance to server defaults?',

  // Color picker
  'admin.colorPicker.default': 'Default',
  'admin.colorPicker.primary': 'Primary',
  'admin.colorPicker.info': 'Info',
  'admin.colorPicker.success': 'Success',
  'admin.colorPicker.warning': 'Warning',
  'admin.colorPicker.error': 'Error',
  'admin.colorPicker.chart1': 'Chart 1',
  'admin.colorPicker.chart2': 'Chart 2',
  'admin.colorPicker.chart3': 'Chart 3',
  'admin.colorPicker.chart4': 'Chart 4',
  'admin.colorPicker.chart5': 'Chart 5',
  'admin.colorPicker.keyword': 'Keyword',
  'admin.colorPicker.function': 'Function',
  'admin.colorPicker.number': 'Number',
  'admin.colorPicker.type': 'Type',
  'admin.colorPicker.variable': 'Variable',

  // Icon picker
  'admin.iconPicker.searchPlaceholder': 'Search icon...',

  // MCP
  'mcp.title': 'MCP Servers',
  'mcp.description': 'Manage external MCP servers. Server tools become available to AI models as tool calls.',
  'mcp.count': '{count, plural, one {# server} other {# servers}}',
  'mcp.addServer': 'Add Server',
  'mcp.newServer': 'New Server',
  'mcp.editServer': 'Edit Server',
  'mcp.noServers': 'No MCP servers configured. Add a server to extend model capabilities.',
  'mcp.serverName': 'Server Name',
  'mcp.serverDescription': 'Description',
  'mcp.serverDescriptionPlaceholder': 'What this server is for (goes into the model prompt)',
  'mcp.type': 'Connection Type',
  'mcp.type.stdio': 'stdio (process)',
  'mcp.type.sse': 'Streamable HTTP',
  'mcp.command': 'Command',
  'mcp.args': 'Arguments',
  'mcp.env': 'Environment Variables',
  'mcp.url': 'URL',
  'mcp.enabledByDefault': 'Enabled by default for new projects',
  'mcp.masterEnabled': 'Enabled at system level',
  'mcp.masterEnabledDescription': 'A disabled server is unavailable anywhere — in any project or session.',
  'mcp.masterEnabledShort': 'System',
  'mcp.defaultOnShort': 'New projects',
  'mcp.masterEnabledTitle': 'Enabled at system level',
  'mcp.masterDisabledTitle': 'Disabled at system level',
  'mcp.masterEnable': 'Enable at system level',
  'mcp.masterDisable': 'Disable at system level',
  'mcp.testConnection': 'Test Connection',
  'mcp.testSuccess': 'Connection successful. Tools: {count}',
  'mcp.testError': 'Error: {error}',
  'mcp.enable': 'Enable',
  'mcp.disable': 'Disable',
  'mcp.edit': 'Edit',
  'mcp.delete': 'Delete',
  'mcp.deleteConfirm': 'Delete MCP server?',
  'mcp.deleteConfirmMessage': 'Are you sure you want to delete server «{name}»?',
  'mcp.autoEnabled': 'default for new projects',
  'mcp.enabledByDefaultTitle': 'Enabled by default for new projects',
  'mcp.disabledByDefaultTitle': 'Not enabled by default for new projects',
  'mcp.type.http': 'HTTP (streamable)',
  'mcp.type.sse.legacy': 'SSE (legacy)',

  // MCP: registry (ADR-071 §2.5)
  'mcp.registry.author': 'author: {name}',
  'mcp.registry.stdioAdminOnly': 'stdio servers can only be added by an administrator',
  'mcp.registry.testAfterSave': 'Save the server first, then test the connection.',
  'mcp.origin.instance': 'system',
  'mcp.origin.user': 'user',
  'mcp.trust.builtin': 'trusted',
  'mcp.trust.community': 'community',

  // MCP: network access policy (ADR-071 §2.3.1)
  'mcp.network.title': 'Network access for user MCP servers',
  'mcp.network.description': 'Restricts which hosts user-added HTTP MCP servers may connect to (SSRF/egress protection).',
  'mcp.network.mode': 'Mode',
  'mcp.network.mode.deny': 'deny — block listed addresses',
  'mcp.network.mode.allow': 'allow — only listed addresses',
  'mcp.network.denyHelp': 'Addresses in the list are forbidden; everything else is allowed. Default is deny of private ranges (10/8, 172.16/12, 192.168/16, 127/8, link-local, metadata).',
  'mcp.network.allowHelp': 'Only addresses in the list are allowed; everything else is forbidden.',
  'mcp.network.list': 'Hosts / CIDR',
  'mcp.network.saved': 'Network policy saved',
  'mcp.network.saveError': 'Failed to save network policy: {error}',

  // Egress policy (tools/webhooks): mode + host/CIDR rules
  'egress.title': 'Egress policy',
  'egress.description': 'Restricts outgoing requests: mode plus host/CIDR rules. Exceptions are allow-rules and are checked first.',
  'egress.tools.title': 'Outgoing requests of built-in tools',
  'egress.tools.description': 'Policy for web_fetch, web_search and other built-in tools that make outgoing HTTP requests.',
  'egress.webhooks.title': 'Outgoing webhook requests',
  'egress.webhooks.description': 'Policy for webhook deliveries (https is required unless the mode is off).',
  'egress.mode': 'Mode',
  'egress.modeHelp': 'deny — block listed addresses; allow — only listed addresses are permitted.',
  'egress.mode.deny': 'deny — block listed addresses',
  'egress.mode.allow': 'allow — only listed addresses',
  'egress.mode.off': 'off — no checks (dev)',
  'egress.offWarning': 'Mode "off" disables egress checks and the HTTPS requirement for webhooks. Development only.',
  'egress.list': 'Hosts / CIDR',
  'egress.listHelp': 'Main list rules: exact hostname, *.suffix or CIDR/IP. Default is deny of private ranges.',
  'egress.exceptions': 'Exceptions (allow)',
  'egress.exceptionsHelp': 'Allow-rules checked before the main list: exact host, *.suffix or CIDR. They can unblock a host from the list.',
  'egress.check.title': 'Check URL',
  'egress.check.description': 'Dry run: the URL is parsed and resolved; no HTTP request is made.',
  'egress.check.url': 'URL to check',
  'egress.check.button': 'Check',
  'egress.check.checking': 'Checking...',
  'egress.check.allowed': 'Allowed',
  'egress.check.blocked': 'Blocked: {reason}',
  'egress.check.matchedRule': 'matched rule: {rule}',
  'egress.check.addresses': 'resolved addresses: {addresses}',
  'egress.check.error': 'Check failed: {error}',
  'egress.saved': 'Egress policy saved',
  'egress.saveError': 'Failed to save egress policy: {error}',
  'egress.loadError': 'Failed to load egress policy: {error}',
  'egress.reset': 'Reset policy',

  // Network: instance-wide egress settings (proxy; TLS CA — next stage)
  'network.title': 'Network',
  'network.description': 'Instance-wide network access settings: egress proxy and trusted CAs.',
  'network.tls.title': 'Trusted CAs (TLS)',
  'network.tls.description': 'Trust for outgoing TLS: CA bundle, default client certificate (mTLS) and per-host client certificates. Applied after an instance restart.',
  'network.tls.source.env': 'environment',
  'network.tls.source.runtime': 'runtime (UI)',
  'network.tls.source.config': 'config file',
  'network.tls.source.none': 'not configured',
  'network.tls.restartRequired': 'TLS changes take effect after an instance restart.',
  'network.tls.status.ca': 'CA bundle',
  'network.tls.status.caCount': '{count, plural, one {# certificate} other {# certificates}}',
  'network.tls.status.caSubjects': 'CA subjects',
  'network.tls.status.rejectUnauthorized': 'Verify server certificate',
  'network.tls.status.client': 'Default client certificate',
  'network.tls.status.clientSubject': 'Client subject',
  'network.tls.status.clientKey': 'Private key',
  'network.tls.status.clientKeySet': 'set',
  'network.tls.status.clientKeyMissing': 'missing',
  'network.tls.readOnly.badge': 'from parameters, read-only',
  'network.tls.readOnly.hint': 'Set via config.yaml/env; the UI can only display it.',
  'network.tls.params.title': 'From parameters (read-only)',
  'network.tls.params.description': 'Values that come from config.yaml or environment variables. They are not editable in the UI.',
  'network.tls.params.ca': 'CA',
  'network.tls.params.caFile': 'CA file',
  'network.tls.params.caPem': 'CA PEM from env/config',
  'network.tls.params.client': 'Client certificate',
  'network.tls.params.certFile': 'Certificate file',
  'network.tls.params.keyFile': 'Key file',
  'network.tls.ca.title': 'CA bundle',
  'network.tls.ca.pem': 'PEM bundle',
  'network.tls.ca.pemHelp': 'One or more certificates (BEGIN CERTIFICATE). Used to verify outgoing TLS servers.',
  'network.tls.ca.placeholder': '-----BEGIN CERTIFICATE-----\n…',
  'network.tls.ca.file': 'Load .pem file',
  'network.tls.ca.envReadOnly': 'CA is set via environment variables and cannot be changed in the UI.',
  'network.tls.ca.validate': 'Validate',
  'network.tls.ca.upload': 'Upload',
  'network.tls.ca.reset': 'Reset runtime CA',
  'network.tls.ca.resetConfirmTitle': 'Reset runtime CA?',
  'network.tls.ca.resetConfirmMessage': 'The CA bundle uploaded through the UI will be removed; the config/env CA (if any) applies again.',
  'network.tls.ca.empty': 'No runtime CA uploaded. The trust bundle comes from config/env (or the system store).',
  'network.tls.client.title': 'Default client certificate (mTLS)',
  'network.tls.client.description': 'Certificate and private key presented to servers that request a client certificate. The key is never shown.',
  'network.tls.client.cert': 'Client certificate (.pem)',
  'network.tls.client.key': 'Private key (.pem)',
  'network.tls.client.validate': 'Validate',
  'network.tls.client.upload': 'Upload',
  'network.tls.client.delete': 'Delete',
  'network.tls.client.deleteConfirmTitle': 'Delete client certificate?',
  'network.tls.client.deleteConfirmMessage': 'The default client certificate will be removed; mTLS to servers requiring it will stop working.',
  'network.tls.client.readOnly': 'The default client certificate is set via config/env — read-only; a per-host mapping can override it.',
  'network.tls.client.keyMatches': 'Key matches certificate',
  'network.tls.mappings.title': 'Per-host client certificates',
  'network.tls.mappings.description': 'Client certificates for specific hosts.',
  'network.tls.mappings.firstMatch': 'The first matching rule wins; "*" matches all hosts; otherwise the default client certificate is used.',
  'network.tls.mappings.hosts': 'Hosts',
  'network.tls.mappings.label': 'Label',
  'network.tls.mappings.source': 'Source',
  'network.tls.mappings.certSubject': 'Certificate subject',
  'network.tls.mappings.empty': 'No per-host mappings yet.',
  'network.tls.mappings.add': 'Add',
  'network.tls.mappings.edit': 'Edit',
  'network.tls.mappings.delete': 'Delete',
  'network.tls.mappings.deleteConfirmTitle': 'Delete mapping?',
  'network.tls.mappings.deleteConfirmMessage': 'The client certificate mapping will be removed.',
  'network.tls.mappings.formAddTitle': 'New mapping',
  'network.tls.mappings.formEditTitle': 'Edit mapping',
  'network.tls.mappings.formHosts': 'Host patterns',
  'network.tls.mappings.formHostsHelp': 'Exact host, *.suffix or * (all hosts). No scheme or path.',
  'network.tls.mappings.formLabel': 'Label',
  'network.tls.mappings.formLabelPlaceholder': 'optional',
  'network.tls.mappings.formCert': 'Client certificate (.pem)',
  'network.tls.mappings.formKey': 'Private key (.pem)',
  'network.tls.mappings.certOptional': 'Leave empty to keep the current certificate.',
  'network.tls.mappings.validateFirst': 'Validate the certificate before saving.',
  'network.tls.validate.ok': 'Validation passed',
  'network.tls.validate.failed': 'Validation failed',
  'network.tls.validate.caResult': 'CA: {count} certificates',
  'network.tls.validate.caSubjects': 'Subjects: {subjects}',
  'network.tls.validate.keyMatches': 'Key matches certificate',
  'network.tls.validate.required': 'Fill in the PEM fields first.',
  'network.tls.conflict': 'This value is managed by config.yaml/env and is read-only in the UI.',
  'network.tls.saved': 'TLS settings saved (restart required)',
  'network.tls.saveError': 'Failed to save TLS settings: {error}',
  'network.tls.deleteError': 'Failed to delete TLS material: {error}',
  'network.tls.validateError': 'Validation failed: {error}',
  'network.tls.proxy.title': 'TLS to proxy',
  'network.tls.proxy.note': 'Configured in the Proxy block above.',
  'network.tls.proxy.caFile': 'CA file',
  'network.tls.proxy.certFile': 'Certificate file',
  'network.tls.proxy.keyFile': 'Key file',
  'network.tls.proxy.hasCaPem': 'CA PEM set',
  'network.tls.proxy.rejectUnauthorized': 'Verify proxy certificate',

  // Egress proxy (ADR-099): status, runtime settings and connection check
  'proxy.title': 'Proxy',
  'proxy.description': 'Egress proxy profiles and host routing for outgoing requests. Changes apply after an instance restart; passwords and keys are never shown.',
  'proxy.enabled': 'Enabled',
  'proxy.disabled': 'Disabled',
  'proxy.source': 'Source',
  'proxy.source.env': 'environment variables',
  'proxy.source.runtime': 'runtime override (UI)',
  'proxy.source.config': 'config file',
  'proxy.source.none': 'not configured',
  'proxy.url': 'Proxy URL',
  'proxy.noProxy': 'Bypass (no_proxy)',
  'proxy.fallbackDirect': 'Direct fallback',
  'proxy.fallbackDirectHint': 'When the proxy is unavailable, requests go direct (with a warning). Security policy is weakened.',
  'proxy.connectTimeout': 'Connect timeout',
  'proxy.connectTimeoutValue': '{ms} ms',
  'proxy.restartRequired': 'Changes take effect after an instance restart.',
  'proxy.check': 'Check connection',
  'proxy.checking': 'Checking...',
  'proxy.reachable': 'Proxy reachable',
  'proxy.unreachable': 'Proxy unreachable',
  'proxy.latency': 'Latency: {latency} ms',
  'proxy.authChallenge': 'Authentication challenge: {challenge}',
  'proxy.checkError': 'Connection check failed: {error}',
  'proxy.error': 'Failed to load proxy status: {error}',
  'proxy.status.running': 'Running configuration',
  'proxy.status.saved': 'Saved configuration',
  'proxy.status.overridden': 'Overrides config',
  'proxy.status.default': 'From config/env',
  'proxy.form.title': 'Proxy settings',
  'proxy.form.enabled': 'Enable proxy',
  'proxy.form.enabledHint': 'When disabled, outgoing requests go direct (unless a URL comes from env).',
  'proxy.form.url': 'Proxy URL',
  'proxy.form.urlHelp': 'http:// or https:// (SOCKS5 is also supported in the URL).',
  'proxy.form.httpProxy': 'HTTP proxy',
  'proxy.form.httpsProxy': 'HTTPS proxy',
  'proxy.form.allProxy': 'Proxy for all schemes',
  'proxy.form.schemeHelp': 'Empty — falls back to the general URL / config / env.',
  'proxy.form.noProxy': 'Bypass (no_proxy)',
  'proxy.form.noProxyHelp': 'Host, .suffix, *.suffix, host:port, IP or CIDR.',
  'proxy.form.fromEnv': 'Use standard environment variables',
  'proxy.form.fromEnvHelp': 'HTTP_PROXY / HTTPS_PROXY / ALL_PROXY / NO_PROXY (unless disabled explicitly).',
  'proxy.form.connectTimeout': 'Connect timeout',
  'proxy.form.connectTimeoutInvalid': 'Specify at least 1 ms.',
  'proxy.form.authUsername': 'Basic auth username',
  'proxy.form.authHelp': 'The password is set below and never stored in config.',
  'proxy.form.authType': 'Auth type',
  'proxy.form.authBasic': 'Basic (only supported)',
  'proxy.form.tls': 'TLS to proxy',
  'proxy.form.tlsCaFile': 'CA file (PEM path)',
  'proxy.form.tlsCertFile': 'Client certificate file',
  'proxy.form.tlsKeyFile': 'Client key file',
  'proxy.form.tlsRejectUnauthorized': 'Verify proxy TLS certificate',
  'proxy.form.tlsHelp': 'CA file and CA PEM are mutually exclusive; certificate and key are set together.',
  'proxy.form.unsaved': 'You have unsaved changes',
  'proxy.password.placeholder': 'Password',
  'proxy.password.set': 'Set',
  'proxy.password.clear': 'Clear',
  'proxy.password.envDisabled': 'Password is managed by SYNTH_PROXY_PASSWORD in the environment.',
  'proxy.password.envConflict': 'Password is set via SYNTH_PROXY_PASSWORD; the UI cannot change it.',
  'proxy.password.envConflictGeneric': 'The password is managed by the environment; the UI cannot change it.',
  'proxy.password.required': 'Enter a password.',
  'proxy.password.setSuccess': 'Proxy password saved',
  'proxy.password.clearSuccess': 'Proxy password cleared',
  'proxy.password.setError': 'Failed to save proxy password: {error}',
  'proxy.password.clearError': 'Failed to clear proxy password: {error}',
  'proxy.password.clearConfirmTitle': 'Clear proxy password?',
  'proxy.password.clearConfirmMessage': 'Basic auth will stop working until a new password is set.',
  'proxy.password.pendingError': 'Profile «{name}» was saved, but the password could not be applied: {error}',
  'proxy.save': 'Save',
  'proxy.savedToast': 'Proxy settings saved (restart required)',
  'proxy.saveError': 'Failed to save proxy settings: {error}',
  'proxy.resetToast': 'Proxy settings reset to config',
  'proxy.resetError': 'Failed to reset proxy settings: {error}',
  'proxy.check.target': 'Checked target',
  'proxy.check.usingSaved': 'saved configuration',
  'proxy.check.usingUrl': 'explicit URL',


  // Egress proxy (ADR-099): profiles + host routing
  'proxy.mode.title': 'Routing mode',
  'proxy.mode.all': 'All hosts except noProxy',
  'proxy.mode.selected': 'Only selected hosts',
  'proxy.mode.allHint': 'The default profile is used for every host not excluded by noProxy (rules can override).',
  'proxy.mode.selectedHint': 'Only hosts matching a rule are proxied; everything else goes direct.',
  'proxy.mode.selectedNoRules': 'Add at least one rule for the «Only selected hosts» mode — otherwise saving is blocked.',
  'proxy.defaultProfile': 'Default profile',
  'proxy.defaultProfileHelp': 'Used for the «all» mode and for rules without an explicit profile.',
  'proxy.status.mode': 'Mode',
  'proxy.status.profiles': 'Profiles',
  'proxy.status.defaultProfile': 'Default profile',
  'proxy.form.noProfiles': 'Add at least one proxy profile (or disable the proxy).',
  'proxy.form.defaultProfileRequired': 'Select an existing default profile for the «all» mode.',
  'proxy.profiles.title': 'Profiles',
  'proxy.profiles.description': 'Named proxy endpoints. The profile name is permanent; passwords and TLS material are stored separately and never shown.',
  'proxy.profiles.empty': 'No profiles yet. Add one to route traffic through a proxy.',
  'proxy.profiles.add': 'Add profile',
  'proxy.profiles.edit': 'Edit',
  'proxy.profiles.delete': 'Delete',
  'proxy.profiles.name': 'Name',
  'proxy.profiles.nameHelp': 'Lowercase letter, then a-z, 0-9, _ or - (max 32). Immutable.',
  'proxy.profiles.nameInvalid': 'Invalid profile name: ^[a-z][a-z0-9_-]{0,31}$.',
  'proxy.profiles.nameInvalidFor': 'Profile «{name}»: invalid name (^[a-z][a-z0-9_-]{0,31}$).',
  'proxy.profiles.exists': 'A profile with this name already exists.',
  'proxy.profiles.label': 'Label',
  'proxy.profiles.labelPlaceholder': 'optional',
  'proxy.profiles.url': 'Proxy URL',
  'proxy.profiles.urlHelp': 'http://, https:// or socks5://. The username can be set below; the password is stored separately.',
  'proxy.profiles.urlRequired': 'Enter a proxy URL.',
  'proxy.profiles.urlRequiredFor': 'Profile «{name}»: enter a proxy URL.',
  'proxy.profiles.username': 'Username',
  'proxy.profiles.authTitle': 'Username / password',
  'proxy.profiles.authHelp': 'Basic proxy authentication.',
  'proxy.profiles.usedByDefault': 'default',
  'proxy.profiles.usedByRules': 'rules: {rules}',
  'proxy.profiles.deleteBlockedDefault': 'Profile «{name}» is the default profile — select another default before deleting it.',
  'proxy.profiles.deleteBlockedRules': 'Profile «{name}» is used by rules: {rules}. Change or delete those rules first.',
  'proxy.profiles.deleteConfirmTitle': 'Delete profile?',
  'proxy.profiles.deleteConfirmMessage': 'Profile «{name}» will be removed from the saved configuration (applied after save).',
  'proxy.profiles.addTitle': 'New profile',
  'proxy.profiles.editTitle': 'Profile «{name}»',
  'proxy.profiles.apply': 'Apply',
  'proxy.profiles.notFound': 'Profile not found — reload the page.',
  'proxy.password.setBadge': 'password set',
  'proxy.password.notSet': 'no password',
  'proxy.password.envManaged': 'Managed by the environment',
  'proxy.tls.title': 'TLS to proxy',
  'proxy.tls.toggle': 'TLS/mTLS',
  'proxy.tls.badge': 'TLS',
  'proxy.tls.help': 'TLS/mTLS to the proxy itself. CA/cert/key paths are saved with the profile; PEM and keys are write-only and never shown.',
  'proxy.tls.caFile': 'CA file (path)',
  'proxy.tls.certFile': 'Client certificate file (path)',
  'proxy.tls.keyFile': 'Client key file (path)',
  'proxy.tls.rejectUnauthorized': 'Verify proxy TLS certificate',
  'proxy.tls.caTitle': 'CA bundle',
  'proxy.tls.caPem': 'CA PEM',
  'proxy.tls.caLoadFile': 'Load .pem file',
  'proxy.tls.hasCa': 'CA is set',
  'proxy.tls.clientTitle': 'Client certificate (mTLS)',
  'proxy.tls.clientCert': 'Client certificate (.pem)',
  'proxy.tls.clientKey': 'Private key (.pem)',
  'proxy.tls.check': 'Check',
  'proxy.tls.upload': 'Upload',
  'proxy.tls.remove': 'Delete',
  'proxy.tls.required': 'Fill in the PEM fields first.',
  'proxy.tls.checkOk': 'Validation passed',
  'proxy.tls.checkFailed': 'Validation failed',
  'proxy.tls.saved': 'TLS material saved (restart required)',
  'proxy.tls.pendingUploadHint':
    'The CA and client certificate can be selected right away; upload happens after the profile is saved.',
  'proxy.tls.pendingError':
    'Profile «{name}» was saved, but TLS material could not be uploaded: {error}',
  'proxy.tls.clientPairRequired': 'Select both the client certificate and the private key.',
  'proxy.tls.removeCaConfirmTitle': 'Delete proxy CA?',
  'proxy.tls.removeCaConfirmMessage': 'The CA bundle for profile «{name}» will be removed; the system trust store applies again.',
  'proxy.tls.removeClientConfirmTitle': 'Delete proxy client certificate?',
  'proxy.tls.removeClientConfirmMessage': 'The client certificate and key for profile «{name}» will be removed.',
  'proxy.rules.title': 'Routing rules',
  'proxy.rules.hint': 'First match wins. noProxy always takes priority. CIDR matches IP literals only; *.example.com matches subdomains only.',
  'proxy.rules.empty': 'No rules. Hosts are routed by the default profile (mode «all»).',
  'proxy.rules.add': 'Add rule',
  'proxy.rules.edit': 'Edit',
  'proxy.rules.delete': 'Delete',
  'proxy.rules.addTitle': 'New rule',
  'proxy.rules.editTitle': 'Rule «{label}»',
  'proxy.rules.untitled': 'untitled',
  'proxy.rules.apply': 'Apply',
  'proxy.rules.hosts': 'Hosts',
  'proxy.rules.hostsHelp': 'Exact host, .suffix, *.suffix, host:port, IP, CIDR or *.',
  'proxy.rules.hostsHint': 'Examples: api.openai.com, *.openai.com, 10.0.0.0/8, *.',
  'proxy.rules.hostsRequired': 'Add at least one host.',
  'proxy.rules.hostsRequiredFor': 'Rule {index}: add at least one host.',
  'proxy.rules.label': 'Label',
  'proxy.rules.labelPlaceholder': 'optional',
  'proxy.rules.action': 'Action',
  'proxy.rules.action.proxy': 'Proxy',
  'proxy.rules.action.direct': 'Direct',
  'proxy.rules.profile': 'Profile',
  'proxy.rules.profileHelp': 'Profile for this rule; the default profile is used when empty.',
  'proxy.rules.profileRequired': 'Select a profile or set a default profile.',
  'proxy.rules.profileRequiredFor': 'Rule {index}: select a profile or set a default profile.',
  'proxy.rules.defaultProfile': 'Default profile',
  'proxy.rules.moveUp': 'Move up',
  'proxy.rules.moveDown': 'Move down',
  'proxy.target.title': 'Check a URL',
  'proxy.target.description': 'Routes the URL through the saved proxy configuration (HEAD request, no redirects). Egress policy is enforced by the server.',
  'proxy.target.url': 'Target URL',
  'proxy.target.urlRequired': 'Enter a target URL.',
  'proxy.target.check': 'Check',
  'proxy.target.checking': 'Checking...',
  'proxy.target.checkError': 'Check failed: {error}',
  'proxy.target.ok': 'Request succeeded',
  'proxy.target.failed': 'Request failed',
  'proxy.target.rule': 'Matched rule',
  'proxy.target.ruleNone': 'no rule',
  'proxy.target.profile': 'Profile',
  'proxy.target.proxyUrl': 'Proxy URL',
  'proxy.target.httpStatus': 'HTTP status: {status}',
  'proxy.target.latency': 'Latency: {latency} ms',
  'proxy.target.usingSaved': 'Checked against the saved configuration (takes effect after restart).',
  'proxy.target.restartRequired': 'The saved configuration differs from the running one.',
  'proxy.target.action.proxy': 'proxy',
  'proxy.target.action.direct': 'direct',
  'proxy.target.via.proxy': 'via proxy',
  'proxy.target.via.direct': 'direct',
  'proxy.reason.disabled': 'proxy is disabled',
  'proxy.reason.no-proxy': 'noProxy exception',
  'proxy.reason.rule': 'routing rule',
  'proxy.reason.default': 'default profile',
  'proxy.reason.no-match': 'no matching rule',
  'proxy.reason.no-default': 'no profile/URL',
  'proxy.restart.action': 'Open Maintenance',

  // MCP: tool availability per mode
  'mcp.permissions.title': 'Tool availability by mode',
  'mcp.permissions.description': 'Configure which server tools are available in Plan mode (read-only) and Act mode (full access). Default settings apply to all tools; individual tools can be configured per-tool.',
  'mcp.permissions.loading': 'Loading settings...',
  'mcp.permissions.loadError': 'Could not load tool availability settings: {error}',
  'mcp.permissions.notReady': 'This section will become available after the server update (MCP tool availability).',
  'mcp.permissions.save': 'Save',
  'mcp.permissions.saved': 'MCP settings saved',
  'mcp.permissions.saveError': 'Failed to save MCP settings: {error}',
  'mcp.permissions.saving': 'Saving...',
  'mcp.permissions.unsaved': 'You have unsaved changes',
  'mcp.permissions.defaultTools': 'All tools',
  'mcp.permissions.defaultToolsHint': 'Default setting for all server tools',
  'mcp.permissions.mode.plan': 'Plan',
  'mcp.permissions.mode.act': 'Act',
  'mcp.permissions.probe': 'Test Connection',
  'mcp.permissions.probing': 'Testing...',
  'mcp.permissions.probeSuccess': 'Tools: {count}',
  'mcp.permissions.probeError': 'Probe error: {error}',
  'mcp.permissions.noTools': 'No tools detected',
  'mcp.permissions.noServerSettings': 'No servers with availability settings.',
  'mcp.permissions.perTool': 'Server tools',
  'mcp.permissions.toolDefaultHint': 'No custom setting — uses "All tools"',

  // MCP: user settings (ADR-071 §2.5)
  'mcp.user.title': 'MCP Servers',
  'mcp.user.description': 'Add your own HTTP MCP servers. They become available to sessions according to the administrator policy.',
  'mcp.user.empty': 'You have no servers yet. Add an HTTP server to extend model capabilities.',
  'mcp.user.httpOnly': 'Only HTTP/SSE servers can be added here; stdio servers are configured by an administrator.',
  'mcp.user.saveError': 'Failed to save MCP server: {error}',
  // Store-level MCP errors (вне React)
  'mcp.error.loadRegistry': 'Failed to load MCP registry',
  'mcp.error.addServer': 'Failed to add MCP server',
  'mcp.error.updateServer': 'Failed to update MCP server',
  'mcp.error.deleteServer': 'Failed to delete MCP server',
  'mcp.error.loadToolSettings': 'Failed to load MCP tool settings',
  'mcp.error.saveToolSettings': 'Failed to save MCP tool settings',
  'mcp.error.probe': 'Failed to test the connection',
  'mcp.error.loadNetworkPolicy': 'Failed to load MCP network policy',
  'mcp.error.saveNetworkPolicy': 'Failed to save MCP network policy',
  'mcp.error.loadToolsDisabled': 'Failed to load disabled tools',
  'mcp.error.saveToolsDisabled': 'Failed to save disabled tools',

  // MCP: admin tools.disabled (ADR-071 §2.6)
  'mcpAdmin.tools.title': 'Built-in tools',
  'mcpAdmin.tools.description': 'Manage which built-in tools are available instance-wide. A checked tool is enabled; uncheck it to disable it — disabled tools never go into the model request regardless of the tools policy. Session runtime tools are always on.',
  'mcpAdmin.tools.checkHint': 'Checked — enabled. Uncheck to disable.',
  'mcpAdmin.tools.groups': 'Capability groups',
  'mcpAdmin.tools.perTool': 'Individual tools',
  'mcpAdmin.tools.group.file_read': 'File reading',
  'mcpAdmin.tools.group.file_write': 'File writing',
  'mcpAdmin.tools.group.shell': 'Shell commands',
  'mcpAdmin.tools.group.search': 'Search',
  'mcpAdmin.tools.group.web': 'Web',
  'mcpAdmin.tools.group.git_read': 'Git read',
  'mcpAdmin.tools.group.git_write': 'Git write',
  'mcpAdmin.tools.group.task': 'Sub-agents',
  'mcpAdmin.tools.group.mcp': 'MCP tools',
  'mcpAdmin.tools.group.user': 'User interaction',
  'mcpAdmin.tools.group.runtime': 'Session runtime',
  'mcpAdmin.tools.runtimeHint': 'Session runtime tools (core) are always on and cannot be disabled',
  'mcpAdmin.tools.alwaysOn': 'always on',
  'mcpAdmin.tools.noSession': 'Open a session to list individual tools (from its prompt composition).',
  'mcpAdmin.tools.saved': 'Tool settings saved',
  'mcpAdmin.tools.saveError': 'Failed to save tool settings: {error}',

  // Reference & Merge
  'reference.title': 'Add Session Reference',
  'reference.selectSession': 'Select source session',
  'reference.label': 'Label',
  'reference.labelPlaceholder': 'E.g. "Analysis results"',
  'reference.autoSummarize': 'Auto-summarize',
  'reference.add': 'Add Reference',
  'reference.empty': 'No references attached',
  'reference.remove': 'Remove reference',
  'reference.source': 'Source',
  'reference.range': 'Messages',
  'reference.attached': 'Attached',

  'merge.title': 'Copy Messages',
  'merge.selectSession': 'Select source session',
  'merge.range': 'Seq range (from,to)',
  'merge.position': 'Position',
  'merge.position.after': 'End',
  'merge.position.before': 'Start',
  'merge.summarize': 'Summarize',
  'merge.copy': 'Copy',
  'merge.copied': 'Copied {count} msgs',

  // Routing (ADR-034)
  'routing.title': 'Routing',
  'routing.globalDescription': 'Default routing settings for new sessions.',
  'routing.strategy': 'Strategy',
  'routing.strategy.auto': 'Auto',
  'routing.strategy.content': 'Content',
  'routing.strategy.cost': 'Cost',
  'routing.strategy.contentCost': 'Content + Cost',
  'routing.content': 'Content',
  'routing.content.coding': 'Coding',
  'routing.content.chat': 'Chat',
  'routing.content.research': 'Research',
  'routing.escalation': 'Quality Check',
  'routing.escalation.fallback': 'Fallback',
  'routing.escalation.minLength': 'Min reply length (chars)',
  'routing.cost': 'Cost',
  'routing.cost.cheap': 'Cheap model',
  'routing.cost.threshold': 'Threshold (tokens)',
  'routing.subagent': 'Sub-agents',
  'routing.subagent.model': 'Model',
  'routing.subagent.modelAuto': 'Auto (same as agent)',
  'routing.quality.pass': 'Quality: OK',
  'routing.quality.fail': 'Quality: ERROR',
  'routing.dictionaries.title': 'Classification dictionaries',
  'routing.dictionaries.source.system': 'System',
  'routing.dictionaries.source.user': 'User',
  'routing.dictionaries.category.coding': 'Coding',
  'routing.dictionaries.category.research': 'Research',
  'routing.dictionaries.category.smallTalk': 'Small talk',
  'routing.dictionaries.category.intents': 'Intents',
  'routing.dictionaries.category.enum': 'Enums',
  'routing.dictionaries.category.injection': 'Injection',
  'routing.dictionaries.tools': 'Tools',
  'routing.dictionaries.addKeyword': 'Add keyword',
  'routing.dictionaries.addTool': 'Add tool',
  'routing.dictionaries.remove': 'Remove',
  'routing.dictionaries.reset': 'Reset to system dictionary',
  'routing.dictionaries.hint': 'Dictionaries are loaded from YAML in packages/core/dictionaries/; overrides are stored in $SYNTH_DATA_DIR/dictionaries/ (the user file takes precedence).',
  'routing.dictionaries.unavailable': 'Dictionary editing is available in local mode (core)',
  'routing.dictionaries.loadError': 'Failed to load dictionaries',
  'routing.dictionaries.modified': 'Overridden',
  'routing.dictionaries.edit': 'Edit',
  'routing.dictionaries.cancel': 'Cancel',
  'routing.dictionaries.editing': 'Editing: {name}',
  'routing.dictionaries.confirmReset': 'Restore system dictionary {name}?',
  'routing.dictionaries.restored': 'System dictionary restored',

  // --- Git-репозитории и SSH-ключи (ADR-076) ---
  'sshkey.not_found': 'SSH key {id} not found',
  'sshkey.name_exists': 'SSH key with name "{name}" already exists',
  'sshkey.encryption_unavailable': 'SSH key encryption is unavailable: secret key is not configured',
  'sshkey.decrypt_failed': 'Failed to decrypt SSH key {id}',
  'sshkey.env_failed': 'Failed to prepare SSH environment (temporary key or askpass)',
  'git.ssh_key_required': 'SSH key is required for repository "{path}"',
  'git.ssh_key_required_hint':
    'Error: SSH key is required for repository "{path}" but none is set or the configured key was not found. '
    + 'Available SSH keys: {keys}. '
    + 'Pass the id of a suitable key as `sshKeyId` (the `ssh_keys_list` tool shows the same list); '
    + 'if no key fits or the list is empty, the user must add a key in Settings → SSH keys.',
  'git.ssh_keys_none': 'none configured',
  'sshkeys.tool.header': 'SSH keys ({count}):',
  'sshkeys.tool.empty':
    'No SSH keys are configured. Add one in Settings → SSH keys (or POST /api/v2/ssh-keys).',
  'sshkeys.tool.deps_unavailable':
    'The SSH key store is unavailable in this build — SSH keys cannot be listed',
  'git.repo_path_invalid': 'Invalid repository path "{path}" (must be inside the project workspace)',
  'git.repo_exists': 'Repository already exists at "{path}"',

  // --- Git worktrees: per-session working directory (ADR-114) ---
  'worktree.directory_missing':
    'The working directory of the linked git worktree "{path}" does not exist. '
    + 'The worktree was probably deleted — the session cannot continue in another directory.',
  'worktree.tool.created':
    'Git worktree "{name}" created on branch "{branch}" (directory: {directory}, id: {worktree_id}). '
    + 'It is not attached to any session yet — bind it with PATCH /api/v2/sessions/<sessionId> '
    + 'and the "worktreeId" field, or let the user attach it in the UI.',

  // --- Execution (ADR-077) ---
  'execution.remote_url_required':
    'Remote execution mode (execution.mode=remote) requires at least one executor address (execution.remote.url / SYNTH_EXECUTION_REMOTE_URL).',
  'execution.remote_unavailable':
    'Remote execution mode (execution.mode=remote) is unavailable: {reason}',

  // --- Question to the user and background processes (stage 1 roadmap 0.13) ---
  'question.answered': 'The user answered the questions: {answers}. Continue with the answers.',
  'question.cancelled': 'The user cancelled the question: {reason}',
  'question.timeout': 'The question expired by timeout',
  'question.deps_unavailable': 'The question mechanism is unavailable in this build',
  'process.background_started': 'Command started in the background (processId: {id}). Output: {log}',
  'process.deps_unavailable': 'Background processes are unavailable in this build',
  'process.background_limit':
    'The limit of background processes for this session has been reached ({limit}). Wait for a running process to finish or stop it.',
  'process.background_unsupported': 'Background execution is unavailable in the current execution mode',
  'process.background_disabled': 'Background processes are disabled (background.enabled: false)',
  'process.detached_started':
    'Command moved to the background (processId: {id}). Output: {log}',
  'process.tool.empty': 'No background runs',
  'process.tool.not_found': 'Background run "{id}" not found',
  'process.tool.deps_unavailable': 'The background run registry is unavailable in this build',
  'process.tool.header': 'Background runs ({count}):',
  'process.tool.no_log': 'There is no log for this background run',
  'process.tool.child_history':
    'The history of the child session {child_session} is available via the read_session_reference tool',
  'process.tool.not_running': 'Background run "{id}" is not running',
  'process.tool.running': 'Background run "{id}" is still running — stop it first with process_stop',
  'process.tool.stopping': 'Stop requested for background run "{id}"',
  'process.tool.deleted': 'Background run "{id}" deleted',

  // --- Повторная привязка файла из workspace (ADR-115) ---
  'attach.message.from_workspace': 'File from the working directory: {path}',
  'attach.tool.attached':
    'File "{path}" attached; it will be available to the model on the next step of this turn',
  'attach.tool.deps_unavailable': 'Attachments are unavailable in this build',
  'attach.tool.delivery_unavailable':
    'File was uploaded, but message delivery to the session is unavailable in this context — the model will not see it',
  'attach.tool.disabled': 'Attachments are disabled on this instance',
  'attach.tool.not_found': 'File or attachment "{path}" not found',
  'attach.tool.not_a_file': '"{path}" is not a file',
  'attach.tool.too_large': 'File "{path}" is {size} bytes — the attachment limit is {limit} bytes',
  'attach.tool.unsupported_mime': 'File "{path}" cannot be attached: {detail}',
  'attach.tool.modality_unsupported':
    'File "{path}" is not attached: the current model does not accept {modality} attachments. Assign an auxiliary model for this modality (Settings → "Multimodal input", modalityModels) or ask the user to send the text or a description — re-attaching the file will not help',
  'attach.tool.unrecognized': 'File "{path}" format was not recognized — it cannot be attached',
  'attach.tool.queued':
    'File "{name}" will be sent as an attachment of the reply at the end of this turn',

  // --- Сохранение вложения в workspace (ADR-115): тул `save_attachment` ---
  'attach.tool.saved': 'Attachment saved to "{path}" ({size} bytes)',
  'attach.tool.ambiguous':
    'Several attachments match "{query}": {list}. Pass sha256 to pick one exactly',
  'attach.tool.no_attachment': 'This session has no media attachments',
  'attach.tool.exists':
    'File "{path}" already exists in the working directory — pass another path to save the attachment',
  'attach.tool.save_failed': 'Failed to save the attachment: {error}',

  // --- Каталог моделей для агента (ADR-115): тул `list_models` ---
  'models.list.header': 'Models (filter: {filter}; shown {shown} of {total}):',
  'models.list.current': 'Current: {model} ({modalities})',
  'models.list.defaults': 'Assigned by modality: {assignments}',
  'models.list.skipped': 'Skipped models with unknown modalities: {count}',
  'models.list.empty': 'No models found',
  'models.list.provider_unknown': 'Provider "{provider}" not found in the model catalog',
  'models.list.deps_unavailable': 'The model catalog is unavailable in this build',
  'models.list.unavailable': 'The model catalog is unavailable: {reason}',

  // --- Фоновые саб-агенты и лимит шагов (этап 1 roadmap 0.13, блок 4) ---
  'task.steps_limit':
    '[steps_limit] The subagent was stopped by the step limit ({limit}).',
  'task.steps_limit_empty':
    'The subagent exhausted the step limit ({limit}) and gave no textual answer; continue from its history or raise the limit',
  'task.context_budget':
    '[context_budget] Context budget reached ({tokens} tokens). Steps completed: {steps}. Unfinished: {tasks}',
  'subagent.context_budget':
    'Subagent stopped by the context budget ({tokens} tokens, steps: {steps})',
  'task.background_started':
    'The subagent is running in the background (sessionID: {id}). You will be notified automatically; do not poll its status.',
  'task.background_limit':
    'The background subagent limit for this session ({limit}) is reached — finish or cancel the running background subagents first',
  'task.background_disabled':
    'Background subagents are disabled on this instance (background.enabled = false) — run the subagent in the foreground',
  'task.resume_foreign_child':
    'Session {id} is not a subagent session of the current session — it cannot be continued from here',
  'task.resume_child_busy':
    'Session {id} is busy or already running — it cannot be continued right now',
  'task.model_unavailable':
    'Error: the model "{provider}/{model}" requested for the subagent is unavailable — the provider is not configured or the model is unknown',
  'task.model_not_in_catalog':
    'Error: the model "{provider}/{model}" requested for the subagent is not in the instance model catalog (or is disabled). Available: {available}. Use the list_models tool to pick a provider/model pair.',

  // --- SSH-ключи: UI раздела «Агенты» (ADR-076, T8) ---
  'sshKeys.title': 'SSH keys',
  'sshKeys.description': 'Per-agent SSH keys for git operations. Private keys and passphrases are encrypted at rest and are never shown after saving.',
  'sshKeys.add': 'Add key',
  'sshKeys.name': 'Name',
  'sshKeys.privateKey': 'Private key',
  'sshKeys.passphrase': 'Passphrase',
  'sshKeys.agents': 'Agents',
  'sshKeys.agentsHint': 'Agents allowed to use this key',
  'sshKeys.noAgents': 'No agents available',
  'sshKeys.replaceKeyHint': 'Leave empty to keep the current key. The stored private key is never displayed.',
  'sshKeys.new': 'New SSH key',
  'sshKeys.edit': 'Edit SSH key',
  'sshKeys.saved': 'SSH key saved',
  'sshKeys.saveError': 'Failed to save the SSH key: {error}',
  'sshKeys.deleted': 'SSH key deleted',
  'sshKeys.deleteError': 'Failed to delete the SSH key: {error}',
  'sshKeys.loadError': 'Failed to load SSH keys',
  'sshKeys.empty': 'No SSH keys configured',
  'sshKeys.linkedAgents': 'Linked agents',
  'sshKeys.noLinkedAgents': 'Not linked to any agent',
  'sshKeys.createdAt': 'Created',
  'sshKeys.deleteTitle': 'Delete SSH key',
  'sshKeys.deleteConfirm': 'Delete key "{name}"? This action cannot be undone.',
  'sshKeys.deleteConfirmAgents': 'Agents that lose access: {agents}',
  'sshKeys.nameExists': 'SSH key with name "{name}" already exists',
  'sshKeys.error.nameRequired': 'Name is required',
  'sshKeys.error.keyRequired': 'Private key is required',

  // --- Внешние события (ADR-089) ---
  'events.title': 'Events',
  'events.description': 'External event bindings and the routing journal. Events are normalized and routed to sessions by source/chat/thread; changes require the LEAD or ADMIN role.',
  'events.bindings.title': 'Bindings',
  'events.bindings.description': 'Stable bindings of external addresses (source/chat/thread) to a session, agent template or queue.',
  'events.bindings.add': 'Add binding',
  'events.bindings.empty': 'No event bindings configured',
  'events.bindings.loadError': 'Failed to load event bindings',
  'events.bindings.count': '{count, plural, one {# binding} other {# bindings}}',
  'events.bindings.noKey': 'no key',
  'events.bindings.noValue': '—',
  'events.bindings.saved': 'Binding saved',
  'events.bindings.saveError': 'Failed to save the binding: {error}',
  'events.bindings.deleted': 'Binding deleted',
  'events.bindings.deleteError': 'Failed to delete the binding: {error}',
  'events.bindings.deleteTitle': 'Delete binding',
  'events.bindings.deleteConfirm': 'Delete binding for "{source}"? This action cannot be undone.',
  'events.column.key': 'Key',
  'events.column.session': 'Session',
  'events.column.agent': 'Agent template',
  'events.column.project': 'Project',
  'events.mode.bound': 'bound',
  'events.mode.ephemeral': 'ephemeral',
  'events.mode.queue': 'queue',
  'events.mode.bind': 'bind (auto-bind)',
  'events.form.new': 'New binding',
  'events.form.edit': 'Edit binding',
  'events.form.source': 'Source',
  'events.form.sourceRequired': 'Source is required',
  'events.form.chatKey': 'Chat key',
  'events.form.threadKey': 'Thread key',
  'events.form.mode': 'Mode',
  'events.form.sessionId': 'Session ID',
  'events.form.agentTemplate': 'Agent template',
  'events.form.project': 'Project',
  'events.journal.title': 'Event journal',
  'events.journal.description': 'Latest processed events and their routing decisions.',
  'events.journal.empty': 'The event journal is empty',
  'events.journal.loadError': 'Failed to load the event journal',
  'events.journal.noDecision': 'no decision',
  'events.journal.reason': 'Reason',
  'events.journal.error': 'Error',
  'events.routes.title': 'Routing rules',
  'events.routes.description': 'Ordered rules (higher priority first) that route an incoming event to a session, ephemeral session or queue.',
  'events.routes.add': 'Add rule',
  'events.routes.empty': 'No routing rules configured',
  'events.routes.loadError': 'Failed to load routing rules',
  'events.routes.unnamed': 'Untitled rule',
  'events.routes.match': 'Match',
  'events.routes.target': 'Target',
  'events.routes.priority': 'Priority',
  'events.routes.anyEvent': 'any event',
  'events.routes.status.enabled': 'enabled',
  'events.routes.status.disabled': 'disabled',
  'events.routes.saved': 'Routing rule saved',
  'events.routes.saveError': 'Failed to save the routing rule: {error}',
  'events.routes.toggleError': 'Failed to toggle the routing rule: {error}',
  'events.routes.deleted': 'Routing rule deleted',
  'events.routes.deleteError': 'Failed to delete the routing rule: {error}',
  'events.routes.deleteTitle': 'Delete routing rule',
  'events.routes.deleteConfirm': 'Delete rule "{name}"? This action cannot be undone.',
  'events.routes.form.new': 'New routing rule',
  'events.routes.form.edit': 'Edit routing rule',
  'events.routes.form.name': 'Name',
  'events.routes.form.priority': 'Priority',
  'events.routes.form.enabled': 'Enabled',
  'events.routes.form.matchTitle': 'Match conditions',
  'events.routes.form.targetTitle': 'Target',
  'events.routes.form.source': 'Source',
  'events.routes.form.type': 'Event type',
  'events.routes.form.chatKey': 'Chat key',
  'events.routes.form.threadKey': 'Thread key',
  'events.routes.form.principalId': 'Principal ID',
  'events.routes.form.label': 'Label',
  'events.routes.form.keywords': 'Keywords',
  'events.routes.form.keywordsHelp': 'Comma or newline separated; any match triggers the rule.',
  'events.routes.form.mode': 'Delivery mode',
  'events.routes.form.sessionId': 'Session ID',
  'events.routes.form.agentTemplate': 'Agent template',
  'events.routes.form.project': 'Project',
  'events.routes.form.ttl': 'TTL',
  'events.routes.form.sessionRequired': 'Session ID is required for bound/queue mode',

  // --- External events: field tooltips, API keys (ADR-089) ---
  'events.form.sourceTooltip': 'Event source identifier, e.g. telegram, webhook or ci.',
  'events.form.modeTooltip': 'How the binding delivers events: to an existing session, to a temporary session or to the queue.',
  'events.form.projectTooltip': 'Project container for the bound/temporary session.',
  'events.form.sessionTooltip': 'Target session; the list is limited to the selected project.',
  'events.form.agentTooltip': 'Agent template used when the binding creates a session.',
  'events.form.chatKeyTooltip': 'Optional chat key (chat:<source>:<chatId>) to narrow the binding.',
  'events.form.threadKeyTooltip': 'Optional thread key (thread:<source>:<chatId>:<threadId>) — takes priority over the chat key.',

  'events.routes.form.nameTooltip': 'Human-readable rule name.',
  'events.routes.form.priorityTooltip': 'Higher value — earlier matching; ties keep file order.',
  'events.routes.form.enabledTooltip': 'Disabled rules are kept but not applied.',
  'events.routes.form.sourceTooltip': 'Match the event source exactly (empty — any).',
  'events.routes.form.typeTooltip': 'Match the event type exactly (empty — any).',
  'events.routes.form.chatKeyTooltip': 'Match the chat key (empty — any).',
  'events.routes.form.threadKeyTooltip': 'Match the thread key (empty — any).',
  'events.routes.form.principalIdTooltip': 'Match the sender principal id (empty — any).',
  'events.routes.form.labelTooltip': 'Match payload.label (empty — any).',
  'events.routes.form.keywordsTooltip': 'Substrings in the event text; any match triggers the rule.',
  'events.routes.form.modeTooltip': 'Where the matched event goes: session, temporary session or queue.',
  'events.routes.form.agentTooltip': 'Agent template for the temporary session.',
  'events.routes.form.projectTooltip': 'Project container for the temporary session.',
  'events.routes.form.ttlTooltip': 'Lifetime of the temporary session (e.g. 24h).',
  'events.routes.form.sessionTooltip': 'Target session for bound/queue rules.',

  'events.session.create': 'Create session',
  'events.keys.title': 'API keys',
  'events.keys.add': 'Add key',
  'events.keys.empty': 'No API keys yet',
  'events.keys.count': '{count, plural, one {# key} other {# keys}}',
  'events.keys.afterSaveHint': 'API keys can be added after the binding is saved — they are tied to its id.',
  'events.keys.loadError': 'Failed to load API keys',
  'events.keys.created': 'API key created',
  'events.keys.updated': 'API key updated',
  'events.keys.deleted': 'API key deleted',
  'events.keys.deleteError': 'Failed to delete the API key: {error}',
  'events.keys.deleteTitle': 'Delete API key',
  'events.keys.deleteConfirm': 'Delete API key "{label}"? Incoming events using it will stop working.',
  'events.keys.revoke': 'Revoke',
  'events.keys.revokeTitle': 'Revoke API key',
  'events.keys.revokeConfirm': 'Revoke API key "{label}"? Incoming events using it will stop working; you can delete it later.',
  'events.keys.revoked': 'API key revoked',
  'events.keys.revokeError': 'Failed to revoke the API key: {error}',
  'events.keys.copied': 'Copied',
  'events.keys.lastUsed': 'Last used',
  'events.keys.secretWarning': 'Copy the key now — it is shown only once and cannot be retrieved later.',
  'events.keys.curlTitle': 'Test request (curl)',
  'events.keys.status.active': 'Active',
  'events.keys.status.expired': 'Expired',
  'events.keys.status.revoked': 'Revoked',
  'events.keys.labelRequired': 'Label is required',
  'events.keys.meta.createdBy': 'Created by',
  'events.keys.meta.created': 'Created',
  'events.keys.meta.expires': 'Expires',
  'events.keys.meta.noExpiry': 'no expiry',
  'events.keys.meta.rateLimit': 'Limit',
  'events.keys.meta.noLimit': 'no limit',
  'events.keys.form.label': 'Label',
  'events.keys.form.labelTooltip': 'Required label; must be unique among the instance keys.',
  'events.keys.form.description': 'Description',
  'events.keys.form.descriptionTooltip': 'Optional: what this key is used for.',
  'events.keys.form.expiresAt': 'Expires on',
  'events.keys.form.expiresAtTooltip': 'Empty — no expiry; a date means the end of that day.',
  'events.keys.form.rateLimit': 'Requests/min limit',
  'events.keys.form.rateLimitTooltip': '0 or empty — global default (no limit).',

  'events.journal.key': 'Key',
  'events.journal.principal': 'Principal',
  'events.journal.openInLogs': 'Open in Logs & Audit',

  // --- Event settings (ADR-089, admin) ---
  'eventsConfig.title': 'Event settings',
  'eventsConfig.description': 'Runtime settings for external event handling: master switch, default mode, ephemeral session TTL, journal retention, source allow-list and the global per-key request limit.',
  'eventsConfig.enabled': 'External events enabled',
  'eventsConfig.enabledTooltip': 'Master switch: when off, incoming events are neither accepted nor routed.',
  'eventsConfig.defaultMode': 'Default mode',
  'eventsConfig.defaultModeTooltip': 'Where to route an event without an explicit binding or rule: to an existing session or to a temporary one.',
  'eventsConfig.ephemeralTtl': 'Ephemeral session TTL',
  'eventsConfig.ephemeralTtlTooltip': 'Lifetime of a temporary session: 30s, 15m, 1h, 24h, 7d.',
  'eventsConfig.journalRetentionDays': 'Journal retention, days',
  'eventsConfig.journalRetentionDaysTooltip': 'How many days the event journal is kept; 0 — no limit.',
  'eventsConfig.allowedSources': 'Allowed sources',
  'eventsConfig.allowedSourcesTooltip': 'Allow-list of event sources; empty — all allowed.',
  'eventsConfig.allowedSourcesPlaceholder': 'e.g. telegram',
  'eventsConfig.unknownAgentTemplate': 'Unknown agent template',
  'eventsConfig.unknownAgentTemplateTooltip': 'What to do when the referenced agent template is missing: drop the event or use the default agent.',
  'eventsConfig.unknownAgentTemplate.drop': 'Drop (drop)',
  'eventsConfig.unknownAgentTemplate.defaultAgent': 'Default agent (default-agent)',
  'eventsConfig.keyRateLimitPerMinute': 'Requests/min limit per key',
  'eventsConfig.keyRateLimitPerMinuteTooltip': 'Global default request-per-minute limit per binding API key; 0 — no limit. A key can override it.',
  'eventsConfig.decisionRouting': 'Decision routing of events',
  'eventsConfig.decisionRoutingTooltip': 'Smart classification of external events by a decision-model when no declarative rule matches (requires the decision layer enabled). Fail-safe: error or low confidence falls back to the default mode.',
  'eventsConfig.autoBind': 'Auto-bind (pin to session)',
  'eventsConfig.autoBindTooltip': 'Fallback: if the event has a chat/thread and no binding, rule or decision routing matched — create a new persistent session and bind this chat to it (EventBinding). Affects the fallback only.',
  'eventsConfig.autoBindAgentTemplate': 'Auto-bind agent template',
  'eventsConfig.autoBindAgentTemplateTooltip': 'Agent template for auto-bind sessions (agent id). Empty — default agent. An unknown template is handled by the “Unknown agent template” policy.',
  'eventsConfig.autoBindAgentTemplatePlaceholder': 'e.g. assistant',
  'eventsConfig.identityMap': 'Session owner mapping',
  'eventsConfig.identityMapTooltip': 'Maps an external sender to an instance user: key — chatKey (e.g. chat:telegram:123456) or principalId (tg:123456), value — the Synth user id. Applied when sessions are created from external events: the session belongs to the human instead of the gateway machine account and shows up in their session list and UI.',
  'eventsConfig.identityMapUserPlaceholder': 'user id',
  'eventsConfig.loadError': 'Failed to load event settings',
  'eventsConfig.saved': 'Event settings saved',
  'eventsConfig.saveError': 'Failed to save event settings: {error}',

  // --- Decision models (ADR-084, admin) ---
  'decisionConfig.title': 'Decision models',
  'decisionConfig.description': 'Runtime settings for the decision layer (System One: Clef/Jev/…): master switch, decision-protocol provider and model, confidence threshold.',
  'decisionConfig.enabled': 'Decision layer enabled',
  'decisionConfig.enabledTooltip': 'Master switch: when off, the decision-model is not used for quick answers, routing or event classification.',
  'decisionConfig.providerModel': 'Provider and model',
  'decisionConfig.providerTooltip': 'Decision-protocol provider: type "decision" (RouterAI, POST /decisions) or "systemone" (Ollama, POST /v1/systemone).',
  'decisionConfig.modelTooltip': 'Decision-layer model from the "Models" section of the selected provider (e.g. clef-flash).',
  'decisionConfig.confidenceThreshold': 'Confidence threshold',
  'decisionConfig.confidenceThresholdTooltip': 'Confidence threshold 0..1: below it the cascade falls back (fail-safe).',
  'decisionConfig.escalationLabel': 'Escalation model',
  'decisionConfig.escalationTooltip': 'Optional: used when the primary model returns a low-confidence or failed decision; leave empty to disable escalation.',
  'decisionConfig.escalationProviderTooltip': 'Decision-protocol provider of the escalation tier (leave empty for no escalation).',
  'decisionConfig.escalationModelTooltip': 'Escalation-tier model from the selected provider (e.g. clef). Leave empty for no escalation.',
  'decisionConfig.loadError': 'Failed to load decision settings',
  'decisionConfig.saved': 'Decision settings saved',
  'decisionConfig.saveError': 'Failed to save decision settings: {error}',
  'decisionConfig.metrics': 'Statistics',
  'decisionConfig.metricsDescription': 'Aggregate in-memory metrics of the decision cascade (process-wide, reset on restart).',
  'decisionConfig.metricsRefresh': 'Refresh',
  'decisionConfig.metricsReset': 'Reset',
  'decisionConfig.metricsResetConfirm': 'Reset decision-layer metrics? Counters will be zeroed.',
  'decisionConfig.metricsResetSuccess': 'Decision metrics reset',
  'decisionConfig.metricsLoadError': 'Failed to load decision metrics: {error}',
  'decisionConfig.metricsResetError': 'Failed to reset decision metrics: {error}',
  'decisionConfig.metricsEmpty': 'No data yet',
  'decisionConfig.metricCalls': 'Calls',
  'decisionConfig.metricHandled': 'Handled',
  'decisionConfig.metricFallback': 'Fallback',
  'decisionConfig.metricEscalated': 'Escalated',
  'decisionConfig.metricAttemptsPrimary': 'Attempts (primary)',
  'decisionConfig.metricAttemptsEscalation': 'Attempts (escalation)',
  'decisionConfig.metricRejected': 'Attempt statuses',
  'decisionConfig.rejectedOk': 'OK',
  'decisionConfig.rejectedLowConfidence': 'Low confidence',
  'decisionConfig.rejectedInvalid': 'Invalid label',
  'decisionConfig.rejectedNoAnswer': 'No answer',
  'decisionConfig.rejectedNoProvider': 'No provider',
  'decisionConfig.rejectedError': 'Error',
  'decisionConfig.metricsByModel': 'By model',
  'decisionConfig.metricModel': 'Model',
  'decisionConfig.metricLatencyAvg': 'Latency avg, ms',
  'decisionConfig.metricLatencyMax': 'Latency max, ms',

  // --- Service keys (ADR-052 stage I, admin) ---
  'serviceKeys.title': 'Service keys',
  'serviceKeys.description': 'Instance-scoped API keys for external services: scopes limit which endpoints the key can call, the project projection limits it to a subset of projects. The secret is shown only once — at creation.',
  'serviceKeys.listTitle': 'Keys',
  'serviceKeys.listDescription': 'Created keys and their status. Revoked and expired keys no longer authenticate.',
  'serviceKeys.count': '{count, plural, one {# key} other {# keys}}',
  'serviceKeys.add': 'Create key',
  'serviceKeys.empty': 'No service keys yet',
  'serviceKeys.loadError': 'Failed to load service keys',
  'serviceKeys.readOnly': 'Only an administrator can manage service keys. You can view the list, but creating, editing, revoking and deleting are unavailable.',
  'serviceKeys.created': 'Service key created',
  'serviceKeys.updated': 'Service key updated',
  'serviceKeys.deleted': 'Service key deleted',
  'serviceKeys.deleteError': 'Failed to delete the service key: {error}',
  'serviceKeys.deleteTitle': 'Delete service key',
  'serviceKeys.deleteConfirm': 'Delete service key "{label}"? Services using it will lose access immediately and the key cannot be restored.',
  'serviceKeys.revoke': 'Revoke',
  'serviceKeys.revokeTitle': 'Revoke service key',
  'serviceKeys.revokeConfirm': 'Revoke service key "{label}"? Services using it will lose access immediately; you can delete it later.',
  'serviceKeys.revoked': 'Service key revoked',
  'serviceKeys.revokeError': 'Failed to revoke the service key: {error}',
  'serviceKeys.copied': 'Copied',
  'serviceKeys.lastUsed': 'Last used',
  'serviceKeys.secretWarning': 'Copy the key now — it is shown only once and cannot be retrieved later.',
  'serviceKeys.curlTitle': 'Test request (curl)',
  'serviceKeys.labelRequired': 'Label is required',
  'serviceKeys.scopesRequired': 'Select at least one scope',
  'serviceKeys.status.active': 'Active',
  'serviceKeys.status.expired': 'Expired',
  'serviceKeys.status.revoked': 'Revoked',
  'serviceKeys.meta.roles': 'Roles',
  'serviceKeys.meta.scopes': 'Scopes',
  'serviceKeys.meta.projects': 'Projects',
  'serviceKeys.meta.noRoles': 'default (USER)',
  'serviceKeys.meta.allProjects': 'all projects',
  'serviceKeys.meta.createdBy': 'Created by',
  'serviceKeys.meta.created': 'Created',
  'serviceKeys.meta.expires': 'Expires',
  'serviceKeys.meta.noExpiry': 'no expiry',
  'serviceKeys.meta.rateLimit': 'Limit',
  'serviceKeys.meta.noLimit': 'no limit',
  'serviceKeys.form.label': 'Label',
  'serviceKeys.form.labelTooltip': 'Required label; must be unique among the instance service keys.',
  'serviceKeys.form.description': 'Description',
  'serviceKeys.form.descriptionTooltip': 'Optional: what this key is used for.',
  'serviceKeys.form.roles': 'Roles',
  'serviceKeys.form.rolesTooltip': 'Roles of the synthetic user the key authenticates as (endpoint availability / RBAC). Empty — USER.',
  'serviceKeys.form.rolesEmpty': 'Empty — USER',
  'serviceKeys.form.scopes': 'Scopes',
  'serviceKeys.form.scopesTooltip': 'Granted scopes: exact (e.g. events:ingest) or a wildcard family (events:*). At least one is required.',
  'serviceKeys.form.allowedProjects': 'Project projection',
  'serviceKeys.form.allowedProjectsTooltip': 'Restrict the key to a subset of projects. Empty — the instance policy (all projects).',
  'serviceKeys.form.allowedProjectsEmpty': 'Empty — all projects',
  'serviceKeys.form.rateLimit': 'Requests/min limit',
  'serviceKeys.form.rateLimitTooltip': 'Per-key request-per-minute limit; 0 or empty — no limit.',
  'serviceKeys.form.expiresAt': 'Expires on',
  'serviceKeys.form.expiresAtTooltip': 'Empty — no expiry; a date means the end of that day.',
  'serviceKeys.role.ADMIN': 'ADMIN',
  'serviceKeys.role.USER': 'USER',
  'serviceKeys.role.LEAD': 'LEAD',
  'serviceKeys.role.AUDITOR': 'AUDITOR',

  // --- Webhooks (ADR-052 stage II, admin) ---
  'webhooks.title': 'Webhooks',
  'webhooks.description': 'Outgoing event subscriptions: Synth signs each delivery with a per-subscription secret (HMAC-SHA256). The signing secret is shown only once.',
  'webhooks.listTitle': 'Subscriptions',
  'webhooks.listDescription': 'Subscriptions and their status. Disabled subscriptions are stored but do not receive deliveries.',
  'webhooks.count': '{count, plural, one {# subscription} other {# subscriptions}}',
  'webhooks.add': 'Create subscription',
  'webhooks.empty': 'No webhook subscriptions yet',
  'webhooks.loadError': 'Failed to load webhooks',
  'webhooks.readOnly': 'Only an administrator can manage webhooks. You can view the list, but creating, editing and deleting are unavailable.',
  'webhooks.created': 'Webhook subscription created',
  'webhooks.updated': 'Webhook subscription updated',
  'webhooks.deleted': 'Webhook subscription deleted',
  'webhooks.deleteError': 'Failed to delete the webhook: {error}',
  'webhooks.deleteTitle': 'Delete webhook',
  'webhooks.deleteConfirm': 'Delete webhook "{label}"? Deliveries stop immediately and it cannot be restored.',
  'webhooks.regenerate': 'Regenerate secret',
  'webhooks.regenerateTitle': 'Regenerate signing secret',
  'webhooks.regenerateConfirm': 'Regenerate the signing secret for "{label}"? The old secret stops working immediately; the new one is shown once.',
  'webhooks.regenerated': 'Signing secret regenerated',
  'webhooks.regenerateError': 'Failed to regenerate the secret: {error}',
  'webhooks.test': 'Test delivery',
  'webhooks.testOk': 'Test delivery sent (status: {status})',
  'webhooks.testError': 'Test delivery failed: {error}',
  'webhooks.copied': 'Copied',
  'webhooks.lastDelivery': 'Last delivery',
  'webhooks.lastDeliveryNever': 'no deliveries yet',
  'webhooks.status.ok': 'OK',
  'webhooks.status.failed': 'Failed',
  'webhooks.enabled.on': 'Enabled',
  'webhooks.enabled.off': 'Disabled',
  'webhooks.meta.url': 'URL',
  'webhooks.meta.events': 'Events',
  'webhooks.meta.eventsDefault': 'default set',
  'webhooks.meta.created': 'Created',
  'webhooks.meta.createdBy': 'Created by',
  'webhooks.meta.secretPrefix': 'Secret',
  'webhooks.form.title': 'New subscription',
  'webhooks.form.label': 'Label',
  'webhooks.form.labelTooltip': 'Required label; unique among the instance webhooks.',
  'webhooks.form.description': 'Description',
  'webhooks.form.descriptionTooltip': 'Optional: what this subscription is for.',
  'webhooks.form.url': 'Target URL',
  'webhooks.form.urlTooltip': 'HTTPS endpoint that receives POST requests. Private/loopback addresses are blocked by the egress.webhooks policy (SSRF protection); https is required unless the policy mode is off.',
  'webhooks.form.events': 'Events',
  'webhooks.form.eventsTooltip': 'Event patterns: exact (message.added) or wildcard (session.*). Empty — the default set.',
  'webhooks.form.eventsEmpty': 'Empty — default set',
  'webhooks.form.customPattern': 'Custom pattern',
  'webhooks.form.customPatternPlaceholder': 'e.g. message.*',
  'webhooks.form.addPattern': 'Add',
  'webhooks.form.patternInvalid': 'Invalid pattern (use foo.bar or foo.*)',
  'webhooks.form.patternDuplicate': 'Pattern is already in the list',
  'webhooks.form.enabled': 'Enabled',
  'webhooks.form.enabledTooltip': 'Disabled subscriptions are stored but do not receive deliveries.',
  'webhooks.labelRequired': 'Label is required',
  'webhooks.urlRequired': 'URL is required',
  'webhooks.urlInvalid': 'Enter a valid https URL',
  'webhooks.secretWarning': 'Copy the signing secret now — it is shown only once and cannot be retrieved later.',
  'webhooks.signatureTitle': 'Signature verification (Node.js)',
  'webhooks.signatureHint': 'Synth sends X-Synth-Signature: t=<unix>,v1=<hex>; verify HMAC-SHA256 over "<t>.<raw body>".',
  'webhooks.deliveries.title': 'Delivery log',
  'webhooks.deliveries.show': 'Delivery log',
  'webhooks.deliveries.hide': 'Hide log',
  'webhooks.deliveries.empty': 'No deliveries yet',
  'webhooks.deliveries.loadError': 'Failed to load deliveries',
  'webhooks.deliveries.attempts': '{count, plural, one {# attempt} other {# attempts}}',
  'webhooks.deliveries.response': 'HTTP',
  'webhooks.deliveries.error': 'Error',
  'webhooks.deliveries.event': 'Event',

  // --- External credentials (ADR-105 phase 4) ---
  'credentials.title': 'Accesses',
  'credentials.description': 'External accesses to OAuth connectors: Synth obtains a token via PKCE or device flow and stores it encrypted. The secret is never exposed — only the mask is shown.',
  'credentials.listTitle': 'External accesses',
  'credentials.listDescription': 'Your accesses to external services and MCP connectors. The token value is available to the MCP transport only — the UI shows a mask.',
  'credentials.count': '{count, plural, one {# access} other {# accesses}}',
  'credentials.add': 'Create access',
  'credentials.empty': 'No external accesses yet',
  'credentials.created': 'External access created',
  'credentials.copied': 'Copied',
  'credentials.authorizeStarted': 'Authorization URL received — open it and paste the code',
  'credentials.deviceStarted': 'Verification code received — enter it at the provider',
  'credentials.refresh': 'Reauthorize',
  'credentials.refreshed': 'Token refreshed',
  'credentials.refreshError': 'Failed to refresh the token: {error}',
  'credentials.revoke': 'Revoke',
  'credentials.revokeTitle': 'Revoke access',
  'credentials.revokeConfirm': 'Revoke the access to “{provider}”? The token stops working; it can only be restored by a new authorization.',
  'credentials.revoked': 'Access revoked',
  'credentials.revokeError': 'Failed to revoke the access: {error}',
  'credentials.bind': 'Bind to connector',
  'credentials.bound': 'Access bound to the connector',
  'credentials.bindError': 'Failed to bind the access: {error}',
  'credentials.status.active': 'active',
  'credentials.status.expired': 'expired',
  'credentials.status.revoked': 'revoked',
  'credentials.status.error': 'error',
  'credentials.meta.clientId': 'Client ID',
  'credentials.meta.scopes': 'Scopes',
  'credentials.meta.scopesEmpty': 'not set',
  'credentials.meta.secretMask': 'Secret mask',
  'credentials.meta.expiresAt': 'Expires',
  'credentials.meta.expiresNever': 'never',
  'credentials.meta.lastUsedAt': 'Last used',
  'credentials.meta.lastUsedNever': 'never used',
  'credentials.meta.connector': 'Connector',
  'credentials.form.title': 'New external access',
  'credentials.form.provider': 'Provider',
  'credentials.form.providerTooltip': 'OAuth provider key from the instance catalog (oauth.providers).',
  'credentials.form.providerRequired': 'Specify the provider',
  'credentials.form.scopes': 'Scopes',
  'credentials.form.scopesTooltip': 'Requested rights, comma-separated. Empty — the provider default scopes.',
  'credentials.form.flow': 'Authorization flow',
  'credentials.form.flow.authorize': 'Authorization code (PKCE)',
  'credentials.form.flow.device': 'Device code (device flow)',
  'credentials.form.start': 'Get authorization URL',
  'credentials.form.authorizationUrl': 'Authorization URL',
  'credentials.form.authorizationHint': 'Open the URL in a browser, approve the access and paste the issued code below.',
  'credentials.form.code': 'Authorization code',
  'credentials.form.codeTooltip': 'The code issued by the provider on the access approval page.',
  'credentials.form.codeRequired': 'Enter the authorization code',
  'credentials.form.codeSubmit': 'Confirm code',
  'credentials.form.deviceTitle': 'Approval at the provider',
  'credentials.form.deviceCode': 'Provider code',
  'credentials.form.devicePending': 'Waiting for approval…',
  'credentials.form.devicePoll': 'Check status',
  'credentials.form.connector': 'MCP connector',
  'credentials.form.connectorPlaceholder': '— select a connector —',
  'credentials.form.connectorSubmit': 'Bind',
  'credentials.errors.unauthorized': 'Authentication required: sign in again',
  'credentials.errors.forbidden': 'Not enough permissions for this access',
  'credentials.errors.notFound': 'Access not found — it may have been removed',
  'credentials.errors.conflict': 'The action is not possible: the access is revoked or requires a new authorization',
  'credentials.errors.providerUnknown': 'The provider is not registered in this instance',
  'credentials.errors.generic': 'Failed to perform the operation',

  // --- Maintenance (ADR-091/ADR-092, admin) ---
  'maintenance.title': 'Maintenance',
  'maintenance.description': 'Instance health, data schema migrations, backups and restore. Restore is an offline operation and is applied on the next instance start.',
  'maintenance.loadError': 'Failed to load maintenance status',
  'maintenance.status.title': 'Status',
  'maintenance.status.description': 'Instance version, data directory, schema and health checks (synth doctor).',
  'maintenance.status.version': 'Version',
  'maintenance.status.dataDir': 'Data directory',
  'maintenance.status.schema': 'Schema',
  'maintenance.status.schemaValue': '{current} / {expected}',
  'maintenance.status.doctorSummary': 'warnings: {warn}, failures: {fail}',
  'maintenance.status.healthOk': 'Instance is healthy',
  'maintenance.status.healthFail': 'Problems detected',
  'maintenance.status.check': 'Check',
  'maintenance.status.checking': 'Checking...',
  'maintenance.status.checkError': 'Failed to run instance checks: {error}',
  'maintenance.status.checks': 'Checks',
  'maintenance.status.checksEmpty': 'No checks yet — press "Check".',
  'maintenance.restart.title': 'Restart',
  'maintenance.restart.description': 'Graceful instance restart: the process exits with code 75 and is started again by a supervisor; settings are applied on start.',
  'maintenance.restart.mode': 'Mode',
  'maintenance.restart.mode.disabled': 'disabled',
  'maintenance.restart.mode.process': 'process (external supervisor)',
  'maintenance.restart.mode.supervisor': 'supervisor (dev.sh)',
  'maintenance.restart.unsupported': 'Restart is unavailable: the instance runs without a supervisor (SYNTH_RESTART_MODE=disabled).',
  'maintenance.restart.hintProcess': 'The process will exit with code 75 and must be restarted by an external supervisor (Kubernetes restartPolicy, Docker restart policy, systemd, pm2). Without one the instance will stay stopped.',
  'maintenance.restart.hintSupervisor': 'The process will exit with code 75 and scripts/dev.sh will start it again.',
  'maintenance.restart.action': 'Restart',
  'maintenance.restart.confirmTitle': 'Restart instance',
  'maintenance.restart.confirm': 'Active streams will be interrupted; saved settings will be applied after start. Continue?',
  'maintenance.restart.inProgress': 'Restarting…',
  'maintenance.restart.inProgressHint': 'Waiting for the instance to come back (up to 90 seconds); the page reloads automatically.',
  'maintenance.restart.timeout': 'The instance did not come back within 90 seconds. Check the logs and restart it manually.',
  'maintenance.restart.loadError': 'Failed to load restart status',
  'maintenance.restart.error': 'Failed to restart: {error}',
  'maintenance.schema.title': 'Data schema',
  'maintenance.schema.description': 'Applied and pending data schema migrations.',
  'maintenance.schema.applied': 'Applied migrations',
  'maintenance.schema.pending': 'Pending migrations',
  'maintenance.schema.noneApplied': 'none',
  'maintenance.schema.nonePending': 'No pending migrations',
  'maintenance.schema.version': 'v{version}',
  'maintenance.schema.apply': 'Apply migrations',
  'maintenance.schema.applying': 'Applying...',
  'maintenance.schema.applyTitle': 'Apply migrations',
  'maintenance.schema.applyConfirm': 'A safety copy will be created, then the data will be modified with no way back except restoring from that copy. Continue?',
  'maintenance.schema.applySuccess': 'Migrations applied: {count}',
  'maintenance.schema.applyError': 'Failed to apply migrations: {error}',
  'maintenance.schema.loadError': 'Failed to load migrations',
  'maintenance.backups.title': 'Backups',
  'maintenance.backups.description': 'Data directory archives in {dataDir}/backups. By default backups exclude backups/, tmp/, logs/, locks, workspaces/ and secrets/ unless the matching option is set.',
  'maintenance.backups.count': '{count, plural, one {# backup} other {# backups}}',
  'maintenance.backups.empty': 'No backups yet',
  'maintenance.backups.create': 'Create backup',
  'maintenance.backups.creating': 'Creating...',
  'maintenance.backups.createSuccess': 'Backup created: {name}',
  'maintenance.backups.createError': 'Failed to create a backup: {error}',
  'maintenance.backups.optSecrets': 'Secrets',
  'maintenance.backups.optSecretsHint': 'Include secrets/ — the archive becomes a secret itself.',
  'maintenance.backups.optWorkspace': 'Workspace',
  'maintenance.backups.optWorkspaceHint': 'Include project working directories (workspaces/).',
  'maintenance.backups.optLive': 'Live',
  'maintenance.backups.optLiveHint': 'Take from a running service: the snapshot is not transactional.',
  'maintenance.backups.download': 'Download',
  'maintenance.backups.delete': 'Delete',
  'maintenance.backups.deleteTitle': 'Delete backup',
  'maintenance.backups.deleteConfirm': 'Delete archive "{name}"? This cannot be undone.',
  'maintenance.backups.deleted': 'Backup deleted',
  'maintenance.backups.deleteError': 'Failed to delete the backup: {error}',
  'maintenance.backups.metaCreated': 'Created',
  'maintenance.backups.metaSize': 'Size',
  'maintenance.backups.metaSchema': 'Schema',
  'maintenance.backups.metaInstance': 'Version',
  'maintenance.backups.metaEntries': 'Entries',
  'maintenance.backups.badgeSecrets': 'secrets',
  'maintenance.backups.badgeWorkspace': 'workspace',
  'maintenance.backups.badgeEncrypted': 'encrypted',
  'maintenance.backups.encryptedCli': 'Available only via the CLI (synth backup/restore)',
  'maintenance.backups.metaUnavailable': 'metadata unavailable',
  'maintenance.restore.title': 'Restore',
  'maintenance.restore.description': 'Restore the data directory from an archive.',
  'maintenance.restore.warning': 'Restore returns the directory to the snapshot (extra and corrupted files are deleted); workspaces/ is preserved if it is not in the archive; it is applied on the next instance start.',
  'maintenance.restore.selectLabel': 'Archive from the list',
  'maintenance.restore.selectPlaceholder': 'Select an archive',
  'maintenance.restore.uploadLabel': 'Upload a file (.tar.gz)',
  'maintenance.restore.validate': 'Validate',
  'maintenance.restore.validating': 'Validating...',
  'maintenance.restore.validOk': 'Archive passed validation',
  'maintenance.restore.validFail': 'Archive failed validation: {problem}',
  'maintenance.restore.validateError': 'Failed to validate the archive: {error}',
  'maintenance.restore.needArchive': 'Select or upload an archive to validate',
  'maintenance.restore.manifestTitle': 'Manifest',
  'maintenance.restore.manifestSchema': 'Data schema',
  'maintenance.restore.manifestInstance': 'Package version',
  'maintenance.restore.manifestEntries': 'Entries',
  'maintenance.restore.manifestSecrets': 'Secrets',
  'maintenance.restore.manifestWorkspace': 'Workspace',
  'maintenance.restore.manifestCreated': 'Created',
  'maintenance.restore.schedule': 'Schedule restore',
  'maintenance.restore.scheduleTitle': 'Schedule restore',
  'maintenance.restore.scheduleConfirm': 'Schedule a restore from "{archive}"? It is applied on the next instance start; the data directory returns to the snapshot and extra files are deleted.',
  'maintenance.restore.scheduleSuccess': 'Restore scheduled; it will be applied on the next instance start',
  'maintenance.restore.scheduleError': 'Failed to schedule the restore: {error}',
  'maintenance.restore.pending': 'Scheduled from {archive} (created {date})',
  'maintenance.restore.cancel': 'Cancel',
  'maintenance.restore.cancelled': 'Scheduled restore cancelled',
  'maintenance.restore.cancelError': 'Failed to cancel the restore: {error}',
  'maintenance.restore.yes': 'yes',
  'maintenance.restore.no': 'no',
  'maintenance.audit.title': 'Maintenance journal',
  'maintenance.audit.description': 'History of instance lifecycle operations (backup, restore, migrations): time, operation, outcome and author. Newest first.',
  'maintenance.audit.loadError': 'Failed to load the maintenance journal',
  'maintenance.audit.count': '{count, plural, one {# entry} other {# entries}}',
  'maintenance.audit.refresh': 'Refresh',
  'maintenance.audit.refreshing': 'Refreshing...',
  'maintenance.audit.empty': 'The journal is empty',
  'maintenance.audit.colTime': 'Time',
  'maintenance.audit.colActor': 'Author',
  'maintenance.audit.actorUnknown': 'not specified',
  'maintenance.audit.status.ok': 'ok',
  'maintenance.audit.status.failed': 'failed',
  'maintenance.audit.status.scheduled': 'scheduled',
  'maintenance.audit.clear': 'Clear journal',
  'maintenance.audit.clearTitle': 'Clear the maintenance journal',
  'maintenance.audit.clearConfirm': 'Delete all maintenance journal entries? This cannot be undone.',
  'maintenance.audit.cleared': 'Journal cleared: {count} removed',
  'maintenance.audit.clearError': 'Failed to clear the journal: {error}',

  // --- Metrics / observability (admin) ---
  'observability.title': 'Metrics',
  'observability.description': 'Prometheus metrics export and instance readiness: state, token and the /metrics and /ready endpoints.',
  'observability.loadError': 'Failed to load metrics settings',
  'observability.statusError': 'Failed to load metrics state',
  'observability.status.title': 'State',
  'observability.status.description': 'Current export, readiness and storage state.',
  'observability.field.source': 'Source',
  'observability.field.ready': 'Readiness (/ready)',
  'observability.field.storage': 'Storage',
  'observability.field.storageBackend': 'Storage backend',
  'observability.field.version': 'Version',
  'observability.field.uptime': 'Uptime',
  'observability.field.series': 'Series in exposition',
  'observability.field.expositionSize': 'Exposition size',
  'observability.field.droppedSeries': 'Dropped series',
  'observability.state.enabled': 'enabled',
  'observability.state.disabled': 'disabled',
  'observability.state.running': 'running',
  'observability.state.notRunning': 'not running',
  'observability.ready.ok': '200 — ready',
  'observability.ready.fail': '503 — not ready',
  'observability.storage.ok': 'ok',
  'observability.storage.degraded': 'degraded',
  'observability.source.env': 'env (SYNTH_METRICS_ENABLED)',
  'observability.source.runtime': 'runtime (UI)',
  'observability.source.config': 'config.yaml',
  'observability.source.default': 'default',
  'observability.export.title': 'Export',
  'observability.export.description': 'Publishing the Prometheus exposition on /metrics.',
  'observability.export.enabled': 'Metrics export',
  'observability.export.enabledHint': 'Serve /metrics (Prometheus exposition 0.0.4). Disabled by default.',
  'observability.export.envLocked': 'The value is set via SYNTH_METRICS_ENABLED — it cannot be changed in the UI.',
  'observability.saved': 'Metrics settings saved',
  'observability.saveError': 'Failed to save settings: {error}',
  'observability.restartRequired': 'Changes take effect after an instance restart.',
  'observability.restart.button': 'Restart instance',
  'observability.restart.confirmTitle': 'Restart instance',
  'observability.restart.confirm': 'Active streams will be interrupted; settings will be applied after start. Continue?',
  'observability.restart.started': 'Restart request sent',
  'observability.restart.error': 'Failed to restart: {error}',
  'observability.token.title': 'Token',
  'observability.token.description': 'Bearer token for /metrics. The value is not shown after it is saved.',
  'observability.token.state': 'Token',
  'observability.token.configured': 'configured',
  'observability.token.notConfigured': 'not configured',
  'observability.token.source.env': 'env (SYNTH_METRICS_TOKEN)',
  'observability.token.source.file': 'secrets/metrics-token file',
  'observability.token.source.none': 'none',
  'observability.token.writeOnly': 'The saved value is not shown: it is stored in SYNTH_METRICS_TOKEN or secrets/metrics-token.',
  'observability.token.envLocked': 'The token is set via SYNTH_METRICS_TOKEN — it cannot be managed in the UI.',
  'observability.token.field': 'New token',
  'observability.token.placeholder': 'Bearer token for Prometheus',
  'observability.token.set': 'Set',
  'observability.token.delete': 'Delete',
  'observability.token.generate': 'Generate',
  'observability.token.generatedCopied': 'Token generated and copied',
  'observability.token.generatedManual': 'Token generated — copy it manually',
  'observability.token.required': 'Enter a token',
  'observability.token.deleteTitle': 'Delete token',
  'observability.token.deleteConfirm': 'Requests to /metrics will no longer require authorization (when export is enabled). Continue?',
  'observability.token.saved': 'Token set',
  'observability.token.deleted': 'Token deleted',
  'observability.token.saveError': 'Failed to set the token: {error}',
  'observability.token.deleteError': 'Failed to delete the token: {error}',
  'observability.token.conflict': 'The token is set via SYNTH_METRICS_TOKEN — it cannot be changed in the UI.',
  'observability.endpoints.title': 'Endpoints',
  'observability.endpoints.description': 'Public instance endpoints (outside /api/v2).',
  'observability.endpoints.metrics': 'Metrics',
  'observability.endpoints.ready': 'Readiness',
  'observability.copy': 'Copy',
  'observability.copied': 'Copied',
  'observability.refresh': 'Refresh status',
  'observability.refreshing': 'Refreshing...',
  'observability.hints.title': 'Hints',
  'observability.hints.description': 'Prometheus setup.',
  'observability.hints.scrape': 'Example scrape_config for Prometheus:',
  'observability.hints.copy': 'Copy config',

  // --- Context management: new-session defaults + window policy (admin) ---
  'settings.contextManagement.title': 'Context management',
  'settings.contextManagement.description': 'Defaults for new sessions and the context window policy: optimization strategy, summarization, sliding window and prompt limits.',
  'settings.help.contextManagement.section.context-defaults':
    'Context optimization strategy and summarization / sliding-window parameters applied to new sessions. Existing sessions are unchanged — they keep their own values in session settings.',
  'settings.contextDefaults.title': 'Defaults for new sessions',
  'settings.contextDefaults.description': 'Context optimization strategy and summarization / sliding-window parameters applied to new sessions.',
  'settings.contextDefaults.newSessionsHint': 'Applies to new sessions; in an existing session it is changed in its settings.',
  'settings.contextDefaults.loadError': 'Failed to load the context defaults',
  'settings.contextDefaults.retry': 'Retry',
  'settings.contextDefaults.saved': 'Context defaults saved',
  'settings.contextDefaults.saveError': 'Failed to save the defaults: {error}',
  'settings.contextDefaults.reset': 'Reset to defaults',
  'settings.contextDefaults.resetHint': 'Removes the saved values; the default applies.',
  'settings.contextDefaults.resetDone': 'Context defaults reset',
  'settings.contextDefaults.resetError': 'Failed to reset the defaults: {error}',
  'settings.contextDefaults.saving': 'Saving...',
  'settings.contextDefaults.source.runtime': 'runtime (UI)',
  'settings.contextDefaults.source.config': 'Default',
  'settings.contextDefaults.source.default': 'default',
  'settings.contextDefaults.field.integer': 'Enter an integer ≥ 1',
  'settings.contextDefaults.field.nonNegative': 'Enter an integer ≥ 0',
  'settings.contextDefaults.field.percent': 'Enter a value from 1 to 100',
  'settings.contextDefaults.strategy.label': 'Context optimization strategy',
  'settings.contextDefaults.strategy.description': 'What the instance does when the history approaches the model context window.',
  'settings.contextDefaults.strategy.none': 'No optimization',
  'settings.contextDefaults.strategy.sliding_window': 'Sliding window',
  'settings.contextDefaults.strategy.summarization': 'Summarization',
  'settings.contextDefaults.strategy.compaction': 'Compaction',
  'settings.contextDefaults.strategyHint.none': 'The history is sent as is; when it overflows, the window policy applies.',
  'settings.contextDefaults.strategyHint.sliding_window': 'Older messages drop out of the prompt when the history exceeds the limit.',
  'settings.contextDefaults.strategyHint.summarization': 'The older part of the history is compressed into a summary; recent messages stay as is.',
  'settings.contextDefaults.strategyHint.compaction': 'The older part of the history is compressed into working state for the code (paths, commands, errors, decisions); the verbatim tail is kept.',
  'settings.contextDefaults.summarization.title': 'Summarization',
  'settings.contextDefaults.summarization.description': 'Compresses the older part of the history into a summary before the prompt is sent to the model.',
  'settings.contextDefaults.summarization.triggerMode': 'Trigger mode',
  'settings.contextDefaults.summarization.triggerMode.hint': 'By message count or by token fill of the context window.',
  'settings.contextDefaults.summarization.triggerMode.messages': 'By messages',
  'settings.contextDefaults.summarization.triggerMode.tokens': 'By tokens',
  'settings.contextDefaults.summarization.afterN': 'After N messages',
  'settings.contextDefaults.summarization.afterN.hint': 'How many messages to accumulate before creating a summary.',
  'settings.contextDefaults.summarization.tokenThreshold': 'Token threshold',
  'settings.contextDefaults.summarization.tokenThreshold.hint': 'Share of the context window after which a summary is created.',
  'settings.contextDefaults.summarization.keepTokens': 'Verbatim tail',
  'settings.contextDefaults.summarization.keepTokens.hint': 'How many latest history tokens stay uncompressed.',
  'settings.contextDefaults.compaction.title': 'Compaction',
  'settings.contextDefaults.compaction.description': 'Compresses the older part of the history into working state for the code: paths, commands, errors and decisions.',
  'settings.contextDefaults.compaction.keepTokens': 'Verbatim tail',
  'settings.contextDefaults.compaction.keepTokens.hint': 'How many latest history tokens compaction leaves as is.',
  'settings.contextDefaults.compaction.tokenThreshold': 'Trigger threshold',
  'settings.contextDefaults.compaction.tokenThreshold.hint': 'Share of the context window after which compaction runs.',
  'settings.contextDefaults.slidingWindow.title': 'Sliding window',
  'settings.contextDefaults.slidingWindow.description': 'Limits the history to the latest messages or tokens.',
  'settings.contextDefaults.slidingWindow.mode': 'Window mode',
  'settings.contextDefaults.slidingWindow.mode.messages': 'By messages',
  'settings.contextDefaults.slidingWindow.mode.tokens': 'By tokens',
  'settings.contextDefaults.slidingWindow.messageLimit': 'Message limit',
  'settings.contextDefaults.slidingWindow.messageLimit.hint': 'How many latest messages to keep in the prompt.',
  'settings.contextDefaults.slidingWindow.tokenThreshold': 'Token threshold',
  'settings.contextDefaults.slidingWindow.tokenThreshold.hint': 'Share of the context window the window keeps.',

  // --- Context window policy (admin) ---
  'settings.contextWindow.title': 'Context window',
  'settings.contextWindow.description': 'Instance-wide policy for prompt size near the model context window: warn or block the turn. Changes apply immediately, no restart required.',
  'settings.contextWindow.loadError': 'Failed to load the context window policy',
  'settings.contextWindow.retry': 'Retry',
  'settings.contextWindow.current': 'current',
  'settings.contextWindow.saved': 'Context window policy saved',
  'settings.contextWindow.saveError': 'Failed to save the policy: {error}',
  'settings.contextWindow.resetDone': 'Policy reset to the default value',
  'settings.contextWindow.resetError': 'Failed to reset the policy: {error}',
  'settings.contextWindow.conflict': 'The policy is set via SYNTH_CONTEXT_WINDOW_POLICY — it cannot be changed in the UI.',
  'settings.contextWindow.envBanner': 'Set by the SYNTH_CONTEXT_WINDOW_POLICY environment variable',
  'settings.contextWindow.policy.title': 'Context window policy',
  'settings.contextWindow.policy.description': 'What the instance does when the prompt gets close to the model context window.',
  'settings.contextWindow.policy.label': 'Context window policy',
  'settings.contextWindow.mode.off': 'Off',
  'settings.contextWindow.mode.warn': 'Warn',
  'settings.contextWindow.mode.enforce': 'Block',
  'settings.contextWindow.modeHint.off': 'No warnings and no blocking: the turn always goes to the model.',
  'settings.contextWindow.modeHint.warn': 'Warn in the UI: a toast at 80% of the window and a banner above the composer at 90%. The server does not block the turn.',
  'settings.contextWindow.modeHint.enforce': 'Warnings plus a hard stop: the server does not call the model when the prompt does not fit the window.',
  'settings.contextWindow.reset': 'Reset to the default value',
  'settings.contextWindow.resetHint': 'Removes the saved value; the default applies.',
  'settings.contextWindow.field.source': 'Source',
  'settings.contextWindow.field.defaults': 'Default value',
  'settings.contextWindow.source.env': 'env (SYNTH_CONTEXT_WINDOW_POLICY)',
  'settings.contextWindow.source.runtime': 'runtime (UI)',
  'settings.contextWindow.source.config': 'Default',
  'settings.contextWindow.source.default': 'default',
  'settings.contextWindow.hints.title': 'How it works',
  'settings.contextWindow.hints.description': 'Where the window comes from and when blocking applies.',
  'settings.contextWindow.hints.window': 'The window comes from the model catalog (`context_window`); when it is unknown, an estimate of 200,000 tokens is used.',
  'settings.contextWindow.hints.enforce': 'Blocking works only in Block mode and with a known model window: an unknown window never blocks.',

  // --- Sticky notes limits (admin) ---
  'settings.stickyNotes.title': 'Notes',
  'settings.stickyNotes.description': 'Instance-wide limits on notes: how many notes a session can have and the maximum length of one note.',
  'settings.stickyNotes.hint': 'Instance limits: they apply to all sessions; existing notes are not changed.',
  'settings.stickyNotes.loadError': 'Failed to load the note limits',
  'settings.stickyNotes.retry': 'Retry',
  'settings.stickyNotes.saved': 'Note limits saved',
  'settings.stickyNotes.saveError': 'Failed to save the note limits: {error}',
  'settings.stickyNotes.reset': 'Reset to defaults',
  'settings.stickyNotes.resetHint': 'Removes the saved values; the default applies.',
  'settings.stickyNotes.resetDone': 'Note limits reset to defaults',
  'settings.stickyNotes.resetError': 'Failed to reset the note limits: {error}',
  'settings.stickyNotes.saving': 'Saving...',
  'settings.stickyNotes.source.runtime': 'runtime (UI)',
  'settings.stickyNotes.source.config': 'Default',
  'settings.stickyNotes.source.default': 'default',
  'settings.stickyNotes.field.maxCount': 'Maximum notes',
  'settings.stickyNotes.field.maxCount.hint': 'How many notes one session can hold.',
  'settings.stickyNotes.field.maxChars': 'Maximum characters per note',
  'settings.stickyNotes.field.maxChars.hint': 'Longer notes are rejected on creation and edit.',
  'settings.stickyNotes.field.range': 'Enter an integer from {min} to {max}',
  'settings.help.contextManagement.section.context-sticky-notes':
    'Instance-wide limits on notes (sticky notes): the number of notes per session and the maximum note length. Limits apply to all sessions; existing notes are not changed.',

  // --- ADR-107 / PROP-047: портал памяти (read-only) ---
  'settings.memory.title': 'Memory',
  'settings.memory.description':
    'Memory plugin portal: provider readiness, facts with provenance, retrieval indexes and index management.',
  'settings.memory.unavailable':
    'The memory portal is unavailable: the memory service is not configured.',
  'settings.memory.refresh': 'Refresh',
  'settings.memory.refreshing': 'Refreshing...',
  'settings.memory.retry': 'Retry',
  'settings.memory.status.title': 'State',
  'settings.memory.status.description': 'Memory provider, readiness and counters of the portal.',
  'settings.memory.status.error': 'Failed to load the memory state: {error}',
  'settings.memory.field.readiness': 'Readiness',
  'settings.memory.field.provider': 'Provider',
  'settings.memory.field.providerMode': 'Mode',
  'settings.memory.field.providerActive': 'Provider active',
  'settings.memory.field.namespace': 'Namespace',
  'settings.memory.field.factsTotal': 'Facts (total)',
  'settings.memory.field.factsActive': 'Facts (active)',
  'settings.memory.field.indexesTotal': 'Indexes (total)',
  'settings.memory.field.indexesReady': 'Indexes (ready)',
  'settings.memory.field.indexesStale': 'Indexes (stale)',
  'settings.memory.field.indexesFailed': 'Indexes (failed)',
  'settings.memory.field.indexesBuilding': 'Indexes (building)',
  'settings.memory.readiness.ready': 'ready',
  'settings.memory.readiness.degraded': 'degraded',
  'settings.memory.readiness.stale': 'stale',
  'settings.memory.readiness.unavailable': 'unavailable',
  'settings.memory.provider.mode.inline': 'inline',
  'settings.memory.provider.mode.remote': 'remote',
  'settings.memory.provider.mode.none': 'not connected',
  'settings.memory.provider.active': 'active',
  'settings.memory.provider.inactive': 'inactive',
  'settings.memory.facts.title': 'Facts',
  'settings.memory.facts.description':
    'Statements remembered by the memory plugin: text, kind, status, confidence and provenance.',
  'settings.memory.facts.error': 'Failed to load facts: {error}',
  'settings.memory.facts.empty': 'No facts yet',
  'settings.memory.facts.filter.query': 'Search by text',
  'settings.memory.facts.filter.queryPlaceholder': 'Text of the fact',
  'settings.memory.facts.filter.apply': 'Search',
  'settings.memory.facts.filter.status': 'Status',
  'settings.memory.facts.filter.kind': 'Kind',
  'settings.memory.facts.filter.all': 'All',
  'settings.memory.facts.page': 'Showing {from}–{to} of {total}',
  'settings.memory.facts.prev': 'Back',
  'settings.memory.facts.next': 'Forward',
  'settings.memory.facts.column.text': 'Text',
  'settings.memory.facts.column.kind': 'Kind',
  'settings.memory.facts.column.status': 'Status',
  'settings.memory.facts.column.confidence': 'Confidence',
  'settings.memory.facts.column.provenance': 'Source',
  'settings.memory.facts.column.version': 'Version',
  'settings.memory.facts.detail.title': 'Fact details',
  'settings.memory.facts.detail.error': 'Failed to load the fact: {error}',
  'settings.memory.facts.detail.capturedAt': 'Captured',
  'settings.memory.facts.detail.updatedAt': 'Updated',
  'settings.memory.facts.detail.validUntil': 'Valid until',
  'settings.memory.facts.detail.supersededBy': 'Superseded by',
  'settings.memory.facts.detail.projectId': 'Project',
  'settings.memory.facts.detail.userId': 'User',
  'settings.memory.facts.kind.decision': 'decision',
  'settings.memory.facts.kind.constraint': 'constraint',
  'settings.memory.facts.kind.reference': 'reference',
  'settings.memory.facts.kind.preference': 'preference',
  'settings.memory.facts.kind.observation': 'observation',
  'settings.memory.facts.status.candidate': 'candidate',
  'settings.memory.facts.status.active': 'active',
  'settings.memory.facts.status.superseded': 'superseded',
  'settings.memory.facts.status.retracted': 'retracted',
  'settings.memory.indexes.title': 'Indexes',
  'settings.memory.indexes.description':
    'Built corpora for retrieval: source, state, generation and the embedding fingerprint.',
  'settings.memory.indexes.error': 'Failed to load indexes: {error}',
  'settings.memory.indexes.empty': 'No indexes yet',
  'settings.memory.indexes.column.name': 'Name',
  'settings.memory.indexes.column.state': 'State',
  'settings.memory.indexes.column.generation': 'Generation',
  'settings.memory.indexes.column.embedding': 'Embedding',
  'settings.memory.indexes.column.volume': 'Volume',
  'settings.memory.indexes.column.updated': 'Updated',
  'settings.memory.indexes.state.building': 'building',
  'settings.memory.indexes.state.ready': 'ready',
  'settings.memory.indexes.state.stale': 'stale',
  'settings.memory.indexes.state.failed': 'failed',
  'settings.memory.indexes.volume': '{documents} docs · {chunks} chunks',
  'settings.memory.indexes.error.hint': 'Index build failed',
  'settings.memory.indexes.create': 'Create index',
  'settings.memory.indexes.createSubmit': 'Create',
  'settings.memory.indexes.createCancel': 'Cancel',
  'settings.memory.indexes.form.name': 'Name',
  'settings.memory.indexes.form.namePlaceholder': 'Index name',
  'settings.memory.indexes.form.nameRequired': 'Enter the index name.',
  'settings.memory.indexes.form.scope': 'Scope',
  'settings.memory.indexes.form.scope.project': 'Project',
  'settings.memory.indexes.form.scope.instance': 'Instance',
  'settings.memory.indexes.form.scope.instanceHint':
    'Shared by the whole instance: available to all users and all sessions.',
  'settings.memory.indexes.form.scope.instanceFilesHint':
    'Files are taken from the working directory of this project.',
  'settings.memory.indexes.form.scope.instanceFilesWarning':
    'The workspace contents of the project will become available to all users of the instance.',
  'settings.memory.indexes.form.scope.sourceProject': 'Source project (workspace)',
  'settings.memory.indexes.form.source': 'Source',
  'settings.memory.indexes.form.source.files': 'files',
  'settings.memory.indexes.form.source.facts': 'facts',
  'settings.memory.indexes.form.filter': 'Filter',
  'settings.memory.indexes.form.filterPlaceholder': 'Glob or predicate (optional)',
  'settings.memory.indexes.form.project': 'Project',
  'settings.memory.indexes.form.projectNone': 'Not selected',
  'settings.memory.indexes.form.projectRequired': 'Select the project for the index.',
  'settings.memory.indexes.rebuild': 'Rebuild',
  'settings.memory.indexes.remove': 'Delete',
  'settings.memory.indexes.removeConfirmTitle': 'Delete the index?',
  'settings.memory.indexes.removeConfirm': 'Index "{name}" and its chunks will be deleted.',
  'settings.memory.indexes.created': 'Index "{name}" created',
  'settings.memory.indexes.rebuilt': 'Rebuild of index "{name}" started',
  'settings.memory.indexes.deleted': 'Index "{name}" deleted',
  'settings.memory.indexes.providerUnavailable': 'The memory plugin is not activated.',
  'settings.memory.indexes.scopeBadge.instance': 'Instance',
  'settings.memory.indexes.column.actions': 'Actions',

  // --- Консолидация фактов (PROP-047) ---
  'settings.memory.consolidate.open': 'Consolidate',
  'settings.memory.consolidate.title': 'Consolidation of facts',
  'settings.memory.consolidate.description':
    'Find duplicate facts and mark the outdated ones as superseded.',
  'settings.memory.consolidate.project': 'Project',
  'settings.memory.consolidate.projectAll': 'All projects',
  'settings.memory.consolidate.threshold': 'Similarity threshold',
  'settings.memory.consolidate.thresholdHint': 'From 0.5 to 0.99.',
  'settings.memory.consolidate.thresholdInvalid':
    'The threshold must be between 0.5 and 0.99.',
  'settings.memory.consolidate.dryRun': 'Only show (dry run)',
  'settings.memory.consolidate.dryRunHint': 'Report what would be replaced, change nothing.',
  'settings.memory.consolidate.run': 'Run',
  'settings.memory.consolidate.running': 'Running...',
  'settings.memory.consolidate.cancel': 'Cancel',
  'settings.memory.consolidate.confirmTitle': 'Consolidate facts?',
  'settings.memory.consolidate.confirm':
    'Duplicate facts will be marked as superseded: the outdated versions are replaced by the current ones.',
  'settings.memory.consolidate.report': 'Clusters: {clusters}, superseded: {superseded}, kept: {kept}',
  'settings.memory.consolidate.reportDryRun':
    'Clusters: {clusters}, superseded: {superseded}, kept: {kept} (dry run)',
  'settings.memory.consolidate.providerUnavailable': 'The memory plugin is not activated.',

  // --- Граф памяти (PROP-047) ---
  'settings.memory.graph.title': 'Graph',
  'settings.memory.graph.description':
    'Entities, facts and the relations between them: relations are built from `[[entity]]` mentions in the fact text.',
  'settings.memory.graph.project': 'Project',
  'settings.memory.graph.projectAll': 'All projects',
  'settings.memory.graph.entity': 'Entity',
  'settings.memory.graph.entityPlaceholder': 'Entity name (empty — the whole graph)',
  'settings.memory.graph.depth': 'Depth',
  'settings.memory.graph.depthHint': 'From 1 to 3.',
  'settings.memory.graph.depthInvalid': 'The depth must be between 1 and 3.',
  'settings.memory.graph.build': 'Build',
  'settings.memory.graph.stats': 'Entities: {entities}, facts: {facts}, relations: {edges}',
  'settings.memory.graph.empty': 'No relations yet: add `[[entity]]` to the fact text',
  'settings.memory.graph.entitiesTitle': 'Entities',
  'settings.memory.graph.entitiesEmpty': 'No entities yet',
  'settings.memory.graph.entityFacts': '{count, plural, one {# fact} other {# facts}}',
  'settings.memory.graph.selectedTitle': 'Entity: {name}',
  'settings.memory.graph.relationsTitle': 'Relations',
  'settings.memory.graph.relationsEmpty': 'No relations yet',
  'settings.memory.graph.relationUnknown': 'related',
  'settings.memory.graph.relationMentions': 'mentions',
  'settings.memory.graph.relationCoOccurs': 'co-occurs',
  'settings.memory.graph.factsTitle': 'Related facts',
  'settings.memory.graph.factsEmpty': 'No related facts yet',
  'settings.memory.graph.providerUnavailable': 'The memory plugin is not activated.',
  'settings.memory.graph.canvas.ariaLabel':
    'Memory graph: {entities} entities, {facts} facts, {edges} relations',
  'settings.memory.graph.canvas.hint':
    'Click an entity in the graph to rebuild it around that entity',
  'settings.memory.graph.canvas.legendEntity': 'Entity',
  'settings.memory.graph.canvas.legendFact': 'Fact',
  'settings.memory.graph.canvas.relationUnknown': 'related',
  'settings.memory.graph.canvas.relationMentions': 'mentions',
  'settings.memory.graph.canvas.relationCoOccurs': 'co-occurs',

  'sessionCreate.project': 'Project',

  // --- ADR-102: аналитика и отчёты (UI, волна 2) ---
  'analytics.title': 'Analytics & reports',
  'analytics.description': 'Reports from pre-aggregated daily rollups (UTC)',
  'analytics.tab.usage': 'Usage & cost',
  'analytics.tab.activity': 'Activity',
  'analytics.tab.decision': 'Decision',
  'analytics.tab.prompt': 'Cache & efficiency',
  'analytics.filter.period': 'Period',
  'analytics.preset.7d': '7 days',
  'analytics.preset.30d': '30 days',
  'analytics.preset.90d': '90 days',
  'analytics.preset.custom': 'Custom',
  'analytics.filter.from': 'From',
  'analytics.filter.to': 'To',
  'analytics.filter.user': 'User',
  'analytics.filter.project': 'Project',
  'analytics.filter.model': 'Model',
  'analytics.filter.agent': 'Agent',
  'analytics.filter.groupBy': 'Group by',
  'analytics.filter.all': 'All',
  'analytics.axis.day': 'Day',
  'analytics.axis.user': 'User',
  'analytics.axis.project': 'Project',
  'analytics.axis.model': 'Model',
  'analytics.axis.agent': 'Agent',
  'analytics.axis.provider': 'Provider',
  'analytics.group.modelAgent': 'Model + agent',
  'analytics.column.cost': 'Cost, {currency}',
  'analytics.measure.input_tokens': 'Input',
  'analytics.measure.output_tokens': 'Output',
  'analytics.measure.cache_read_tokens': 'Cache read',
  'analytics.measure.cache_write_tokens': 'Cache write',
  'analytics.measure.reasoning_tokens': 'Reasoning',
  'analytics.measure.requests': 'Requests',
  'analytics.measure.messages': 'Messages',
  'analytics.measure.duration_ms': 'Duration',
  'analytics.measure.sessions_created': 'Sessions created',
  'analytics.measure.sessions_archived': 'Sessions archived',
  'analytics.measure.messages_user': 'User messages',
  'analytics.measure.messages_assistant': 'Assistant messages',
  'analytics.measure.messages_tool': 'Tool messages',
  'analytics.measure.tool_calls': 'Tool calls',
  'analytics.measure.errors': 'Errors',
  'analytics.measure.aborts': 'Aborts',
  'analytics.measure.turns': 'Turns',
  'analytics.measure.calls': 'Calls',
  'analytics.measure.handled': 'Handled',
  'analytics.measure.fallback': 'Fallback',
  'analytics.measure.escalated': 'Escalated',
  'analytics.measure.attempts': 'Attempts',
  'analytics.measure.rejected': 'Rejected',
  'analytics.measure.total_tokens': 'Total tokens',
  'analytics.measure.cache_hit_rate': 'Cache hit rate',
  'analytics.measure.reasoning_ratio': 'Reasoning share',
  'analytics.measure.output_tps': 'Output speed',
  'analytics.export.csv': 'CSV',
  'analytics.export.json': 'JSON',
  'analytics.exportError': 'Failed to download the report',
  'analytics.print': 'Generate report',
  'analytics.print.title': 'Analytics report',
  'analytics.print.period': 'Period',
  'analytics.print.generatedAt': 'Generated',
  'analytics.print.filters': 'Filters',
  'analytics.print.noFilters': 'none',
  'analytics.print.summary': 'Summary',
  'analytics.summary.cost': 'Cost',
  'analytics.summary.tokens': 'Tokens',
  'analytics.summary.requests': 'Requests',
  'analytics.summary.cacheHit': 'Cache hit rate',
  'analytics.summary.sessions': 'Sessions created',
  'analytics.summary.messages': 'Messages',
  'analytics.summary.toolCalls': 'Tool calls',
  'analytics.summary.errors': 'Errors',
  'analytics.summary.reasoningShare': 'Reasoning share',
  'analytics.summary.tps': 'Output speed',
  'analytics.forbidden': 'This report is not available for your role',
  'analytics.forbiddenHint': 'Cross-instance reports (Decision, summary) are available to LEAD, ADMIN and AUDITOR. Other reports are limited to your own data.',
  'analytics.summaryForbidden': 'The instance summary is not available for your role — only your own data is shown.',
  'analytics.loadError': 'Failed to load the report',
  'analytics.empty': 'No data for the selected period',
  'analytics.total': 'Total',
  'analytics.sortBy': 'Sort by "{column}"',
  'analytics.utcNote': 'Period and daily buckets are in UTC.',

  // --- Settings help (stage 2) ---
  'settings.help.profile.section.main': 'Profile avatar shown in chats and lists; PNG/JPEG up to 500 KB.',
  'settings.help.profile.section.name': 'Core profile data: the login is set by an administrator, the name is editable.',
  'settings.help.profile.section.contacts': 'Contact details for notifications and teamwork; all fields are optional.',
  'settings.help.profile.section.teamRole': 'Team role used for reporting; it does not affect access rights.',
  'settings.help.profile.section.notes': 'Free-form notes about you; saved together with your profile.',
  'settings.help.profile.section.onboarding': 'Onboarding interview status: completed or still offered.',
  'settings.help.profile.section.identities': 'External accounts (e.g. Telegram) linked to your profile; their sessions belong to you.',
  'settings.help.profile.username': 'Account login; read-only — changed by an administrator.',
  'settings.help.profile.displayName': 'Name shown to other participants; falls back to the login when empty.',
  'settings.help.profile.email': 'Email for contacts and notifications; format user@example.com.',
  'settings.help.profile.phone': 'Contact phone in any format, e.g. +7 900 000-00-00.',
  'settings.help.profile.teamRole': 'Team role (developer, administrator, etc.); does not affect Synth permissions.',
  'settings.help.profile.notes': 'Free-form text about you; used by the assistant as extra context.',
  'settings.help.profile.interviewCompleted': 'Turn on when the interview is finished: the assistant will not offer it again.',
  'settings.help.profile.identityClaimCode': 'One-time code from chat (e.g. from the Telegram bot) used to link an external account.',
  'settings.help.appearance.section.theme-mode': 'Theme mode (system, light, dark) and color preset; applied immediately.',
  'settings.help.appearance.section.ui-scale': 'Interface scale from 50% to 120%; affects text and control sizes. The chat area scales separately — see the Chat section.',
  'settings.help.appearance.section.language': 'Interface language (Russian or English); applied immediately across all screens.',
  'settings.help.appearance.theme': 'Color palette from the preset list; the choice is saved with the Save button.',
  'settings.help.notifications.section.categories': 'Popup notification categories; history is always kept in the status panel.',
  'settings.help.notifications.connection': 'Show notifications when the server connection is lost or restored; on by default.',
  'settings.help.notifications.streaming': 'Show generation start and completion; off by default.',
  'settings.help.notifications.queue': 'Show queue stalls, clearing, and resumption; on by default.',
  'settings.help.notifications.message': 'Show notifications about message actions; off by default.',
  'settings.help.notifications.error': 'Show send errors, loading failures, and other issues; on by default.',
  'settings.help.notifications.system': 'Show informational system status messages; on by default.',
  'settings.help.chat.section.intermediate-text': 'Where to show intermediate responses: between blocks (inline) or at the bottom of the chat (bottom); inline by default.',
  'settings.help.chat.section.chat-scale': 'Chat area scale: affects only answer text, code blocks and spacing in the message feed; panels, the tree, settings and the composer are unchanged. Final size = global scale × chat scale.',
  'settings.help.mcp.section.main': 'Your HTTP/SSE MCP servers; visible only to you and attached to sessions per administrator policy.',
  'settings.help.skills.section.list': 'All available skills with level, scope, and trust badges; click one to open details.',
  'settings.help.skills.section.detail': 'The SKILL.md body and supporting files of the selected skill; untrusted skills show a warning.',

  // --- Settings help: events and routing (stage 2) ---
  'settings.help.eventsAdmin.section.events-bindings': 'Source-to-session bindings: events from a source go to the selected session or agent template.',
  'settings.help.eventsAdmin.section.events-routes': 'Routing rules: event attributes choose a session, a new session, or chat binding.',
  'settings.help.eventsAdmin.keys': 'Binding API keys: an external service sends events with a Bearer key; the secret is shown once.',
  'settings.help.routing.section.routing-main': 'Global routing master switch: when off, the session model is used without automatic selection.',
  'settings.help.routing.section.routing-strategy': 'How to pick a model: automatically by task type, by cost, or by both signals together.',
  'settings.help.routing.section.routing-content': 'Models for coding, chat, and research; used when the strategy considers the task type.',
  'settings.help.routing.section.routing-escalation': 'Quality check: an uncertain or too-short reply is retried on the fallback model.',
  'settings.help.routing.section.routing-cost': 'Cost saving: short requests go to the cheap model, long ones to the main model.',
  'settings.help.routing.section.routing-subagent': 'Separate model for sub-agents; Auto inherits the parent agent model.',
  'settings.help.routing.section.routing-dictionaries': 'Keyword dictionaries for task classification; user overrides take precedence over system ones.',
  'settings.help.routing.enabled': 'Enables automatic model selection for new and current sessions; off uses the session model.',
  'settings.help.routing.strategy': 'Routing mode: auto, content, cost, or content + cost; auto by default.',
  'settings.help.routing.contentCodingProvider': 'Provider for coding tasks; empty uses the session main model provider.',
  'settings.help.routing.contentCodingModel': 'Coding model from the provider enabled models; empty falls back to the strategy.',
  'settings.help.routing.contentChatProvider': 'Provider for chat and general questions; empty uses the session main model provider.',
  'settings.help.routing.contentChatModel': 'Chat model from the provider enabled models; empty falls back to the strategy.',
  'settings.help.routing.contentResearchProvider': 'Provider for analysis and research; empty uses the session main model provider.',
  'settings.help.routing.contentResearchModel': 'Research model from the provider enabled models; empty falls back to the strategy.',
  'settings.help.routing.escalation': 'Enables reply quality checks: low-confidence requests are retried on the fallback model.',
  'settings.help.routing.escalationProvider': 'Fallback model provider; must be enabled and available.',
  'settings.help.routing.escalationModel': 'Fallback model for the retry; the list is limited to the selected provider.',
  'settings.help.routing.escalationMinLength': 'Minimum reply length in characters; shorter replies count as uncertain; default 10.',
  'settings.help.routing.cost': 'Enables cost saving: short requests use the cheap model, long ones the main model.',
  'settings.help.routing.costProvider': 'Cheap model provider; empty uses the session main model provider.',
  'settings.help.routing.costModel': 'Cheap model for short requests; the list is limited to the selected provider.',
  'settings.help.routing.costThreshold': 'Request length threshold in tokens: below uses the cheap model, above the main one; default 500.',
  'settings.help.routing.subagent': 'Enables a separate model for sub-agents; off inherits the agent model.',
  'settings.help.routing.subagentModel': 'Model for sub-agents, or Auto to match the parent agent; auto by default.',

  // --- Settings help: integrations (stage 2) ---
  'settings.help.mcpAdmin.section.mcp-admin-main': 'MCP server registry: system and user servers with their transport, availability, and author.',
  'settings.help.mcpAdmin.section.mcp-admin-form': 'MCP server form: name, description, transport, and connection details (URL or command).',
  'settings.help.mcpAdmin.section.mcp-admin-permissions': 'MCP tool availability per Plan and Act mode: per server and per tool.',
  'settings.help.mcpAdmin.section.mcp-admin-network': 'Network policy for user HTTP MCP servers: allowed or blocked hosts and CIDRs (SSRF protection).',
  'settings.help.mcpAdmin.section.policy': 'MCP tool enablement policy: which definitions are sent to the model prompt.',
  'settings.help.mcpAdmin.serverName': 'Unique registry name (letters, digits, hyphen); used in MCP tool names.',
  'settings.help.mcpAdmin.serverDescription': 'Description for the model: included in the prompt and helps pick server tools.',
  'settings.help.mcpAdmin.type': 'Transport type: HTTP (streamable), legacy SSE, or stdio process; stdio is admin-only.',
  'settings.help.mcpAdmin.command': 'Command that starts the stdio server, e.g. npx or python; shown for stdio only.',
  'settings.help.mcpAdmin.args': 'Command-line arguments separated by spaces; quote arguments that contain spaces.',
  'settings.help.mcpAdmin.env': 'stdio process environment variables, one KEY=value per line; empty lines are ignored.',
  'settings.help.mcpAdmin.url': 'HTTP/SSE MCP endpoint URL, e.g. http://localhost:8765/mcp.',
  'settings.help.mcpAdmin.masterEnabled': 'Master availability: a disabled server is unavailable in every project and session.',
  'settings.help.mcpAdmin.enabledByDefault': 'Auto-enable in new projects; existing projects keep their own setting.',
  'settings.help.mcpAdmin.permissionsDefault': 'Default availability for all server tools; per-tool settings override it.',
  'settings.help.mcpAdmin.permissionsPerTool': 'Availability of a specific tool per mode; without a setting it inherits All tools.',
  'settings.help.mcpAdmin.networkMode': 'Mode: deny blocks the listed addresses, allow permits only the listed ones; deny by default.',
  'settings.help.mcpAdmin.networkList': 'Hosts, domains, and CIDR subnets for the rule; an empty allow list blocks every address.',
  'settings.help.mcpAdmin.networkExceptions': 'Rule exceptions: addresses and hosts where the mode does not apply.',
  'settings.help.mcpAdmin.networkCheckUrl': 'URL for an offline policy check without an HTTP request: parsing, DNS, and rule matching.',
  'settings.help.mcpAdmin.policy': 'MCP tool enablement policy: consistency, available, or auto; auto by default.',
  'settings.help.builtinTools.section.main': 'Built-in tools: capability groups and individual tools for agents; clearing a checkbox disables the tool.',
  'settings.help.builtinTools.section.policy': 'Policy for sending built-in tool definitions to the model prompt.',
  'settings.help.builtinTools.policy': 'Built-in tool enablement mode: consistency, available, or auto; consistency by default.',
  'settings.help.skillsAdmin.section.skills-admin-list': 'Skill registry: name, scope, trust, and availability; instance skills can be edited and deleted.',
  'settings.help.skillsAdmin.section.skills-admin-master': 'Master gate: disabled categories, groups, and skills are unavailable in every project and session.',
  'settings.help.skillsAdmin.section.skills-admin-new-projects': 'New project seed: what not to enable by default; existing projects are unchanged.',
  'settings.help.skillsAdmin.section.skills-admin-diagnostics': 'SKILL.md discovery and validation diagnostics: loading errors and warnings.',
  'settings.help.skillsAdmin.section.policy': 'Skill enablement policy: which skills are offered to the model and the user.',
  'settings.help.skillsAdmin.name': 'Unique skill name (letters, digits, hyphen); cannot be changed after creation.',
  'settings.help.skillsAdmin.description': 'Short description for the catalog and the model; required, up to 1024 characters.',
  'settings.help.skillsAdmin.body': 'SKILL.md body (markdown instructions); loaded by the model when the skill is invoked.',
  'settings.help.skillsAdmin.filePath': 'Supporting file path relative to the skill directory, e.g. references/checklist.md.',
  'settings.help.skillsAdmin.fileContent': 'Supporting file content; saved together with the skill.',
  'settings.help.skillsAdmin.policy': 'Skill enablement policy: consistency, available, or auto; auto by default.',
  'settings.help.commands.section.commands-list': 'All available slash commands: source, scope, and availability; unavailable ones show a reason.',
  'settings.help.commands.section.commands-diagnostics': 'Command diagnostics: shadowed and colliding names.',
  'settings.help.commands.section.commands-bundles': 'Bundles: several skills plus shared instructions invoked by a single slash command.',
  'settings.help.commands.name': 'Unique bundle name (letters, digits, hyphen); becomes a slash command and cannot change after creation.',
  'settings.help.commands.description': 'Bundle description for the command catalog; required, up to 1024 characters.',
  'settings.help.commands.skills': 'Skills included in the bundle; at least one is required.',
  'settings.help.commands.instruction': 'Shared bundle instruction (markdown); added to the context when invoked.',
  'settings.help.eventsConfig.section.events-config-main': 'Runtime settings for external event handling: ingress, routing and key limits; applied immediately.',
  'settings.help.webhooks.section.webhooks-list': 'Outgoing event subscriptions: delivery URLs, pattern filters and last delivery status.',
  'settings.help.webhooks.customPattern': 'Extra event pattern: an exact name (message.added) or a wildcard (session.*); added to the list above.',
  'settings.help.serviceKeys.section.service-keys-list': 'Instance-scoped keys: roles, scopes and project projection; the secret is shown once on creation.',

  // --- Settings help: security and network (stage 2) ---
  'settings.help.security.section.security-gateway': 'LLM traffic filter: secret obfuscation, request limits, and audit across all sessions.',
  'settings.help.security.section.security-patterns': 'Secret detection rules using regular expressions; matches are replaced with placeholders.',
  'settings.help.security.section.security-protected-paths': 'End-to-end protection for file and shell tools: denied paths, approval, and reply timeout.',
  'settings.help.security.gatewayEnabled': 'Gateway master switch: when off, model requests run without obfuscation or limits.',
  'settings.help.security.logPayloads': 'Also write obfuscated requests and responses to the LLM log; data may be sensitive.',
  'settings.help.security.inputMode': 'Action on a detected secret: obfuscate replaces it with a placeholder, block rejects the request.',
  'settings.help.security.rateLimitUser': 'Maximum LLM requests per user per minute; at least 1, 60 by default.',
  'settings.help.security.rateLimitProvider': 'Maximum requests to one provider per minute in total; 120 by default.',
  'settings.help.security.patterns': 'Regex rules: type is the log label, regex is the secret pattern; invalid regex is not saved.',
  'settings.help.security.protectedPathsEnabled': 'Enables protected path checks; when off, file and shell tools skip them.',
  'settings.help.security.askTimeoutEnabled': 'Limit how long an approval request waits; when off, it waits indefinitely.',
  'settings.help.security.askTimeoutSeconds': 'Seconds to wait for approval; empty uses the global 30 s, 0 disables the timeout.',
  'settings.help.security.deniedPaths': 'Absolute paths with exact match that are blocked; one per line.',
  'settings.help.security.deniedPrefixes': 'Directory prefixes: any path inside them is blocked; matching is case-sensitive.',
  'settings.help.security.approvalPaths': 'Paths allowed only after user confirmation (ask).',
  'settings.help.security.deniedCommandPrefixes': 'Shell command prefixes blocked entirely, e.g. rm -rf; applies to shell only.',
  'settings.help.network.section.network-proxy': 'Outgoing traffic through HTTP/HTTPS/SOCKS5 proxies: profiles, host rules, and timeouts; restart required.',
  'settings.help.network.section.network-tls': 'Outgoing TLS trust: CA bundle, default mTLS client, and per-host certificates; restart required.',
  'settings.help.network.proxyEnabled': 'Use a proxy for outgoing requests; when off, connections go directly.',
  'settings.help.network.proxyMode': 'all sends all traffic via the default profile; selected uses only hosts matched by a rule.',
  'settings.help.network.proxyDefaultProfile': 'Profile for all mode and rules without an explicit profile; the first profile is picked automatically.',
  'settings.help.network.proxyNoProxy': 'Hosts and CIDRs that always go directly and ignore proxy rules; takes precedence over rules.',
  'settings.help.network.proxyFromEnv': 'Use standard HTTP(S)_PROXY/NO_PROXY environment variables as a proxy settings source.',
  'settings.help.network.proxyFallbackDirect': 'Try a direct connection when the proxy is unavailable; may bypass egress policy.',
  'settings.help.network.proxyConnectTimeout': 'Proxy connection timeout in milliseconds; 5000 by default.',
  'settings.help.network.profiles': 'Named proxies with URL, Basic auth, and TLS/mTLS; password and PEM are write-only.',
  'settings.help.network.profileAuth': 'Basic auth login and password for the proxy; the password is set separately and never returned.',
  'settings.help.network.profileName': 'Stable profile name (letters, digits, hyphen, underscore); cannot change after creation.',
  'settings.help.network.profileLabel': 'Human-readable profile label for lists; does not affect routing.',
  'settings.help.network.profileUrl': 'Proxy URL with http://, https://, or socks5:// scheme, e.g. http://proxy.corp:3128.',
  'settings.help.network.profileUsername': 'Basic auth login; the password is entered separately and never shown after saving.',
  'settings.help.network.profilePassword': 'Basic auth password: write-only, not returned after saving; 409 when set via env.',
  'settings.help.network.profileTls': 'TLS and mTLS to the https proxy itself: CA, client certificate, and certificate verification.',
  'settings.help.network.profileTlsCaFile': 'Path to the CA file used to verify the proxy certificate; an alternative to uploading PEM below.',
  'settings.help.network.profileTlsCertFile': 'Path to the client certificate for mTLS to an https proxy.',
  'settings.help.network.profileTlsKeyFile': 'Path to the client certificate private key; not returned by the API.',
  'settings.help.network.profileTlsRejectUnauthorized': 'Verify the proxy certificate against the CA; disabling verification is not recommended.',
  'settings.help.network.profileTlsCaPem': 'CA PEM bundle for this profile only; write-only, not returned after saving.',
  'settings.help.network.profileTlsClientCert': 'Client certificate PEM for mTLS to the proxy; write-only, not listed.',
  'settings.help.network.profileTlsClientKey': 'Client certificate private key; write-only, the value is never returned.',
  'settings.help.network.rules': 'Host routing rules: order is priority and the first match wins.',
  'settings.help.network.ruleHosts': 'Hosts or CIDRs for the rule: exact name, *.suffix, or IP/subnet.',
  'settings.help.network.ruleLabel': 'Rule label for lists and debugging; does not affect routing.',
  'settings.help.network.ruleAction': 'proxy routes through a profile, direct always connects without a proxy.',
  'settings.help.network.ruleProfile': 'Profile for action=proxy; empty uses the default profile.',
  'settings.help.network.target': 'Target URL check against the saved configuration: HEAD request without redirects or body.',
  'settings.help.network.targetUrl': 'Target URL to test routing, e.g. https://api.openai.com/v1/models; saved settings are used.',
  'settings.help.network.tlsRejectUnauthorized': 'Verify server certificates against trusted CAs; disabling it turns verification off for all outgoing TLS.',
  'settings.help.network.tlsCa': 'Extra CA bundle for verifying outgoing TLS servers; one or more PEM certificates.',
  'settings.help.network.tlsCaPem': 'CA PEM certificates (BEGIN CERTIFICATE), several allowed; read-only when set via env/config.',
  'settings.help.network.tlsClient': 'Default client certificate and key for servers that require mTLS; the key is write-only.',
  'settings.help.network.tlsClientCert': 'Client certificate PEM for mTLS; write-only, not shown after upload.',
  'settings.help.network.tlsClientKey': 'Client certificate private key; write-only, the value is never returned.',
  'settings.help.network.tlsMappings': 'Client certificates for specific hosts; first match wins, * means all hosts.',
  'settings.help.network.tlsMappingHosts': 'Exact host, *.suffix, or * (all hosts); no scheme or path.',
  'settings.help.network.tlsMappingLabel': 'Mapping label for the list; it does not affect certificate selection.',
  'settings.help.network.tlsMappingCert': 'Client certificate PEM for this host; write-only, not displayed.',
  'settings.help.network.tlsMappingKey': 'Client certificate private key; write-only, the value is never returned.',
  'settings.help.builtinTools.section.egress-tools': 'Limits outgoing HTTP requests of built-in tools: mode and host/CIDR lists.',
  'settings.help.builtinTools.egressMode': 'deny blocks the listed addresses; allow permits only the listed ones.',
  'settings.help.builtinTools.egressList': 'Main list: exact hostname, *.suffix, or CIDR/IP; an empty allow list blocks everything.',
  'settings.help.builtinTools.egressExceptions': 'Allow exceptions are checked before the main list and can unblock a host.',
  'settings.help.builtinTools.egressCheckUrl': 'URL for an offline check: parsing, DNS, and rule matching without an HTTP request.',
  'settings.help.webhooks.section.egress-webhooks': 'Limits webhook delivery targets: deny/allow/off mode and host/CIDR lists.',
  'settings.help.webhooks.egressMode': 'deny blocks the addresses; allow permits only the listed ones; off disables checks (dev).',
  'settings.help.webhooks.egressList': 'Main list: exact hostname, *.suffix, or CIDR/IP; an empty allow list blocks everything.',
  'settings.help.webhooks.egressExceptions': 'Allow exceptions are checked before the main list and can unblock a host.',
  'settings.help.webhooks.egressCheckUrl': 'URL for an offline check: parsing, DNS, and rule matching without an HTTP request.',

  // --- Settings help: providers, models, agents (stage 2) ---
  'settings.help.providers.section.providers-form': 'Provider form: API connection, default model, price currency, and icon.',
  'settings.help.providers.section.providers-list': 'Provider registry: type, URL, enabled state, and available models.',
  'settings.help.providers.name': 'Unique registry name (letters, digits, hyphen); cannot be changed after creation.',
  'settings.help.providers.type': 'API protocol: OpenAI, Anthropic, Ollama, Decision, or System One; sets the request format.',
  'settings.help.providers.url': 'Base API URL with version, e.g. https://api.example.com/v1; for Ollama — the server address.',
  'settings.help.providers.apiKey': 'Provider secret key; when editing, an empty field keeps the current key.',
  'settings.help.providers.currency': 'Default price currency for the provider (RUB, USD, CNY); a model can override it.',
  'settings.help.providers.enabled': 'A disabled provider stays in the registry but is not used by sessions or models.',
  'settings.help.providers.icon': 'Provider icon in lists and chat: favicon, Remixicon, or a brand set.',
  'settings.help.models.section.models-default': 'Instance-level provider + model pair for new sessions when no model is set explicitly.',
  'settings.help.models.section.models-filters': 'Search and filters for the model list; they do not change models or their settings.',
  'settings.help.models.section.models-add-manual': 'Manual model creation for models missing from the provider response: id, context, and prices.',
  'settings.help.models.defaultProvider': 'Default model provider for new sessions; the list contains only providers with models.',
  'settings.help.models.defaultModelLabel': 'Default model chosen from the enabled models of the selected provider.',
  'settings.help.models.search': 'Case-insensitive search by model name; works together with the provider filter.',
  'settings.help.models.filterProvider': 'Show models of the selected provider only; All providers clears the filter.',
  'settings.help.models.onlyEnabled': 'Hide disabled models; the model settings themselves are not changed.',
  'settings.help.models.filterModality': 'Show only models that accept attachments of this modality; Any clears the filter.',
  'settings.help.models.provider': 'Provider of the new model; part of its full provider/name id.',
  'settings.help.models.name': 'Model name as used by the provider, e.g. gpt-4o; full id is provider/name.',
  'settings.help.models.contextK': 'Context window in thousands of tokens, e.g. 128; empty means unknown.',
  'settings.help.models.priceIn': 'Input price per 1M tokens in the model currency; empty means not set.',
  'settings.help.models.priceOut': 'Output price per 1M tokens in the model currency; empty means not set.',
  'settings.help.agents.section.agents-default': 'Agent for new sessions without an explicit choice; the list shows primary agents only.',
  'settings.help.agents.section.agents-filter': 'Registry filter by agent class: all, primary, subagents, or system.',
  'settings.help.agents.section.agents-list': 'Agent registry: enabled state, classes, model, capabilities, and step limit.',
  'settings.help.agents.section.agents-form': 'Agent form: id, model, generation parameters, capabilities, icon, and color.',
  'settings.help.agents.section.agents-ssh-keys': 'SSH keys for agent git operations; private keys are encrypted at rest.',
  'settings.help.agents.id': 'Unique agent identifier (letters, digits, underscore); cannot change after creation.',
  'settings.help.agents.displayName': 'Agent name in the UI and @-mentions; may differ from the id.',
  'settings.help.agents.description': 'Short description of the agent role; shown in lists and helps pick an agent.',
  'settings.help.agents.agentMode': 'Agent classes: primary, subagent, and/or system; multiple choices are allowed.',
  'settings.help.agents.provider': 'Provider of the agent model; Default follows the session-level provider choice.',
  'settings.help.agents.model': 'Model from the selected provider; Default follows the session-level model choice.',
  'settings.help.agents.contextFile': 'Context file with instructions; Auto (by ID) looks the file up by agent id.',
  'settings.help.agents.temperature': 'Reply randomness from 0 to 2: lower is steadier, higher is more creative; not set — model default.',
  'settings.help.agents.topP': 'Nucleus sampling from 0 to 1; 0 means unset and uses the provider value.',
  'settings.help.agents.topK': 'Token selection limit, 0 means unset; not supported by every provider.',
  'settings.help.agents.reasoning': 'Reasoning level for supporting models; the list depends on the provider type.',
  'settings.help.agents.maxSteps': 'Maximum agent steps per turn; 0 means unlimited.',
  'settings.help.agents.capabilities': 'Tool groups available to the agent; clearing a group removes its tools.',
  'settings.help.agents.icon': 'Agent icon in lists and mentions; empty uses the default robot icon.',
  'settings.help.agents.color': 'Agent color used to highlight mentions; empty uses the default color.',
  'settings.help.agents.sshKeyName': 'Key name used to select it in git operations; must be unique.',
  'settings.help.agents.sshKeyPrivate': 'OpenSSH/PEM private key; when editing, an empty field keeps the current key.',
  'settings.help.agents.sshKeyPassphrase': 'Passphrase of the private key, if any; stored encrypted.',

  // --- Settings help: admin overview (stage 2) ---
  'settings.help.projects.section.projects-workspace': 'Default working directory for new sessions and projects without their own workspace; the path is created if needed.',
  'settings.help.projects.section.projects-workspace-policy': 'What happens when a project workspace points outside the allowed root: ask for confirmation or deny; managed mode always denies.',
  'settings.help.projects.section.projects-new': 'Project creation: the name is required and the working directory is provisioned automatically.',
  'settings.help.projects.workspacePath': 'Absolute path to the default directory; used for new sessions and projects without their own workspace.',
  'settings.help.projects.newProjectName': 'New project name in lists and the tree; it can be changed later.',
  'settings.help.users.section.users-new': 'Create or edit an account: login, contacts, roles, and access status.',
  'settings.help.users.username': 'Unique login used to sign in; cannot be edited after creation.',
  'settings.help.users.displayName': 'Name shown in the UI and lists; empty falls back to the login.',
  'settings.help.users.email': 'Contact email for notifications; optional, format user@example.com.',
  'settings.help.users.roles': 'Synth roles: ADMIN — full access, LEAD — oversight and events, USER — regular, AUDITOR — read-only; several are allowed.',
  'settings.help.users.active': 'Active users can sign in; a disabled account is kept but access is blocked.',
  'settings.help.users.notes': 'Administrator notes about the user; not added to the prompt or profile.',
  'settings.help.context.section.context-new-file': 'New context file: name, content, and category; it is added to the prompt of the selected category.',
  'settings.help.context.section.context-edit': 'Editor for the selected context file; changes take effect after saving.',
  'settings.help.context.fileName': 'File name with the .md extension, e.g. ABOUT.md; must be unique within the category.',
  'settings.help.context.content': 'Markdown file content; saved as is and added to the system context.',
  'settings.help.context.editContent': 'Markdown content of the selected file; changes take effect after saving.',
  'settings.help.defaults.section.defaults-theme-mode': 'Default theme and palette for new users and after a profile reset.',
  'settings.help.defaults.section.defaults-ui-scale': 'Default UI scale for mobile and desktop devices; users can change it.',
  'settings.help.defaults.section.defaults-language': 'Default interface language for new users.',
  'settings.help.defaults.section.defaults-chat-display': 'Default chat feed view and density; a user’s own choice always wins.',
  'settings.help.defaults.section.defaults-chat-scale': 'Default chat area scale for mobile and desktop devices; a user’s own choice wins.',
  'settings.help.defaults.chatViewMode': 'Detailed shows the agent reply in a bubble; feed renders it as flat prose.',
  'settings.help.defaults.chatDensity': 'Compact collapses previous turns into one summary line; the live turn always stays expanded.',
  'settings.help.defaults.chatScaleMobile': 'Chat area scale on phones and tablets, 75–150%; a 85% floor applies on the device.',
  'settings.help.defaults.chatScaleDesktop': 'Chat area scale on desktop, 75–150%; 100% by default.',
  'settings.help.defaults.theme': 'Default color palette; applied to new profiles and after a reset.',
  'settings.help.defaults.uiScaleMobile': 'UI scale on phones and tablets, 50–120%; 85% by default.',
  'settings.help.defaults.uiScaleDesktop': 'UI scale on desktop, 50–120%; 100% by default.',

  // --- Settings help: maintenance, metrics, debug (stage 2) ---
  'settings.help.maintenance.section.maintenance-status': 'What synth doctor checks and where instance data lives; rerun checks with the "Check" button.',
  'settings.help.maintenance.section.maintenance-restart': 'Restart interrupts active streams and only works under a supervisor; without one the instance stays down.',
  'settings.help.maintenance.section.maintenance-schema': 'Applying migrations changes data irreversibly — only a safety copy is created beforehand.',
  'settings.help.maintenance.section.maintenance-backups': 'What goes into the archive: secrets, project workspaces, and snapshot consistency on a live instance.',
  'settings.help.maintenance.section.maintenance-restore': 'The archive rolls data back to the snapshot and removes extra files; it applies on the next instance start.',
  'settings.help.maintenance.section.maintenance-audit': 'History of instance lifecycle operations with outcome and author; the journal can be cleared.',
  'settings.help.maintenance.backupSecrets': 'Include secrets/ (master key, SSH keys): the archive itself becomes a secret and must be protected.',
  'settings.help.maintenance.backupWorkspace': 'Include workspaces/ — project working directories; the archive grows noticeably.',
  'settings.help.maintenance.backupLive': 'Archive a running service without stopping it; the snapshot may be inconsistent.',
  'settings.help.maintenance.restoreArchive': 'Archive from the backups directory; encrypted archives are excluded — restore them via the CLI.',
  'settings.help.maintenance.restoreUpload': 'Upload a .tar.gz from disk; an uploaded file takes precedence over the selected one.',
  'settings.help.metrics.section.metrics-status': 'Current export mode, readiness, and storage state; refreshed automatically every 15 seconds.',
  'settings.help.metrics.section.metrics-export': 'Enabling /metrics takes effect after an instance restart; with the env source the toggle is locked.',
  'settings.help.metrics.section.metrics-token': 'Bearer token for scraping: stored in secrets/metrics-token and never shown after saving.',
  'settings.help.metrics.section.metrics-endpoints': 'The /metrics and /ready addresses for Prometheus and readiness checks; both can be copied.',
  'settings.help.metrics.section.metrics-hints': 'A ready-to-use Prometheus scrape_config with a 15-second interval and optional bearer token.',
  'settings.help.metrics.exportEnabled': 'Serve /metrics in Prometheus 0.0.4 format; disabled by default, requires a restart.',
  'settings.help.metrics.tokenValue': 'At least 16 characters; stored write-only in secrets/metrics-token, 409 when SYNTH_METRICS_TOKEN is set.',
  'settings.help.contextWindow.section.context-window-policy':
    'Instance-wide prompt size policy: off — no warnings, warn — UI warnings only, block — the server skips the model call. Applies immediately.',
  'settings.help.contextWindow.section.context-window-hints':
    'The window comes from the model catalog; when it is unknown, an estimate is used and blocking never applies.',
  'settings.help.memory.section.memory-status':
    'Provider of the memory plugin, its readiness and the counters of facts and indexes.',
  'settings.help.memory.section.memory-facts':
    'Facts remembered by the memory plugin: text, kind, status, confidence and provenance. The section only reads.',
  'settings.help.memory.section.memory-indexes':
    'Built corpora for retrieval: source, state, generation and the embedding fingerprint (model, dimension, chunker version).',
  'settings.help.memory.section.memory-graph':
    'Graph of the memory plugin: entities extracted from facts and the relations between them. Click an entity to rebuild the graph around it.',
  'settings.help.debug.section.debug-ai': 'Log levels for AI providers and models; includes every group except the service ones.',
  'settings.help.debug.section.debug-service': 'Instance service groups: routes, storage, WebSocket, and the debug output itself.',
  'settings.help.debug.levels': 'NONE — off, DEBUG — verbose, INFO — regular events, WARNING — problems, ERROR — errors only.',

  // --- Addons (ADR-086 §5, ADR-051/ADR-100) ---
  'addons.title': 'Addons',
  'addons.description':
    'Extension packages installed in this instance and the pipelines they bring. A package that grants capabilities waits for administrator approval: its agents, skills, MCP servers and pipelines appear in the instance only after the confirmation.',
  'addons.forbidden': 'Administrator rights are required to view this section.',
  'addons.packs.title': 'Extension packages',
  'addons.packs.description':
    'Installed packages: version, class, status and what the package delivered to the instance. Removing a package also removes the artifacts it delivered.',
  'addons.packs.count': '{count, plural, one {# package} other {# packages}}',
  'addons.packs.empty': 'No extension packages installed',
  'addons.packs.loadError': 'Failed to load extension packages: {error}',
  'addons.packs.status.active': 'active',
  'addons.packs.status.pending_approval': 'awaiting approval',
  'addons.packs.status.disabled': 'disabled',
  'addons.packs.pendingBadge': 'approval required',
  'addons.packs.pendingHint':
    '{count, plural, one {# package is} other {# packages are}} awaiting administrator approval',
  'addons.packs.approve': 'Approve installation',
  'addons.packs.approveConfirmTitle': 'Approve package installation',
  'addons.packs.approveConfirm':
    'Install the package "{name}": its agents, skills, MCP servers and pipelines will be added to the instance.',
  'addons.packs.approved': 'Package {name} approved and installed',
  'addons.packs.approveError': 'Failed to approve the package {name}: {error}',
  'addons.packs.remove': 'Remove',
  'addons.packs.removeConfirmTitle': 'Remove package',
  'addons.packs.removeConfirm':
    'Remove the package "{name}"? The agents, skills, MCP servers, pipelines and routing rules it delivered will be removed from the instance.',
  'addons.packs.removed': 'Package {name} removed',
  'addons.packs.removeError': 'Failed to remove the package {name}: {error}',
  'addons.packs.installedAt': 'Installed',
  'addons.packs.provides.agents': 'Agent roles',
  'addons.packs.provides.skills': 'Skills',
  'addons.packs.provides.mcp': 'MCP servers',
  'addons.packs.provides.pipelines': 'Pipelines',
  'addons.pipelines.title': 'Pipelines',
  'addons.pipelines.description':
    'Pipeline definitions are delivered by extension packages; runs are created by the router when a triggering event arrives.',
  'addons.pipelines.definitions': 'Definitions',
  'addons.pipelines.instances': 'Runs',
  'addons.pipelines.templates': 'Templates',
  'addons.pipelines.templatesEmpty': 'No system templates',
  'addons.pipelines.templatesError': 'Failed to load templates: {error}',
  'addons.templates.badge': 'system',
  'addons.templates.id': 'ID',
  'addons.templates.version': 'Version',
  'addons.pipelines.empty': 'No pipelines in this instance',
  'addons.pipelines.instancesEmpty': 'No pipeline runs',
  'addons.pipelines.loadError': 'Failed to load pipelines: {error}',
  'addons.pipelines.filter.pipeline': 'Pipeline',
  'addons.pipelines.filter.status': 'Status',
  'addons.pipelines.filter.all': 'All',
  'addons.pipelines.instanceStatus.pending': 'pending',
  'addons.pipelines.instanceStatus.running': 'running',
  'addons.pipelines.instanceStatus.waiting': 'waiting',
  'addons.pipelines.instanceStatus.done': 'completed',
  'addons.pipelines.instanceStatus.failed': 'failed',
  'addons.pipelines.instanceStatus.cancelled': 'cancelled',
  'addons.pipelines.currentStep': 'Current step',
  'addons.pipelines.steps': 'Steps',
  'addons.pipelines.attempts': 'Attempts',
  'addons.pipelines.createdAt': 'Created',
  'addons.pipelines.installedBy': 'Installed from package',
  'settings.help.addons.section.addons-packs':
    'Registry of packages installed in the instance. A package awaiting approval has not delivered its artifacts yet — approving installs them.',
  'settings.help.addons.section.addons-pipelines':
    'Pipeline definitions delivered by packages and their runs: status, current step and attempt count.',

  // --- Plugins (ADR-090, Ф6) ---
  'plugins.title': 'Plugins',
  'plugins.description':
    'Instance plugin layer: installed extensions with their trust level and scanner verdict, activation, installation from a source and layer policy.',
  'plugins.count': '{count, plural, one {# plugin} other {# plugins}}',
  'plugins.forbidden': 'Administrator rights are required to view this section.',
  'plugins.loadError': 'Failed to load plugins: {error}',
  'plugins.list.title': 'Installed plugins',
  'plugins.list.description':
    'Plugins from plugins.lock.json: version, execution mode, trust, scanner verdict and content hash. A plugin installed by deployment (image/PVC) is marked as managed — it cannot be removed through the API.',
  'plugins.list.empty': 'No plugins installed',
  'plugins.pendingBadge': 'awaiting approval',
  'plugins.pendingHint':
    'The bundle passed the scan with warnings and was quarantined: its artifacts appear in the instance only after approval. Only an administrator can approve it.',
  'plugins.approve': 'Approve installation',
  'plugins.approveConfirmTitle': 'Approve plugin installation',
  'plugins.approveConfirm':
    'Install the plugin "{name}" from quarantine? Integrity, trust and scanner verdict are re-checked before installation.',
  'plugins.approved': 'Plugin {name} approved and installed',
  'plugins.approveError': 'Failed to approve the plugin {name}: {error}',
  'plugins.enable': 'Enable',
  'plugins.disable': 'Disable',
  'plugins.enabled': 'Plugin {name} enabled',
  'plugins.disabled': 'Plugin {name} disabled',
  'plugins.enableError': 'Failed to enable the plugin {name}: {error}',
  'plugins.disableError': 'Failed to disable the plugin {name}: {error}',
  'plugins.remove': 'Remove',
  'plugins.removeConfirmTitle': 'Remove plugin',
  'plugins.removeConfirm':
    'Remove the plugin "{name}"? It will be deactivated and its lock entry and installation directory deleted.',
  'plugins.removed': 'Plugin {name} removed',
  'plugins.removeError': 'Failed to remove the plugin {name}: {error}',
  'plugins.update': 'Update',
  'plugins.updated': 'Plugin {name} updated: {from} → {to}',
  'plugins.upToDate': 'Plugin {name} is already up to date ({version})',
  'plugins.updateError': 'Failed to update the plugin {name}: {error}',
  'plugins.rollback': 'Roll back',
  'plugins.rollbackHint':
    'Roll back to the previous version (one step, reversible). If there is no previous step the server replies plugin.rollback_unavailable.',
  'plugins.rollbackConfirmTitle': 'Roll back plugin',
  'plugins.rollbackConfirm': 'Roll the plugin "{name}" back to the previous version?',
  'plugins.rolledBack': 'Plugin {name} rolled back: {from} → {to}',
  'plugins.rollbackError': 'Failed to roll back the plugin {name}: {error}',
  'plugins.rollbackUnavailable': 'plugin {name} has no previous version to roll back to',
  'plugins.source': 'Source',
  'plugins.contentHash': 'Content hash',
  'plugins.entry': 'Entry point',
  'plugins.installedAt': 'Installed',
  'plugins.updatedAt': 'Updated',
  'plugins.managedBadge': 'managed',
  'plugins.managedHint':
    'The plugin is delivered by deployment (image or PVC): it cannot be removed or reinstalled through the API — its version changes with the image (plugin.managed_readonly).',
  'plugins.serverPolicy.allowed': 'allowed by the server',
  'plugins.serverPolicy.denied': 'denied by the server',
  'plugins.serverPolicy.unverified': 'not verified by the server',
  'plugins.serverPolicy.hint':
    'The server did not confirm the policy (server unreachable or allowlist mode without a list): the local plugin runs in cooperative mode — in hybrid, client-side enforcement is not guaranteed (Level 1, ADR-090 F7).',
  'plugins.trustLabel': 'Plugin trust level',
  'plugins.scanLabel': 'Scanner verdict',
  'plugins.trust.builtin': 'built-in',
  'plugins.trust.verified': 'verified',
  'plugins.trust.trusted': 'trusted',
  'plugins.trust.community': 'community',
  'plugins.scanVerdict.safe': 'safe',
  'plugins.scanVerdict.caution': 'caution',
  'plugins.scanVerdict.dangerous': 'dangerous',
  'plugins.mode.inline': 'inline',
  'plugins.mode.remote': 'remote',
  'plugins.mode.both': 'both',
  'plugins.state.active': 'active',
  'plugins.state.inactive': 'disabled',
  'plugins.install.title': 'Installation',
  'plugins.install.description':
    'Source: a directory or archive on disk (standalone), an npm package, or an https archive with a mandatory sha256 pin. Installation is an explicit owner/ADMIN action.',
  'plugins.install.ref': 'Source',
  'plugins.install.refHint':
    'Directory path, .tgz/.tar.gz, npm package name (name or @scope/name), or an https archive URL. The source kind is inferred automatically.',
  'plugins.install.refPlaceholder': '/opt/plugins/my-plugin or @scope/plugin',
  'plugins.install.sha256': 'sha256 (for URL)',
  'plugins.install.sha256Hint':
    'Mandatory for an https archive: 64 hex characters. Not needed for local or npm sources.',
  'plugins.install.sha256Placeholder': '64 hex characters',
  'plugins.install.trust': 'Trust level',
  'plugins.install.trustHint':
    'Below the plugins.trustFloor threshold installation/activation is rejected. The builtin level is only issued by the image.',
  'plugins.install.managedHint':
    'In a managed instance local sources (directory or archive on disk) are unavailable — the server replies 403 LOCAL_INSTALL_DISABLED. Network sources (npm and https archive) are allowed.',
  'plugins.install.installing': 'Installing…',
  'plugins.install.submit': 'Install',
  'plugins.install.refRequired': 'Specify an installation source',
  'plugins.install.approvalRequired':
    'Plugin {name} was quarantined: installation awaits administrator approval',
  'plugins.installed': 'Plugin {name} {version} installed',
  'plugins.settings.title': 'Layer policy',
  'plugins.settings.description':
    'Key policies of the plugin layer. They apply at instance startup: a restart is required after saving (except filter and prompt block budgets).',
  'plugins.settings.loadError': 'Failed to load the plugin layer policy: {error}',
  'plugins.settings.saved': 'Plugin layer policy saved',
  'plugins.settings.saveError': 'Failed to save the plugin layer policy: {error}',
  'plugins.settings.restartRequired':
    'The policy takes effect after the instance restarts: the plugin runtime and host are assembled at startup.',
  'plugins.settings.reset': 'Reset',
  'plugins.settings.resetConfirmTitle': 'Reset plugin policy',
  'plugins.settings.resetConfirm':
    'Reset the plugin layer runtime settings to config.yaml values? Changes apply after a restart.',
  'plugins.settings.enabled': 'Plugin layer enabled',
  'plugins.settings.enabledHint': 'Master switch of the instance plugin layer.',
  'plugins.settings.executionEnabled': 'Plugin code execution',
  'plugins.settings.executionEnabledHint':
    'Main switch for executing plugin code. Disabled by default: plugins are installed but not activated.',
  'plugins.settings.runtimeInstall': 'Runtime installation',
  'plugins.settings.runtimeInstallHint':
    'Whether plugins may be installed through the API/UI (deny — only offline operator operations and the image).',
  'plugins.settings.runtimeInstall.allow': 'allow — permitted',
  'plugins.settings.runtimeInstall.deny': 'deny — forbidden',
  'plugins.settings.trustFloor': 'Trust floor',
  'plugins.settings.trustFloorHint':
    'Minimum trust level: a plugin below the floor is neither installed nor activated.',
  'plugins.settings.scan': 'Bundle scanning',
  'plugins.settings.scanHint':
    'Static scan before installation. Disabling the scan while execution is enabled is not allowed (fail-closed).',
  'plugins.settings.scan.enabled': 'enabled',
  'plugins.settings.scan.disabled': 'disabled',
  'plugins.settings.promptBlockMaxChars': 'Prompt block budget',
  'plugins.settings.promptBlockMaxCharsHint':
    'Character limit per system prompt block from a plugin (the host truncates blocks over budget).',
  'plugins.settings.llmFilterTimeoutMs': 'LLM filter timeout',
  'plugins.settings.llmFilterTimeoutMsHint':
    'Time budget for a single plugin filter call; after it expires the filter failMode applies.',
  'plugins.restart.confirmTitle': 'Restart instance',
  'plugins.restart.confirm':
    'Restart the instance to apply the plugin layer policy? Active requests will be interrupted.',
  'plugins.restart.button': 'Restart',
  'plugins.restart.started': 'Restart started',
  'plugins.restart.error': 'Failed to restart the instance: {error}',
  'plugins.audit.title': 'Plugin journal',
  'plugins.audit.description':
    'Journal of plugin actions: installs, activations, scans and the reasons for rejections (latest entries).',
  'plugins.audit.empty': 'The plugin journal is empty',
  'plugins.audit.refresh': 'Refresh',
  'plugins.audit.loadError': 'Failed to load the plugin journal: {error}',
  'plugins.audit.outcome.ok': 'succeeded',
  'plugins.audit.outcome.rejected': 'rejected',
  'settings.help.plugins.section.plugins-list':
    'Installed plugins: version, mode, trust, scanner verdict and content hash; actions — enable/disable, update, roll back, remove.',
  'settings.help.plugins.section.plugins-audit':
    'Journal of plugin actions — time, plugin, action, outcome and the rejection reason. Reading the journal does not change the plugin state.',
  'settings.help.plugins.section.plugins-install':
    'Install from a source. Local paths and archives are available in standalone only; an https archive requires a sha256 pin.',
  'settings.help.plugins.section.plugins-policy':
    'Plugin layer policy: execution, trust floor, scanning and budgets. Applies after the instance restarts.',

  // --- Пайплайны проекта (ADR-101, Э7) ---
  'pipelines.empty': 'No pipelines in the projects you have access to',
  'pipelines.emptyProject': 'No pipelines in this project',
  'pipelines.create': 'Create pipeline',
  'pipelines.createTitle': 'New pipeline',
  'pipelines.name': 'Name',
  'pipelines.namePlaceholder': 'Release pipeline',
  'pipelines.nameRequired': 'Name is required',
  'pipelines.description': 'Description',
  'pipelines.descriptionPlaceholder': 'What the pipeline does',
  'pipelines.created': 'Pipeline created',
  'pipelines.installedBy': 'from package {pack}',
  'pipelines.draftVersion': 'Draft {version}',
  'pipelines.publishedVersion': 'Published {version}',
  'pipelines.draftOnly': 'Not published',
  'pipelines.draft': 'Draft',
  'pipelines.published': 'Published version',
  'pipelines.notPublished': 'No published version yet',
  'pipelines.version': 'Version',
  'pipelines.mode': 'Mode',
  'pipelines.status.draft': 'draft',
  'pipelines.status.published': 'published',
  'pipelines.vars': 'Variables',
  'pipelines.nodes': '{count, plural, one {# step} other {# steps}}',
  'pipelines.exits': '{count, plural, one {# exit} other {# exits}}',
  'pipelines.node.human': 'human decision',
  'pipelines.node.target': 'Target',
  'pipelines.node.skill': 'Skill',
  'pipelines.node.timeout': 'Timeout',
  'pipelines.node.retry': 'Retries',
  'pipelines.node.input': 'Input',
  'pipelines.noDraft': 'No draft',
  'pipelines.viewStructure': 'Structure',
  'pipelines.viewJson': 'JSON',
  'pipelines.invalidJson': 'The specification is not valid JSON',
  'pipelines.saveDraft': 'Save draft',
  'pipelines.draftSaved': 'Draft saved',
  'pipelines.publish': 'Publish',
  'pipelines.publishDone': 'Version published',
  'pipelines.startRun': 'Start run',
  'pipelines.runStarted': 'Run started',
  'pipelines.runTitle': 'Run: {name}',
  'pipelines.delete': 'Delete pipeline',
  'pipelines.confirmDelete': 'Delete the pipeline and its versions? Runs are kept.',
  'pipelines.deleted': 'Pipeline deleted',
  'pipelines.runs': 'Runs',
  'pipelines.allStatuses': 'All statuses',
  'pipelines.noRuns': 'No runs yet',
  'pipelines.notFound': 'Pipeline not found',
  'pipelines.currentNode': 'Current step',
  'pipelines.startedAt': 'Started',
  'pipelines.finishedAt': 'Finished',
  'pipelines.duration': 'Duration',
  'pipelines.trigger': 'Trigger',
  'pipelines.awaitingHuman': 'The run is waiting for a human decision',
  'pipelines.commentPlaceholder': 'Comment (optional)',
  'pipelines.approve': 'Approve',
  'pipelines.reject': 'Reject',
  'pipelines.approved': 'Run approved',
  'pipelines.rejected': 'Run rejected',
  'pipelines.cancelRun': 'Cancel run',
  'pipelines.cancelled': 'Run cancelled',
  'pipelines.journal': 'Journal',
  'pipelines.emptyJournal': 'No events yet',
  'pipelines.loadMore': 'Show more',
  'pipelines.loadingMore': 'Loading…',
  'pipelines.loadOlderEvents': 'Load older events',
  'pipelines.loadingOlderEvents': 'Loading…',

  // --- Визуальный редактор пайплайнов (ADR-101, Э7.2) ---
  'pipelines.editor.viewVisual': 'Visual',
  'pipelines.editor.palette': 'Blocks',
  'pipelines.editor.inspector': 'Step settings',
  'pipelines.editor.noSelection': 'Select a step on the canvas to edit its fields',
  'pipelines.editor.emptyGraph': 'The pipeline has no steps yet',
  'pipelines.editor.exitsHint': 'Pipeline exits are edited in JSON mode',
  'pipelines.editor.addStep': 'Add step',
  'pipelines.editor.removeStep': 'Delete step',
  'pipelines.editor.moveUp': 'Move up',
  'pipelines.editor.moveDown': 'Move down',
  'pipelines.editor.transitions': 'Transitions',
  'pipelines.editor.transitionsEmpty': 'No transitions — the run continues to the next step',
  'pipelines.editor.transition.add': 'Add transition',
  'pipelines.editor.transition.path': 'Path',
  'pipelines.editor.transition.op': 'Condition',
  'pipelines.editor.transition.value': 'Value',
  'pipelines.editor.transition.target': 'Target step',
  'pipelines.editor.transition.remove': 'Delete transition',
  'pipelines.editor.op.eq': 'equals',
  'pipelines.editor.op.ne': 'not equals',
  'pipelines.editor.op.in': 'is in list',
  'pipelines.editor.op.exists': 'exists',
  'pipelines.editor.op.gt': 'greater than',
  'pipelines.editor.op.lt': 'less than',
  'pipelines.editor.kind.agent': 'Agent step',
  'pipelines.editor.kind.script': 'Script step',
  'pipelines.editor.kind.tool': 'Tool step',
  'pipelines.editor.kind.human': 'Human step',
  'pipelines.editor.field.title': 'Title',
  'pipelines.editor.field.agent': 'Agent',
  'pipelines.editor.field.skill': 'Skill',
  'pipelines.editor.field.prompt': 'Prompt',
  'pipelines.editor.field.command': 'Command',
  'pipelines.editor.field.args': 'Arguments',
  'pipelines.editor.field.tool': 'Tool',
  'pipelines.editor.field.toolArgs': 'Tool arguments (JSON)',
  'pipelines.editor.field.timeout': 'Timeout, sec',
  'pipelines.editor.field.retryMax': 'Retries',
  'pipelines.editor.field.retryBackoff': 'Backoff, sec',
  'pipelines.editor.field.input': 'Input paths',
  'pipelines.validate': 'Validate',
  'pipelines.validateOk': 'The specification is valid',
  'pipelines.validateFailed': 'The specification has problems — fix them before saving',
  'pipelines.problems': 'Problems',
  'pipelines.saveBlocked': 'The specification is invalid — it was not sent',

  // --- PWA ---
  'pwa.updateAvailable': 'A new app version is available',
  'pwa.updateNow': 'Update',
  'pwa.updateLater': 'Later',

  // --- Authority (ADR-106 §11) — read-only раздел «Полномочия» ---
  'authority.title': 'Authority',
  'authority.description':
    'Full authorities of users and agents: instance policy, roles with grants and agent bindings. The section is read-only.',
  'authority.mode.title': 'Layer mode',
  'authority.mode.description':
    'The Authority layer narrows the decision of the permission layer: deny and ask stay stronger than allow.',
  'authority.mode.current': 'Current mode',
  'authority.mode.unknown': 'Not exposed by the API — set in the instance config',
  'authority.mode.states': 'Possible states',
  'authority.mode.state.enforced': 'Enforcement',
  'authority.mode.state.enforcedHint':
    'Enabled without shadow — deny and ask narrow the permission-layer decision',
  'authority.mode.state.shadow': 'Log only',
  'authority.mode.state.shadowHint':
    'Enabled with shadow — the decision is counted and logged, but not applied',
  'authority.mode.state.disabled': 'Disabled',
  'authority.mode.state.disabledHint':
    'Disabled by default — the layer makes no decisions and does not write to the journal',
  'authority.mode.configHint':
    'Config keys: synth.authority.enabled and synth.authority.shadow — see docs/AUTHORITY.md §4',
  'authority.policy.title': 'Instance policy',
  'authority.policy.description':
    'The instance policy is the upper bound of all authority axes; a package never grants rights to itself.',
  'authority.policy.stub':
    'The instance policy (roles and instance ceiling) is available only through the config and the data directory — the API does not return it. Below is the composition contributed by the installed packages.',
  'authority.policy.roles': 'Roles',
  'authority.policy.actions': 'Actions',
  'authority.policy.targets': 'Targets',
  'authority.policy.agents': 'Agents',
  'authority.policy.grants': 'Grants',
  'authority.policy.mutating': 'mutating',
  'authority.roles.title': 'Roles and grants',
  'authority.roles.description':
    'A grant is an "action × target" with an effect: allow, ask or deny. The source of a grant is shown next to it.',
  'authority.roles.empty': 'No packages with authority content are installed',
  'authority.roles.domain': 'Domain',
  'authority.roles.grantsCount': '{count, plural, one {# grant} other {# grants}}',
  'authority.roles.noGrants': 'The package content declares no grants for this role',
  'authority.roles.sourcePack': 'package',
  'authority.effect.allow': 'Allow',
  'authority.effect.ask': 'Ask',
  'authority.effect.deny': 'Deny',
  'authority.pack.status.active': 'active',
  'authority.pack.status.pending_approval': 'awaiting approval',
  'authority.pack.status.disabled': 'disabled',
  'authority.agents.title': 'Agent bindings',
  'authority.agents.description':
    'Roles carried by an agent and its ceiling — the actions the agent may not exceed.',
  'authority.agents.empty': 'No agent bindings',
  'authority.agents.roles': 'Roles',
  'authority.agents.ceiling': 'Ceiling',
  'authority.agents.source': 'Source',
  'authority.loadError': 'Failed to load authority data: {error}',
  'authority.forbidden': 'Reading the package registry requires administrator rights',
  // ADR-114: инвентарь git-worktree'ов (per-session рабочий каталог).
  'worktrees.title': 'Worktrees',
  'worktrees.description': 'Secondary working copies of the repository — a session can work in its own directory.',
  'worktrees.loading': 'Loading worktrees...',
  'worktrees.empty': 'No worktrees',
  'worktrees.emptyHint': 'Create a worktree to give the session its own working copy of the repository.',
  'worktrees.loadError': 'Failed to load worktrees: {error}',
  'worktrees.create': 'Create',
  'worktrees.createTitle': 'New worktree',
  'worktrees.form.branch': 'Branch',
  'worktrees.form.branchPlaceholder': 'feature/my-branch',
  'worktrees.form.name': 'Directory name',
  'worktrees.form.namePlaceholder': 'my-branch',
  'worktrees.form.hint': 'Leave the fields empty — the server picks the branch and the directory name.',
  'worktrees.created': 'Worktree created',
  'worktrees.createError': 'Failed to create worktree: {error}',
  'worktrees.action.attach': 'Attach',
  'worktrees.action.detach': 'Detach',
  'worktrees.action.remove': 'Delete',
  'worktrees.action.prune': 'Clean up',
  'worktrees.badge.dirty': 'changes',
  'worktrees.badge.attached': 'attached',
  'worktrees.badge.missing': 'missing',
  'worktrees.row.branch': 'Branch: {branch}',
  'worktrees.row.session': 'Session: {name}',
  'worktrees.removed': 'Worktree deleted',
  'worktrees.removeError': 'Failed to delete worktree: {error}',
  'worktrees.pruned': 'Cleaned up: {count} stale records removed',
  'worktrees.pruneError': 'Failed to clean up worktrees: {error}',
  'worktrees.confirm.removeTitle': 'Delete worktree',
  'worktrees.confirm.removeMessage': 'Delete the worktree "{name}"? Its directory and branch will be removed.',
  'worktrees.confirm.forceTitle': 'Delete worktree with uncommitted changes',
  'worktrees.confirm.forceMessage': 'The worktree "{name}" has uncommitted changes; deleting it will remove them together with the directory.',
  'worktrees.confirm.pruneTitle': 'Clean up worktrees',
  'worktrees.confirm.pruneMessage': 'Remove the records whose directory no longer exists and run git worktree prune?',
  'worktrees.session.title': 'Working directory',
  'worktrees.session.hint': 'The worktree directory is used as the working directory of the session.',
  'worktrees.session.projectDir': 'Project directory',
  'worktrees.session.empty': 'The project has no worktrees',
  'worktrees.session.bound': 'Worktree: {name}',
  'worktrees.session.bindError': 'Failed to change the working directory: {error}',
  'worktrees.header.badge': 'worktree: {name} · {branch}',
  'worktrees.header.badgeTitle': 'Open the worktree inventory of the project',
};
